"use strict";

var $ = jQuery.noConflict();
jQuery(document).ready(function ($) {
  /* Offset position for Header logos */
  function offsetPosition() {
    var offsetLeft = $('[data-js="header-logos"]').offset();
    if (offsetLeft) {
      $('html').css('--offset-left', `${offsetLeft.left}px`);
    }
  }
  offsetPosition();
  $(window).resize(offsetPosition);

  /* Smooth scroll for anchor links */
  $('.u-button[href^="#"]').on('click', function (e) {
    var target = $($(this).attr('href'));
    if (target.length) {
      e.preventDefault();
      var headerHeight = $('.m-header').outerHeight() || 0;
      $('html, body').animate({
        scrollTop: target.offset().top - headerHeight
      }, 500);
    }
  });

  /* Tippy */
  var mobileClickHandlerActive = false;
  function initTippy() {
    if (typeof tippy === 'undefined') return;
    var primaryTouch = window.matchMedia('(pointer: coarse)').matches;
    var noHover = window.matchMedia('(hover: none)').matches;
    var smallScreen = window.matchMedia('(max-width: 1024px)').matches;
    var isMobile = primaryTouch || noHover || smallScreen;

    // Destroy existing instances
    $('[data-tippy-content]').each(function () {
      if (this._tippy) {
        this._tippy.destroy();
      }
    });

    // Initialize tooltips
    tippy('[data-tippy-content]:not([data-tooltip="point"]):not([data-tooltip="consent"])', {
      allowHTML: true,
      theme: 'light',
      animation: 'shift-away',
      zIndex: 100,
      trigger: isMobile ? 'click' : 'mouseenter focus',
      touch: true,
      hideOnClick: true,
      interactive: true,
      appendTo: document.body
    });
    tippy('[data-tooltip="point"][data-tippy-content]', {
      allowHTML: true,
      theme: 'point',
      animation: 'shift-away',
      placement: 'top-start',
      arrow: false,
      maxWidth: 285,
      zIndex: 100,
      trigger: isMobile ? 'click' : 'mouseenter focus',
      touch: true,
      hideOnClick: true,
      interactive: true,
      appendTo: document.body
    });
    tippy('[data-tooltip="consent"][data-tippy-content]', {
      allowHTML: true,
      theme: 'light',
      animation: 'shift-away',
      maxWidth: 285,
      zIndex: 999999,
      trigger: isMobile ? 'click' : 'mouseenter focus',
      touch: true,
      hideOnClick: true,
      interactive: true,
      appendTo: document.body
    });

    // Setup mobile click handlers
    // setupMobileHandlers(isMobile);
  }
  function setupMobileHandlers(isMobile) {
    // Remove old handlers
    $(document).off('click.tippy-mobile touchend.tippy-mobile');
    if (isMobile && !mobileClickHandlerActive) {
      mobileClickHandlerActive = true;

      // Use both click and touchend for better tablet compatibility
      var eventName = 'click.tippy-mobile touchend.tippy-mobile';
      $(document).on(eventName, '[data-tippy-content]', function (e) {
        var element = this;
        var tippyInstance = element._tippy;
        if (!tippyInstance) return;

        // Exception: favorite compare button in header should work as normal link on mobile
        if ($(element).is('[data-js="favorite-compare-button"]')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var isVisible = tippyInstance.state.isVisible;
        if (isVisible) {
          tippyInstance.hide();
          return;
        }
        $('[data-tippy-content]').each(function () {
          if (this._tippy && this !== element) {
            this._tippy.hide();
          }
        });
        tippyInstance.show();
      });
      $(document).on(eventName, function (e) {
        if (!$(e.target).closest('[data-tippy-content]').length && !$(e.target).closest('.tippy-box').length) {
          $('[data-tippy-content]').each(function () {
            if (this._tippy) {
              this._tippy.hide();
            }
          });
        }
      });
    } else if (!isMobile && mobileClickHandlerActive) {
      mobileClickHandlerActive = false;
      $(document).off('click.tippy-mobile touchend.tippy-mobile');
    }
  }

  // Initial setup
  initTippy();

  // Listen for resize and orientation changes
  var resizeTimeout;
  $(window).on('resize orientationchange', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      initTippy();
    }, 250);
  });

  /* Fancybox */
  Fancybox.bind(document, "[data-fancybox]", {
    Html5Video: {
      autoplay: true,
      controls: true
    },
    Youtube: {
      autoplay: 1,
      nocookie: false
    },
    Iframe: {
      preload: false
    },
    Hash: false,
    l10n: novisaData.i18n.fancybox
  });

  /* Plyr */
  if (typeof Plyr !== 'undefined') {
    const elements = document.querySelectorAll('.js-player');
    if (elements.length > 0) {
      const players = Plyr.setup(elements, {
        controls: ['play', 'progress', 'current-time', 'duration', 'mute', 'volume']
      });
      players.forEach((player, index) => {
        player.on('play', () => {
          players.forEach((otherPlayer, otherIndex) => {
            if (index !== otherIndex) {
              otherPlayer.pause();
            }
          });
        });
      });
    }
  }
});

/**
 * Global Tippy Reinitialize Function
 * Destroys and reinitializes Tippy tooltips within a given container
 * 
 * @param {string|jQuery|HTMLElement} container - Container selector, jQuery object, or DOM element. If not provided, works on entire document.
 */
function reinitializeTippy(container) {
  var $container;
  var mediaQuery = window.matchMedia('(max-width: 1024px)');
  var isMobile = mediaQuery.matches;

  // Handle different container types
  if (!container) {
    $container = jQuery(document);
  } else if (typeof container === 'string') {
    $container = jQuery(container);
  } else if (container instanceof jQuery) {
    $container = container;
  } else {
    $container = jQuery(container);
  }
  if (!$container.length || typeof tippy === 'undefined') {
    return;
  }

  // Destroy existing Tippy instances
  $container.find('[data-tippy-content]').each(function () {
    if (this._tippy) {
      this._tippy.destroy();
    }
  });

  // Reinitialize regular tooltips
  var regularTooltips = $container.find('[data-tippy-content]:not([data-tooltip="point"])');
  if (regularTooltips.length) {
    tippy(regularTooltips.toArray(), {
      allowHTML: true,
      theme: 'light',
      animation: 'shift-away',
      zIndex: 100,
      trigger: isMobile ? 'click' : 'mouseenter focus',
      touch: true,
      hideOnClick: true,
      interactive: true,
      appendTo: document.body
    });
  }

  // Reinitialize point tooltips
  var pointTooltips = $container.find('[data-tooltip="point"][data-tippy-content]');
  if (pointTooltips.length) {
    tippy(pointTooltips.toArray(), {
      allowHTML: true,
      theme: 'point',
      animation: 'shift-away',
      placement: 'top-start',
      arrow: false,
      maxWidth: 285,
      zIndex: 100,
      trigger: isMobile ? 'click' : 'mouseenter focus',
      touch: true,
      hideOnClick: true,
      interactive: true,
      appendTo: document.body
    });
  }
}
jQuery(document).ready(function ($) {
  $('[data-js="accordion"]').each(function () {
    var $accordion = $(this);
    $accordion.find('[data-js="accordion-header"]').on('click', function (e) {
      e.preventDefault();
      var $header = $(this);
      var dataId = $header.data('id');
      var $content = $accordion.find('[data-js="accordion-content"][data-id="' + dataId + '"]');
      var isActive = $header.hasClass('is-active');
      $accordion.find('[data-js="accordion-header"]').not($header).removeClass('is-active');
      $accordion.find('[data-js="accordion-content"]').not($content).slideUp(250).removeClass('is-active');
      if (isActive) {
        $content.slideUp(250, function () {
          $header.removeClass('is-active');
          $content.removeClass('is-active');
        });
      } else {
        $content.slideDown(250, function () {
          $header.addClass('is-active');
          $content.addClass('is-active');
        });
      }
    });
  });
});
jQuery(document).ready(function ($) {
  $('[data-modal-type="career"]').on('click', function () {
    var $modal = $('[data-modal-title="' + $(this).attr('data-modal-title') + '"]');
    var jobName = $(this).data('job-name');
    var jobCities = $(this).data('job-cities');
    $modal.find('input[type="hidden"][value="{job}"]').attr('value', jobName + ' - ' + jobCities);
  });
});
// Safe clipboard write
function safeCopyToClipboard(text) {
  return new Promise(resolve => {
    function tryCopy() {
      if (document.hasFocus()) {
        navigator.clipboard.writeText(text).then(resolve);
      } else {
        setTimeout(tryCopy, 50);
      }
    }
    tryCopy();
  });
}
(() => {
  const elements = document.querySelectorAll('[data-js="copy"]');
  if (!elements.length) return;
  elements.forEach(element => {
    element.addEventListener('click', () => {
      const value = element.getAttribute('data-value');
      const message = element.getAttribute('data-message') || 'Copied!';
      safeCopyToClipboard(value).then(() => {
        const messageClass = 'copy-message';
        document.querySelectorAll(`.${messageClass}`).forEach(oldMsg => oldMsg.remove());
        element.insertAdjacentHTML('afterend', `<p class="${messageClass}">${message}</p>`);
        element.classList.add('is-copied');
        setTimeout(() => element.classList.remove('is-copied'), 3000);
      });
    });
  });
})();
(() => {
  const buttons = document.querySelectorAll('[data-js="copy-link"]');
  if (!buttons.length) return;
  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const value = btn.getAttribute('data-value');
      const labelDefault = btn.getAttribute('data-label-default');
      const labelSuccess = btn.getAttribute('data-label-success');
      safeCopyToClipboard(value).then(() => {
        const labelSpan = btn.querySelector('span.text-xs');
        if (labelSpan) labelSpan.textContent = labelSuccess;
        btn.classList.add('is-copied');
        setTimeout(() => {
          btn.classList.remove('is-copied');
          if (labelSpan) labelSpan.textContent = labelDefault;
        }, 2500);
      });
    });
  });
})();
jQuery(document).ready(function ($) {
  // Track investment view on single investment page
  if (typeof novisaData !== 'undefined' && novisaData.investment_id) {
    var investmentId = novisaData.investment_id;
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'novisa_increment_investment_view',
        post_id: investmentId
      },
      success: function (response) {
        if (response.success) {}
      },
      error: function (xhr, status, error) {
        console.error('Error counting investment view:', error);
      }
    });
  }

  // Track property view when modal is opened
  $(document).on('propertyModalOpened', function (e, voxId) {
    if (!voxId) {
      return;
    }
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'novisa_increment_property_view',
        vox_id: voxId
      },
      success: function (response) {
        if (response.success) {}
      },
      error: function (xhr, status, error) {
        console.error('Error counting property view:', error);
      }
    });
  });

  // Track property favorite when added to favorites
  $(document).on('favoritePropertyAdded', function (e, voxId) {
    if (!voxId) {
      return;
    }
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'novisa_increment_property_favorite',
        vox_id: voxId
      },
      success: function (response) {
        if (response.success) {}
      },
      error: function (xhr, status, error) {
        console.error('Error counting property favorite:', error);
      }
    });
  });
});
jQuery(document).ready(function ($) {
  // Button
  $(document).on('click', '[data-js="favorite-button"]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var property = $(this).data('property');
    var favorite = Cookies.get('novisa_favorite_properties');
    if (favorite) {
      favorite = JSON.parse(favorite);
    } else {
      favorite = [];
    }
    var wasRemoved = false;
    var wasAdded = false;
    if (favorite.includes(property)) {
      favorite.splice(favorite.indexOf(property), 1);
      wasRemoved = true;
    } else {
      favorite.push(property);
      wasAdded = true;
    }
    Cookies.set('novisa_favorite_properties', JSON.stringify(favorite), {
      expires: 365
    });
    $('[data-js="favorite-button"][data-property="' + property + '"]').toggleClass('is-active');
    favoritePropertiesUpdateCounter();

    // Trigger custom events for synchronization
    $(document).trigger('favoritePropertyChanged');
    if (wasRemoved) {
      $(document).trigger('favoritePropertyRemoved', [property]);
    } else if (wasAdded) {
      $(document).trigger('favoritePropertyAdded', [property]);

      // Display favorite button message
      $('[data-js="favorite-compare-button"]').addClass('has-message');
      $('[data-js="favorite-compare-button"]').removeAttr('data-tippy-content');

      // Destroy Tippy instance to prevent tooltip from appearing
      var compareButton = $('[data-js="favorite-compare-button"]')[0];
      if (compareButton && compareButton._tippy) {
        compareButton._tippy.destroy();
      }

      // Hide message
      setTimeout(function () {
        $('[data-js="favorite-compare-button"]').removeClass('has-message');

        // Reinitialize Tippy after hiding message
        if (compareButton && typeof tippy !== 'undefined' && typeof novisaData !== 'undefined' && novisaData.i18n && novisaData.i18n.favoriteButton && novisaData.i18n.favoriteButton.compareTooltip) {
          var mediaQuery = window.matchMedia('(max-width: 1024px)');
          var isMobile = mediaQuery.matches;
          var tooltipText = novisaData.i18n.favoriteButton.compareTooltip;
          tippy(compareButton, {
            allowHTML: true,
            theme: 'light',
            animation: 'shift-away',
            zIndex: 100,
            trigger: isMobile ? 'manual' : 'mouseenter focus',
            hideOnClick: true,
            interactive: true,
            content: tooltipText
          });

          // Restore data-tippy-content attribute
          compareButton.setAttribute('data-tippy-content', tooltipText);
        }
      }, 1500);
    }
  });
  favoritePropertiesActivateButtons();
  favoritePropertiesUpdateCounter();
});

// Activate buttons if property is in favorite
function favoritePropertiesActivateButtons() {
  $('[data-js="favorite-button"]').each(function () {
    var property = $(this).data('property');
    var favorite = Cookies.get('novisa_favorite_properties');
    if (favorite) {
      favorite = JSON.parse(favorite);
    } else {
      favorite = [];
    }
    if (favorite.includes(property)) {
      $(this).addClass('is-active');
    }
  });
}

// Update counter
function favoritePropertiesUpdateCounter() {
  var favorite = Cookies.get('novisa_favorite_properties');
  if (favorite) {
    favorite = JSON.parse(favorite);
  } else {
    favorite = [];
  }
  $('[data-js="favorite-button-counter"]').text(favorite.length).toggleClass('is-active', favorite.length > 0);
}
jQuery(document).ready(function ($) {
  // Initialize compare on page load if we're on compare page
  if ($('[data-js="favorite-compare-container"]').length) {
    loadCompareProperties();
    initDragToScroll();
  }

  /**
   * Initialize drag to scroll functionality for compare list
   */
  function initDragToScroll() {
    var $list = $('[data-js="favorite-compare-list"]');
    if (!$list.length) {
      return;
    }

    // Check if list has scrollbar
    function hasScrollbar() {
      return $list[0].scrollWidth > $list[0].clientWidth;
    }

    // Update info visibility based on scrollbar presence
    function updateInfoVisibility() {
      var $info = $('[data-js="favorite-compare-info"]');
      if (hasScrollbar()) {
        $info.css('display', 'flex');
      } else {
        $info.hide();
      }
    }

    // Update cursor based on scrollbar presence
    function updateCursor() {
      if (hasScrollbar()) {
        $list.css('cursor', 'grab');
      } else {
        $list.css('cursor', 'default');
      }
    }

    // Initial setup
    updateCursor();
    updateInfoVisibility();
    var isDown = false;
    var startX;
    var scrollLeft;
    $list.on('mousedown', function (e) {
      // Only enable drag if there's a scrollbar
      if (!hasScrollbar()) {
        return;
      }

      // Don't interfere with button clicks
      if ($(e.target).closest('button, a, [data-js="favorite-compare-remove"]').length) {
        return;
      }
      isDown = true;
      $list.addClass('is-dragging');
      $list.css('cursor', 'grabbing');
      startX = e.pageX - $list.offset().left;
      scrollLeft = $list.scrollLeft();

      // Prevent text selection while dragging
      e.preventDefault();
    });
    $list.on('mouseleave mouseup', function () {
      isDown = false;
      $list.removeClass('is-dragging');
      updateCursor();
    });
    $list.on('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - $list.offset().left;
      var walk = (x - startX) * 2; // Scroll speed multiplier
      $list.scrollLeft(scrollLeft - walk);
    });

    // Update cursor on window resize
    $(window).on('resize', function () {
      updateCursor();
      updateInfoVisibility();
    });
  }

  // Listen for remove button clicks (delegated event)
  $(document).on('click', '[data-js="favorite-compare-remove"]', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var $column = $(this).closest('.u-compare__list-column');
    var voxId = $column.data('vox-id');
    if (!voxId) {
      return;
    }

    // Remove from favorites cookie
    var favorite = Cookies.get('novisa_favorite_properties');
    if (favorite) {
      favorite = JSON.parse(favorite);
      var index = favorite.indexOf(voxId);
      if (index > -1) {
        favorite.splice(index, 1);
        Cookies.set('novisa_favorite_properties', JSON.stringify(favorite), {
          expires: 365
        });
      }
    }

    // Update counter
    if (typeof favoritePropertiesUpdateCounter === 'function') {
      favoritePropertiesUpdateCounter();
    }

    // Update favorite buttons state
    if (typeof favoritePropertiesActivateButtons === 'function') {
      favoritePropertiesActivateButtons();
    }

    // Trigger custom event to synchronize with other modules
    // The event listener below will handle the actual removal
    $(document).trigger('favoritePropertyRemoved', [voxId]);
  });

  /**
   * Remove compare column with animation
   * @param {string} voxId - Property vox_id to remove
   */
  function removeCompareColumn(voxId) {
    var $column = $('[data-js="favorite-compare-list"] .u-compare__list-column[data-vox-id="' + voxId + '"]');
    if (!$column.length) {
      return;
    }
    $column.fadeOut(300, function () {
      $(this).remove();

      // Check if there are any properties left
      var $list = $('[data-js="favorite-compare-list"]');
      var remainingColumns = $list.find('.u-compare__list-column:not(.is-labels)').length;

      // If no properties left, show empty state
      if (remainingColumns === 0) {
        showEmptyState();
      } else {
        // Update cursor after removing column
        updateDragScrollCursor();
      }
    });
  }

  // Listen for property removal from other modules (e.g., favorite list)
  $(document).on('favoritePropertyRemoved', function (e, voxId) {
    // Only proceed if compare container exists on this page
    if (!$('[data-js="favorite-compare-container"]').length) {
      return;
    }

    // Remove the column for this property
    removeCompareColumn(voxId);
  });

  // Listen for property addition from other modules (e.g., favorite button in related properties)
  $(document).on('favoritePropertyAdded', function (e, voxId) {
    // Only proceed if compare container exists on this page
    if (!$('[data-js="favorite-compare-container"]').length) {
      return;
    }

    // Reload entire compare to include the new property
    loadCompareProperties();
  });

  /**
   * Load compare properties from cookie via AJAX
   */
  function loadCompareProperties() {
    var favorite = Cookies.get('novisa_favorite_properties');
    var voxIds = [];
    if (favorite) {
      try {
        voxIds = JSON.parse(favorite);
      } catch (e) {
        console.error('Error parsing favorite properties cookie:', e);
        voxIds = [];
      }
    }

    // Show loading state
    showLoadingState();

    // If no properties, get empty state from server
    if (!voxIds || voxIds.length === 0) {
      voxIds = [];
    }

    // Make AJAX request
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'load_favorite_compare',
        'vox_ids[]': voxIds
      },
      success: function (response) {
        if (response.success && response.data.html) {
          renderCompareHTML(response.data.html);
        } else {
          console.error('Error loading properties:', response.data ? response.data.message : 'Unknown error');
          showErrorState();
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX error:', error);
        showErrorState();
      }
    });
  }

  /**
   * Render compare HTML from server
   */
  function renderCompareHTML(html) {
    var $container = $('[data-js="favorite-compare-container"]');
    var $list = $('[data-js="favorite-compare-list"]');
    var $form = $('[data-js="favorite-compare-form"]');
    if (!$container.length) {
      return;
    }

    // Check if HTML contains message state (no table structure)
    if (html.indexOf('data-js="favorite-compare-empty"') !== -1 || html.indexOf('data-js="favorite-compare-loading"') !== -1 || html.indexOf('data-js="favorite-compare-error"') !== -1) {
      // Hide table, note, form and show message
      $list.hide();
      $form.hide();
      $container.find('.u-compare__loading, .u-compare__empty, .u-compare__error').remove();
      $container.append(html);
    } else {
      // Show table, note, form and render properties
      $list.show();
      $form.show();
      $container.find('.u-compare__loading, .u-compare__empty, .u-compare__error').remove();
      $list.find('.u-compare__list-column:not(.is-labels)').remove();
      $list.append(html);

      // Update cursor after content change
      updateDragScrollCursor();
    }
  }

  /**
   * Update drag scroll cursor based on scrollbar presence
   */
  function updateDragScrollCursor() {
    var $list = $('[data-js="favorite-compare-list"]');
    var $info = $('[data-js="favorite-compare-info"]');
    if (!$list.length) {
      return;
    }
    setTimeout(function () {
      var hasScroll = $list[0].scrollWidth > $list[0].clientWidth;
      if (hasScroll) {
        $list.css('cursor', 'grab');
      } else {
        $list.css('cursor', 'default');
      }
      if (hasScroll) {
        $info.show();
      } else {
        $info.hide();
      }
    }, 50);
  }

  /**
   * Show loading state (outside table structure)
   */
  function showLoadingState() {
    var $container = $('[data-js="favorite-compare-container"]');
    var $list = $('[data-js="favorite-compare-list"]');
    var $form = $('[data-js="favorite-compare-form"]');
    if (!$container.length) {
      return;
    }

    // Hide table, note and form
    $list.hide();
    $form.hide();

    // Remove existing messages
    $container.find('.u-compare__loading, .u-compare__empty, .u-compare__error').remove();

    // Get translated text
    var loadingText = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.compare ? window.novisaData.i18n.compare.loading : 'Ładowanie...';

    // Add loading message outside table
    var $loadingState = $('<div class="u-compare__loading" data-js="favorite-compare-loading">' + '<p class="text-lg">' + loadingText + '</p>' + '</div>');
    $container.append($loadingState);
  }

  /**
   * Show empty state (outside table structure)
   */
  function showEmptyState() {
    var $container = $('[data-js="favorite-compare-container"]');
    var $list = $('[data-js="favorite-compare-list"]');
    var $form = $('[data-js="favorite-compare-form"]');
    if (!$container.length) {
      return;
    }

    // Hide table, note and form
    $list.hide();
    $form.hide();

    // Remove existing messages
    $container.find('.u-compare__loading, .u-compare__empty, .u-compare__error').remove();

    // Get translated texts
    var emptyTitle = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.compare ? window.novisaData.i18n.compare.empty_title : 'Brak lokali do porównania.';
    var emptySubtitle = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.compare ? window.novisaData.i18n.compare.empty_subtitle : 'Dodaj lokale do ulubionych, aby je porównać.';

    // Add empty message outside table
    var $emptyState = $('<div class="u-compare__empty" data-js="favorite-compare-empty">' + '<p class="text-lg">' + emptyTitle + '</p>' + '<p class="text-sm">' + emptySubtitle + '</p>' + '</div>');
    $container.append($emptyState);
  }

  /**
   * Show error state (outside table structure)
   */
  function showErrorState() {
    var $container = $('[data-js="favorite-compare-container"]');
    var $list = $('[data-js="favorite-compare-list"]');
    var $form = $('[data-js="favorite-compare-form"]');
    if (!$container.length) {
      return;
    }

    // Hide table, note and form
    $list.hide();
    $form.hide();

    // Remove existing messages
    $container.find('.u-compare__loading, .u-compare__empty, .u-compare__error').remove();

    // Get translated texts
    var errorTitle = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.compare ? window.novisaData.i18n.compare.error_title : 'Wystąpił błąd podczas ładowania.';
    var errorSubtitle = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.compare ? window.novisaData.i18n.compare.error_subtitle : 'Spróbuj odświeżyć stronę.';

    // Add error message outside table
    var $errorState = $('<div class="u-compare__error" data-js="favorite-compare-error">' + '<p class="text-lg">' + errorTitle + '</p>' + '<p class="text-sm">' + errorSubtitle + '</p>' + '</div>');
    $container.append($errorState);
  }
});
jQuery(document).ready(function ($) {
  // Initialize favorite list if container exists
  if ($('[data-js="favorite-list-container"]').length) {
    loadFavoriteList();
  }

  /**
   * Load favorite properties list from cookie via AJAX
   */
  function loadFavoriteList() {
    var favorite = Cookies.get('novisa_favorite_properties');
    var voxIds = [];
    if (favorite) {
      try {
        voxIds = JSON.parse(favorite);
      } catch (e) {
        console.error('Error parsing favorite properties cookie:', e);
        voxIds = [];
      }
    }

    // Show loading state
    showLoadingState();

    // If no properties, get empty state from server
    if (!voxIds || voxIds.length === 0) {
      voxIds = [];
    }

    // Make AJAX request
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'load_favorite_list',
        'vox_ids[]': voxIds // Correctly serializes array for PHP
      },
      success: function (response) {
        if (response.success && response.data.html) {
          renderTableHTML(response.data.html, response.data.is_empty);
        } else {
          console.error('Error loading properties:', response.data ? response.data.message : 'Unknown error');
          showErrorState();
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX error:', error);
        showErrorState();
      }
    });
  }

  /**
   * Render table HTML from server
   */
  function renderTableHTML(html, isEmptyOrError) {
    var $container = $('[data-js="favorite-list-container"]');
    if (!$container.length) {
      return;
    }

    // Clear container
    $container.empty();

    // Append HTML (either table or message)
    $container.append(html);

    // If it's a table (not empty/error state), initialize interactions
    if (!isEmptyOrError) {
      initializeTableInteractions();
    }
  }

  /**
   * Initialize tooltips and favorite buttons for table content
   * Uses global helper from _table.js (reinitializes all tables in DOM)
   */
  function initializeTableInteractions() {
    if (typeof tableReinitialize === 'function') {
      tableReinitialize();
    }
  }

  /**
   * Show loading state
   */
  function showLoadingState() {
    var $container = $('[data-js="favorite-list-container"]');
    if (!$container.length) {
      return;
    }
    var i18n = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.favoriteList ? window.novisaData.i18n.favoriteList : {};
    var loadingText = i18n.loading || 'Ładowanie...';
    var loadingHTML = '<div class="u-properties-table__loading" data-js="favorite-list-loading">' + '<p class="text-lg">' + loadingText + '</p>' + '</div>';
    $container.html(loadingHTML);
  }

  /**
   * Show empty state
   */
  function showEmptyState() {
    var $container = $('[data-js="favorite-list-container"]');
    if (!$container.length) {
      return;
    }
    var i18n = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.favoriteList ? window.novisaData.i18n.favoriteList : {};
    var emptyTitle = i18n.empty_title || 'Brak polubionych lokali.';
    var emptySubtitle = i18n.empty_subtitle || 'Dodaj lokale do ulubionych, aby wyświetlić je tutaj.';
    var emptyHTML = '<div class="u-properties-table__empty" data-js="favorite-list-empty">' + '<p class="text-lg">' + emptyTitle + '</p>' + '<p class="text-sm">' + emptySubtitle + '</p>' + '</div>';
    $container.html(emptyHTML);
  }

  /**
   * Show error state
   */
  function showErrorState() {
    var $container = $('[data-js="favorite-list-container"]');
    if (!$container.length) {
      return;
    }
    var i18n = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.favoriteList ? window.novisaData.i18n.favoriteList : {};
    var errorTitle = i18n.error_title || 'Wystąpił błąd podczas ładowania.';
    var errorSubtitle = i18n.error_subtitle || 'Spróbuj odświeżyć stronę.';
    var errorHTML = '<div class="u-properties-table__error" data-js="favorite-list-error">' + '<p class="text-lg">' + errorTitle + '</p>' + '<p class="text-sm">' + errorSubtitle + '</p>' + '</div>';
    $container.html(errorHTML);
  }

  /**
   * Remove favorite list row with animation
   * @param {string} voxId - Property vox_id to remove
   */
  function removeFavoriteListRow(voxId) {
    var $container = $('[data-js="favorite-list-container"]');
    var $row = $container.find('tr[data-vox-id="' + voxId + '"]');
    if (!$row.length) {
      return;
    }

    // Remove row with animation
    $row.fadeOut(300, function () {
      $(this).remove();

      // Check if there are any rows left
      var $tbody = $container.find('tbody');
      var remainingRows = $tbody.find('tr').length;

      // If no rows left, show empty state
      if (remainingRows === 0) {
        showEmptyState();
      }
    });
  }

  // Listen for property removal from any module (favorite button, compare, etc.)
  $(document).on('favoritePropertyRemoved', function (e, voxId) {
    // Only proceed if favorite list container exists on this page
    if (!$('[data-js="favorite-list-container"]').length) {
      return;
    }

    // Remove the row for this property
    removeFavoriteListRow(voxId);
  });

  // Listen for property addition from any module (favorite button in related properties, etc.)
  $(document).on('favoritePropertyAdded', function (e, voxId) {
    // Only proceed if favorite list container exists on this page
    if (!$('[data-js="favorite-list-container"]').length) {
      return;
    }

    // Reload entire list to include the new property
    loadFavoriteList();
  });
});
jQuery(document).ready(function ($) {
  // Initialize favorite related if container exists
  if ($('[data-js="favorite-related-container"]').length) {
    loadFavoriteRelated();
  }

  /**
   * Load related properties based on favorite properties via AJAX
   */
  function loadFavoriteRelated() {
    var favorite = Cookies.get('novisa_favorite_properties');
    var voxIds = [];
    if (favorite) {
      try {
        voxIds = JSON.parse(favorite);
      } catch (e) {
        console.error('Error parsing favorite properties cookie:', e);
        voxIds = [];
      }
    }

    // Show loading state
    showLoadingState();

    // If no favorite properties, show empty state
    if (!voxIds || voxIds.length === 0) {
      voxIds = [];
    }

    // Make AJAX request
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'load_favorite_related',
        'vox_ids[]': voxIds
      },
      success: function (response) {
        if (response.success && response.data.html) {
          renderTableHTML(response.data.html, response.data.is_empty);
        } else {
          console.error('Error loading related properties:', response.data ? response.data.message : 'Unknown error');
          showErrorState();
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX error:', error);
        showErrorState();
      }
    });
  }

  /**
   * Render table HTML from server
   */
  function renderTableHTML(html, isEmptyOrError) {
    var $container = $('[data-js="favorite-related-container"]');
    if (!$container.length) {
      return;
    }

    // Clear container
    $container.empty();

    // Append HTML (either table or message)
    $container.append(html);

    // If it's a table (not empty/error state), initialize interactions
    if (!isEmptyOrError) {
      initializeTableInteractions();
    }
  }

  /**
   * Initialize tooltips and favorite buttons for table content
   * Uses global helper from _table.js
   */
  function initializeTableInteractions() {
    if (typeof tableReinitialize === 'function') {
      tableReinitialize();
    }
  }

  /**
   * Show loading state
   */
  function showLoadingState() {
    var $container = $('[data-js="favorite-related-container"]');
    if (!$container.length) {
      return;
    }
    var i18n = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.favoriteRelated ? window.novisaData.i18n.favoriteRelated : {};
    var loadingText = i18n.loading || 'Ładowanie...';
    var loadingHTML = '<div class="u-properties-table__loading" data-js="favorite-related-loading">' + '<p class="text-lg">' + loadingText + '</p>' + '</div>';
    $container.html(loadingHTML);
  }

  /**
   * Show empty state
   */
  function showEmptyState() {
    var $container = $('[data-js="favorite-related-container"]');
    if (!$container.length) {
      return;
    }
    var i18n = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.favoriteRelated ? window.novisaData.i18n.favoriteRelated : {};
    var emptyTitle = i18n.empty_title || 'Brak podobnych lokali.';
    var emptySubtitle = i18n.empty_subtitle || 'Nie znaleźliśmy lokali podobnych do Twoich ulubionych.';
    var emptyHTML = '<div class="u-properties-table__empty" data-js="favorite-related-empty">' + '<p class="text-lg">' + emptyTitle + '</p>' + '<p class="text-sm">' + emptySubtitle + '</p>' + '</div>';
    $container.html(emptyHTML);
  }

  /**
   * Show error state
   */
  function showErrorState() {
    var $container = $('[data-js="favorite-related-container"]');
    if (!$container.length) {
      return;
    }
    var i18n = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.favoriteRelated ? window.novisaData.i18n.favoriteRelated : {};
    var errorTitle = i18n.error_title || 'Wystąpił błąd podczas ładowania.';
    var errorSubtitle = i18n.error_subtitle || 'Spróbuj odświeżyć stronę.';
    var errorHTML = '<div class="u-properties-table__error" data-js="favorite-related-error">' + '<p class="text-lg">' + errorTitle + '</p>' + '<p class="text-sm">' + errorSubtitle + '</p>' + '</div>';
    $container.html(errorHTML);
  }

  // Listen for property removal (when property is removed from favorites)
  $(document).on('favoritePropertyRemoved', function (e, voxId) {
    // Only proceed if favorite related container exists on this page
    if (!$('[data-js="favorite-related-container"]').length) {
      return;
    }

    // Reload related properties to potentially include the removed property
    loadFavoriteRelated();
  });
});

/* Sticky Header */
const header = document.getElementById("header");
let scrollpos = window.scrollY;
window.addEventListener('scroll', function () {
  scrollpos = window.scrollY;
  scrollpos > 64 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
});
jQuery(document).ready(function ($) {
  var $hamburger = $('[data-js="hamburger"]');
  var $menu = $('[data-js="header-menu"]');
  var $html = $('html');

  /* Hamburger */
  $hamburger.on('click', function (e) {
    e.preventDefault();
    var $btn = $(this);
    if ($btn.hasClass('is-active')) {
      $btn.removeClass('is-active');
      $menu.removeClass('is-active');
      $html.removeClass('has-nav-open');
      $menu.find('.menu > li.has-megamenu').removeClass('is-active');
    } else {
      $btn.addClass('is-active');
      $menu.addClass('is-active');
      $html.addClass('has-nav-open');
    }
  });

  /* Menu Mobile */
  if ($menu.length) {
    var $menuLinks = $menu.find('.menu > li.has-megamenu > a');
    $menuLinks.on('click', function (e) {
      e.preventDefault();
      var $el = $(this);
      var $parentLi = $el.closest('li.has-megamenu');
      var isActive = $parentLi.hasClass('is-active');
      $menu.find('.menu > li.has-megamenu').removeClass('is-active');
      if (!isActive) {
        $parentLi.addClass('is-active');
      }
    });

    /* Language Switcher Mobile */
    var $languageSwitcherButton = $('[data-js="language-switcher-button"]');
    $languageSwitcherButton.on('click', function (e) {
      e.preventDefault();
      var $el = $(this);
      var $languageSwitcher = $el.closest('[data-js="language-switcher"]');
      $languageSwitcher.toggleClass('is-active');
    });
  }
});
jQuery(document).ready(function ($) {
  const $labelRotator = $('[data-js="label-rotator"]:visible');
  if ($labelRotator.length) {
    $labelRotator.each(function () {
      const $label = $(this);
      const $labels = $label.find('.u-labels__item');

      // Check if there are multiple labels to rotate
      if ($labels.length > 1) {
        let currentIndex = 0;

        // Start rotation every 4 seconds
        setInterval(function () {
          // Hide current label
          $labels.eq(currentIndex).fadeOut(500).css('z-index', 1);

          // Calculate next index (loop back to 0 if at the end)
          currentIndex = (currentIndex + 1) % $labels.length;

          // Show next label with fade effect
          $labels.eq(currentIndex).fadeIn(500).css('z-index', 2);
        }, 4000);
      }
    });
  }
});
/**
 * Loan Calculator
 * Dedicated calculator for credit/loan calculations
 */

jQuery(document).ready(function ($) {
  /**
   * Calculate monthly loan installment using PMT annuity formula
   * Uses Excel's 30/360 day count convention for consistency
   */
  function calculateLoanInstallment(loanAmount, loanPeriodYears, annualInterestRate) {
    // Validate inputs
    if (loanAmount <= 0 || loanPeriodYears <= 0) {
      return 0;
    }

    // Convert years to months
    const totalMonths = loanPeriodYears * 12;

    // Convert annual interest rate to monthly using Excel's 30/360 convention
    const monthlyRate = annualInterestRate / 100 * (30 / 360);

    // Handle 0% interest as special case
    if (monthlyRate <= 0) {
      return loanAmount / totalMonths;
    }

    // PMT annuity formula: (r * P) / (1 - (1 + r)^-n)
    const installment = monthlyRate * loanAmount / (1 - Math.pow(1 + monthlyRate, -totalMonths));
    return installment;
  }

  /**
   * Get proper Polish month text form based on number
   * Uses WPML translations from novisaData.i18n.loanCalculator
   */
  function getMonthText(count) {
    const i18n = window.novisaData?.i18n?.loanCalculator || {};
    if (count === 1) {
      return i18n.monthSingular || 'miesiąc';
    } else if (count >= 2 && count <= 4) {
      return i18n.monthFew || 'miesiące';
    } else {
      return i18n.monthMany || 'miesięcy';
    }
  }

  /**
   * Update loan calculator result display
   */
  // OLD
  // function updateLoanCalculator() {
  //     const $calculatorWrapper = $('.u-card-calculator');

  //     if (!$calculatorWrapper.length) {
  //         return;
  //     }

  //     // Find calculator tabs within .u-card-calculator only
  //     const $calculators = $calculatorWrapper.find('[data-tab="loan-calculator"], [data-tab="overpayment-calculator"]');

  //     $calculators.each(function() {
  //         const $calculator = $(this);

  //         // Get input values from this specific calculator
  //         const $amountInput = $calculator.find('.filter-field[data-min="20000"] .input-value');
  //         const $periodInput = $calculator.find('.filter-field[data-min="3"] .input-value');
  //         const $rateInput = $calculator.find('.filter-field[data-min="0"] .input-value');
  //         const $resultElement = $calculator.find('[data-js="result"]');

  //         if (!$amountInput.length || !$periodInput.length || !$rateInput.length || !$resultElement.length) {
  //             return;
  //         }

  //         const loanAmount = parseFloat($amountInput.val()) || 0;
  //         const loanPeriodYears = parseFloat($periodInput.val()) || 0;
  //         let annualInterestRate = parseFloat($rateInput.val()) || 0;

  //         // Check if "variable" rate type is active - reduce rate by 0.10% for calculation only
  //         const $variableButton = $calculatorWrapper.find('[data-js="rate-type"] .button[data-type="variable"]');
  //         if ($variableButton.length && $variableButton.hasClass('is-active')) {
  //             annualInterestRate = Math.max(0, annualInterestRate - 0.10);
  //         }

  //         // Calculate installment
  //         const installment = calculateLoanInstallment(loanAmount, loanPeriodYears, annualInterestRate);

  //         // Format result
  //         const formatted = installment.toLocaleString('pl-PL', {
  //             minimumFractionDigits: 2,
  //             maximumFractionDigits: 2
  //         });

  //         // Update result display (currency added in HTML for WPML)
  //         $resultElement.text(formatted);
  //     });
  // }
  function updateLoanCalculator() {
    const $calculatorWrapper = $('.u-card-calculator');
    if (!$calculatorWrapper.length) {
      return;
    }
    const $calculators = $calculatorWrapper.find('[data-tab="loan-calculator"], [data-tab="overpayment-calculator"]');
    $calculators.each(function () {
      const $calculator = $(this);
      const isOverpaymentTab = $calculator.data('tab') === 'overpayment-calculator';
      let loanAmount = 0;
      if (!isOverpaymentTab) {
        const $propertyInput = $calculator.find('[data-id="property-value"] .input-value');
        const $contribInput = $calculator.find('[data-id="own-contribution"] .input-value');
        const $loanDisplay = $calculator.find('[data-id="loan-amount"] .input-value');
        const contribType = $calculator.find('[data-js="contribution-type"] .button.is-active').data('type') || 'percent';

        // Aggressive parsing
        const propValRaw = $propertyInput.val() || '0';
        const contribValRaw = $contribInput.val() || '0';
        let propertyValue = parseFloat(String(propValRaw).replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
        let contribValue = parseFloat(String(contribValRaw).replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
        let contribPln = 0;
        if (contribType === 'percent') {
          contribPln = propertyValue * (contribValue / 100);
        } else {
          contribPln = contribValue;
        }
        if (contribPln > propertyValue) {
          contribPln = propertyValue;
        }
        loanAmount = propertyValue - contribPln;
        $loanDisplay.val(loanAmount.toLocaleString('pl-PL', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }));
        if (contribType === 'pln') {
          const sliderEl = $calculator.find('[data-id="own-contribution"] .slider')[0];
          if (sliderEl && sliderEl.noUiSlider) {
            let currentMax = sliderEl.noUiSlider.options.range.max;
            let newMax = propertyValue > 0 ? propertyValue : 1000000;

            // Rebuild the slider only when the property value changes!
            // Prevents resetting to zero when typing the own contribution manually
            if (currentMax !== newMax) {
              sliderEl.noUiSlider.updateOptions({
                range: {
                  'min': 0,
                  'max': newMax
                }
              });
              $calculator.find('[data-id="own-contribution"] [data-label-max]').text((propertyValue > 0 ? propertyValue.toLocaleString('pl-PL') : '1 000 000') + ' zł');
            }
          }
        }
      } else {
        const $amountInput = $calculator.find('[data-field="remaining-amount"]');
        if (!$amountInput.length) return;
        const amountValRaw = $amountInput.val() || '0';
        loanAmount = parseFloat(String(amountValRaw).replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
      }
      let $periodInput = $calculator.find('[data-id="loan-period"] .input-value');
      if (!$periodInput.length) $periodInput = $calculator.find('.filter-field[data-min="3"] .input-value, .okres-splaty .input-value');
      let $rateInput = $calculator.find('[data-id="interest-rate"] .input-value');
      if (!$rateInput.length) $rateInput = $calculator.find('.filter-field[data-min="0"]:not([data-id="own-contribution"]) .input-value, .oprocentowanie .input-value');
      const $resultElement = $calculator.find('[data-js="result"], [data-js="overpayment-result"]');
      if (!$periodInput.length || !$rateInput.length && !isOverpaymentTab || !$resultElement.length) {
        return;
      }
      const periodRaw = String($periodInput.val() || '0').replace(/[^0-9.,]/g, '').replace(',', '.');
      const loanPeriodYears = isOverpaymentTab ? (parseFloat(periodRaw) || 0) / 12 : parseFloat(periodRaw) || 0;
      const rateValRaw = $rateInput.val() || '0';
      let annualInterestRate = parseFloat(String(rateValRaw).replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
      const $variableButton = $calculatorWrapper.find('[data-js="rate-type"] .button[data-type="variable"]');
      if (!isOverpaymentTab && $variableButton.length && $variableButton.hasClass('is-active')) {
        annualInterestRate = Math.max(0, annualInterestRate - 0.10);
      }
      const installment = calculateLoanInstallment(loanAmount, loanPeriodYears, annualInterestRate);
      const formatted = installment.toLocaleString('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      $resultElement.text(formatted);
    });
  }
  function initLoanCalculatorSliders() {
    const $calculatorWrapper = $('.u-card-calculator');
    if (!$calculatorWrapper.length) {
      return;
    }
    $calculatorWrapper.find('[data-slider-single]').each(function () {
      var $field = $(this);
      var sliderEl = $field.find('.slider')[0];
      var $output = $field.find('.input-value');
      var min = parseFloat($field.data('min'));
      var max = parseFloat($field.data('max'));
      var step = parseFloat($field.data('step')) || 1;
      var suffix = $field.data('suffix') || '';
      var start = $field.data('start') ? parseFloat($field.data('start')) : parseFloat($output.val()) || min;
      if (sliderEl.noUiSlider) {
        return;
      }
      noUiSlider.create(sliderEl, {
        start: [start],
        connect: [true, false],
        range: {
          'min': min,
          'max': max
        },
        step: step
      });
      var decimalPlaces = step < 1 && suffix.includes('%') ? 2 : step < 1 ? 1 : 0;
      var isOverpaymentTab = $field.closest('[data-tab="overpayment-calculator"]').length > 0;
      sliderEl.noUiSlider.set(start);
      $output.val(start.toFixed(decimalPlaces));
      sliderEl.noUiSlider.on('update', function (values) {
        var val = parseFloat(values[0]);
        if (!$output.is(':focus')) {
          $output.val(val.toFixed(decimalPlaces));
        }
        var currentSuffix = $field.data('suffix') || suffix;
        $output.next('.unit').text(currentSuffix);
      });
      sliderEl.noUiSlider.on('change', function (values) {
        if (isOverpaymentTab) {
          updateOverpaymentCalculator();
        } else {
          updateLoanCalculator();
        }
      });
      $output.on('input', function () {
        var inputVal = $(this).val();
        var cleaned = inputVal.replace(/[^0-9.,\s]/g, '');
        if (cleaned !== inputVal) {
          $(this).val(cleaned);
        }
      });
      $output.on('blur', function () {
        // New aggressive parsing
        var inputValRaw = String($(this).val() || '0').replace(/[^0-9.,]/g, '').replace(',', '.');
        var inputVal = parseFloat(inputValRaw);
        if (isNaN(inputVal)) {
          inputVal = 0;
        }
        sliderEl.noUiSlider.set(inputVal);
        var correctedVal = parseFloat(sliderEl.noUiSlider.get());
        $(this).val(correctedVal.toFixed(decimalPlaces));
        if (isOverpaymentTab) {
          updateOverpaymentCalculator();
        } else {
          updateLoanCalculator();
        }
      });
      $output.on('keypress', function (e) {
        if (e.which === 13) {
          $(this).blur();
        }
      });
    });
  }
  function initLoanCalculator() {
    const $calculatorWrapper = $('.u-card-calculator');
    if (!$calculatorWrapper.length) {
      return;
    }
    initLoanCalculatorSliders();
    $calculatorWrapper.on('input change', '.filter-field .input-value', function () {
      updateLoanCalculator();
    });
    $calculatorWrapper.on('click', '[data-js="rate-type"] .button', function () {
      const $button = $(this);
      $button.addClass('is-active').siblings().removeClass('is-active');
      updateLoanCalculator();
    });
    $calculatorWrapper.on('click', '[data-js="contribution-type"] .button', function (e) {
      e.preventDefault();
      const $btn = $(this);
      if ($btn.hasClass('is-active')) return;
      $btn.siblings().removeClass('is-active');
      $btn.addClass('is-active');
      const newType = $btn.data('type');
      const $field = $btn.closest('[data-id="own-contribution"]');
      const sliderEl = $field.find('.slider')[0];
      const $input = $field.find('.input-value');
      const propertyValRaw = $calculatorWrapper.find('[data-id="property-value"] .input-value').val() || '0';
      const inputValRaw = $input.val() || '0';
      const propertyVal = parseFloat(String(propertyValRaw).replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
      const currentInputVal = parseFloat(String(inputValRaw).replace(/[^0-9.,]/g, '').replace(',', '.')) || 0;
      if (!sliderEl || !sliderEl.noUiSlider) return;
      if (newType === 'pln') {
        let plnVal = propertyVal * (currentInputVal / 100);
        sliderEl.noUiSlider.updateOptions({
          range: {
            'min': 0,
            'max': propertyVal > 0 ? propertyVal : 1000000
          },
          step: 1 // Step 1
        });
        $field.data('suffix', ' zł');
        $field.find('[data-label-min]').text('0 zł');
        $field.find('[data-label-max]').text((propertyVal > 0 ? propertyVal.toLocaleString('pl-PL') : '1 000 000') + ' zł');
        sliderEl.noUiSlider.set(plnVal);
      } else {
        let pctVal = propertyVal > 0 ? currentInputVal / propertyVal * 100 : 0;
        sliderEl.noUiSlider.updateOptions({
          range: {
            'min': 0,
            'max': 100
          },
          step: 1
        });
        $field.data('suffix', ' %');
        $field.find('[data-label-min]').text('0 %');
        $field.find('[data-label-max]').text('100 %');
        sliderEl.noUiSlider.set(pctVal);
      }
      updateLoanCalculator();
    });

    // Initial calculation
    updateLoanCalculator();
  }

  // Initialize when DOM is ready
  initLoanCalculator();

  /**
   * ========================================
   * OVERPAYMENT CALCULATOR
   * ========================================
   * Completely independent from loan calculator
   */

  /**
   * Calculate overpayment installment for "reduce-installment" effect
   * Uses 30/360 day count convention to match Excel calculations
   */
  function calculateOverpaymentInstallment(loanAmount, totalMonths, annualInterestRate, overpaymentAmount, isRecurring) {
    if (loanAmount <= 0 || totalMonths <= 0) {
      return 0;
    }

    // Monthly interest rate using Excel's 30/360 convention
    const monthlyRate = annualInterestRate / 100 * (30 / 360);
    if (isRecurring) {
      // Recurring overpayment: return standard installment
      // (actual reduction happens over time, not calculated here)
      if (monthlyRate > 0) {
        const installment = monthlyRate * loanAmount / (1 - Math.pow(1 + monthlyRate, -totalMonths));
        return installment;
      } else {
        return loanAmount / totalMonths;
      }
    } else {
      // One-time overpayment: reduce loan amount first, then calculate installment
      const adjustedLoanAmount = loanAmount - overpaymentAmount;
      if (adjustedLoanAmount <= 0) {
        return 0;
      }

      // Calculate installment using IPMT + PPMT for accuracy
      if (monthlyRate > 0) {
        // Interest payment for first period
        const firstInterest = adjustedLoanAmount * monthlyRate;

        // Principal payment for first period
        const standardPMT = monthlyRate * adjustedLoanAmount / (1 - Math.pow(1 + monthlyRate, -totalMonths));
        const firstPrincipal = standardPMT - firstInterest;

        // Total first installment
        return firstPrincipal + firstInterest;
      } else {
        return adjustedLoanAmount / totalMonths;
      }
    }
  }

  /**
   * Calculate shortened loan period (in months) for "shorten-period" effect
   * Uses NPER formula to determine how many months are needed with overpayment
   */
  function calculateShortenedPeriod(loanAmount, totalMonths, annualInterestRate, overpaymentAmount, isRecurring) {
    if (loanAmount <= 0) {
      return totalMonths;
    }

    // Monthly interest rate using Excel's 30/360 convention
    const monthlyRate = annualInterestRate / 100 * (30 / 360);

    // Calculate base monthly installment without overpayment
    let baseInstallment;
    if (monthlyRate > 0) {
      baseInstallment = monthlyRate * loanAmount / (1 - Math.pow(1 + monthlyRate, -totalMonths));
    } else {
      baseInstallment = loanAmount / totalMonths;
    }

    // Determine payment amount for NPER calculation
    let payment;
    if (isRecurring) {
      // Recurring: base installment + recurring overpayment amount
      payment = baseInstallment + overpaymentAmount;
    } else {
      // One-time: just base installment (overpayment reduces loan amount instead)
      payment = baseInstallment;
    }

    // Adjust loan amount by one-time overpayment if applicable
    const adjustedLoanAmount = isRecurring ? loanAmount : loanAmount - overpaymentAmount;
    if (adjustedLoanAmount <= 0 || payment <= 0) {
      return 0;
    }

    // NPER formula: calculate number of periods needed to pay off the loan
    if (monthlyRate > 0) {
      const nper = -Math.log(1 - adjustedLoanAmount * monthlyRate / payment) / Math.log(1 + monthlyRate);
      return Math.round(nper);
    } else {
      return Math.round(adjustedLoanAmount / payment);
    }
  }

  /**
   * Calculate required overpayment amount to achieve target period
   * Reverse calculation: from desired period → overpayment amount
   */
  function calculateRequiredOverpayment(loanAmount, originalPeriod, targetPeriod, annualInterestRate, isRecurring) {
    if (loanAmount <= 0 || targetPeriod >= originalPeriod) {
      return 0; // No overpayment needed if target is same or longer
    }

    // Monthly interest rate using Excel's 30/360 convention
    const monthlyRate = annualInterestRate / 100 * (30 / 360);

    // Calculate base monthly installment for original period
    let baseInstallment;
    if (monthlyRate > 0) {
      baseInstallment = monthlyRate * loanAmount / (1 - Math.pow(1 + monthlyRate, -originalPeriod));
    } else {
      baseInstallment = loanAmount / originalPeriod;
    }
    if (isRecurring) {
      // Recurring overpayment: calculate required payment to achieve target period
      // PMT formula reversed: payment = (r * P) / (1 - (1 + r)^-n)
      let requiredPayment;
      if (monthlyRate > 0) {
        requiredPayment = monthlyRate * loanAmount / (1 - Math.pow(1 + monthlyRate, -targetPeriod));
      } else {
        requiredPayment = loanAmount / targetPeriod;
      }

      // Overpayment = required payment - base installment
      return Math.max(0, requiredPayment - baseInstallment);
    } else {
      // One-time overpayment: calculate how much to reduce principal
      // New loan amount should result in targetPeriod with baseInstallment
      let requiredLoanAmount;
      if (monthlyRate > 0) {
        // PV formula: P = payment * (1 - (1 + r)^-n) / r
        requiredLoanAmount = baseInstallment * (1 - Math.pow(1 + monthlyRate, -targetPeriod)) / monthlyRate;
      } else {
        requiredLoanAmount = baseInstallment * targetPeriod;
      }

      // Overpayment = original loan - required loan amount
      return Math.max(0, loanAmount - requiredLoanAmount);
    }
  }

  /**
   * Update overpayment calculator result based on selected effect type
   */
  function updateOverpaymentCalculator() {
    const $calculatorWrapper = $('.u-card-calculator');
    if (!$calculatorWrapper.length) {
      return;
    }
    const $overpaymentTab = $calculatorWrapper.find('[data-tab="overpayment-calculator"]');
    if (!$overpaymentTab.length) {
      return;
    }

    // Get input values
    const loanAmount = parseFloat($overpaymentTab.find('[data-field="remaining-amount"]').val()) || 0;
    const $periodInput = $overpaymentTab.find('[data-field="overpayment-period"]');
    const currentPeriod = parseFloat($periodInput.val()) || 0;

    // IMPORTANT: Always use original period for calculations, not the current (possibly shortened) value
    const originalPeriod = parseFloat($periodInput.data('original-period')) || currentPeriod;
    const annualInterestRate = parseFloat($overpaymentTab.find('[data-field="overpayment-rate"]').val()) || 0;
    const overpaymentAmount = parseFloat($overpaymentTab.find('[data-field="overpayment-amount"]').val()) || 0;

    // Get overpayment type
    const $activeOverpaymentType = $overpaymentTab.find('[data-js="overpayment-type"] .button.is-active');
    const isRecurring = $activeOverpaymentType.data('type') === 'recurring';

    // Get effect type
    const $activeEffect = $overpaymentTab.find('[data-js="overpayment-effect"] .button.is-active');
    const effect = $activeEffect.data('effect'); // 'reduce-installment' or 'shorten-period'

    const $resultElement = $overpaymentTab.find('[data-js="overpayment-result"]');
    const $infoElement = $overpaymentTab.find('[data-js="overpayment-info"]');
    const $periodInfoElement = $overpaymentTab.find('[data-js="overpayment-period-info"]');
    const $periodTextElement = $overpaymentTab.find('[data-js="overpayment-period-text"]');
    const $resultLabel = $overpaymentTab.find('.filter-result .label');
    const $resultContainer = $overpaymentTab.find('.filter-result .result');

    // Handle "shorten-period" effect
    if (effect === 'shorten-period') {
      // Calculate shortened period based on current overpayment amount
      const shortenedPeriod = calculateShortenedPeriod(loanAmount, currentPeriod, annualInterestRate, overpaymentAmount, isRecurring);
      const adjustedAmount = isRecurring ? loanAmount : loanAmount - overpaymentAmount;

      // Check if loan is fully paid off
      const $paidOffElement = $overpaymentTab.find('[data-js="overpayment-paid-off"]');
      if (adjustedAmount <= 0 || shortenedPeriod <= 0) {
        // Loan is fully paid off
        $resultContainer.hide();
        $infoElement.hide();
        $periodInfoElement.hide();
        $paidOffElement.show();
      } else if (shortenedPeriod > 0) {
        // Calculate new installment for shortened period
        const monthlyRate = annualInterestRate / 100 * (30 / 360);
        let newInstallment;
        if (monthlyRate > 0) {
          newInstallment = monthlyRate * adjustedAmount / (1 - Math.pow(1 + monthlyRate, -shortenedPeriod));
        } else {
          newInstallment = adjustedAmount / shortenedPeriod;
        }

        // Display new installment amount
        const formatted = newInstallment.toLocaleString('pl-PL', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
        $resultContainer.show();
        $resultLabel.show();
        $resultElement.show();
        $resultElement.text(formatted);
        $infoElement.hide();
        $paidOffElement.hide();

        // Show period info with REAL shortened months
        const roundedPeriod = Math.round(shortenedPeriod);
        const monthText = getMonthText(roundedPeriod);
        const monthsText = roundedPeriod + ' ' + monthText;
        $periodTextElement.text(monthsText);
        $periodInfoElement.show();
      } else {
        $resultContainer.hide();
        $infoElement.hide();
        $periodInfoElement.hide();
        $paidOffElement.hide();
      }
      return;
    }

    // Handle "reduce-installment" effect
    // Period is EDITABLE - use current value from input

    const $paidOffElement = $overpaymentTab.find('[data-js="overpayment-paid-off"]');
    const adjustedAmount = isRecurring ? loanAmount : loanAmount - overpaymentAmount;

    // Check if loan is fully paid off
    if (adjustedAmount <= 0) {
      // Loan is fully paid off
      $resultContainer.hide();
      $infoElement.hide();
      $periodInfoElement.hide();
      $paidOffElement.show();
    } else if (isRecurring) {
      // Recurring overpayment: installment changes every month
      // Hide the entire result section - only show info message
      $resultContainer.hide();
      $infoElement.show();
      $periodInfoElement.hide();
      $paidOffElement.hide();
    } else {
      // One-time overpayment: calculate and show reduced installment
      const installment = calculateOverpaymentInstallment(loanAmount, currentPeriod, annualInterestRate, overpaymentAmount, isRecurring);
      const formatted = installment.toLocaleString('pl-PL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      $resultContainer.show();
      $resultLabel.show();
      $resultElement.show();
      $resultElement.text(formatted);
      $infoElement.hide();
      $periodInfoElement.hide();
      $paidOffElement.hide();
    }
  }

  /**
   * Initialize overpayment calculator with event listeners
   */
  function initOverpaymentCalculator() {
    const $calculatorWrapper = $('.u-card-calculator');
    if (!$calculatorWrapper.length) {
      return;
    }

    // Listen to overpayment amount slider changes
    setTimeout(function () {
      const $overpaymentSlider = $calculatorWrapper.find('[data-tab="overpayment-calculator"] [data-field="overpayment-amount"]').closest('[data-slider-single]').find('.slider')[0];
      if ($overpaymentSlider && $overpaymentSlider.noUiSlider) {
        $overpaymentSlider.noUiSlider.on('change', function () {
          updateOverpaymentCalculator();
        });
      }
    }, 500);

    // Listen to manual input changes (only on blur to avoid partial values during typing)
    $calculatorWrapper.on('blur', '[data-field="overpayment-amount"]', function () {
      updateOverpaymentCalculator();
    });

    // Listen to remaining amount changes (manual edits)
    $calculatorWrapper.on('blur', '[data-field="remaining-amount"]', function () {
      updateOverpaymentCalculator();
    });

    // Listen to interest rate changes (manual input, no slider)
    $calculatorWrapper.on('blur', '[data-field="overpayment-rate"]', function () {
      // Format to 2 decimal places
      var val = parseFloat($(this).val().replace(',', '.')) || 0;
      val = Math.max(0, Math.min(10, val)); // Clamp to 0-10%
      $(this).val(val.toFixed(2));
      updateOverpaymentCalculator();
    });

    // Listen to period changes (manual input)
    $calculatorWrapper.on('blur', '[data-field="overpayment-period"]', function () {
      const $periodInput = $(this);

      // Validate and clamp to reasonable range (36-420 months = 3-35 years)
      var val = parseFloat($periodInput.val()) || 0;
      val = Math.max(36, Math.min(420, Math.round(val)));
      $periodInput.val(val);

      // Just recalculate - no synchronization with overpayment amount
      updateOverpaymentCalculator();
    });

    // Filter numeric input for interest rate
    $calculatorWrapper.on('input', '[data-field="overpayment-rate"]', function () {
      var inputVal = $(this).val();
      var cleaned = inputVal.replace(/[^0-9.,]/g, '');
      if (cleaned !== inputVal) {
        $(this).val(cleaned);
      }
    });

    // Listen to overpayment type button changes (recurring/one-time)
    $calculatorWrapper.on('click', '[data-js="overpayment-type"] .button', function () {
      const $button = $(this);
      $button.addClass('is-active').siblings().removeClass('is-active');
      updateOverpaymentCalculator();
    });

    // Listen to overpayment effect button changes (shorten-period/reduce-installment)
    $calculatorWrapper.on('click', '[data-js="overpayment-effect"] .button', function () {
      const $button = $(this);
      $button.addClass('is-active').siblings().removeClass('is-active');

      // Keep current period value - don't reset when switching effects
      // Period is always editable - both effects allow editing
      const $periodInput = $calculatorWrapper.find('[data-field="overpayment-period"]');
      $periodInput.prop('readonly', false).attr('tabindex', '0').removeClass('readonly');
      updateOverpaymentCalculator();
    });

    // Store original period value and format interest rate on initialization
    setTimeout(function () {
      const $periodInput = $calculatorWrapper.find('[data-field="overpayment-period"]');
      const originalValue = $periodInput.val();
      $periodInput.data('original-period', originalValue);

      // Period is always editable
      $periodInput.prop('readonly', false).attr('tabindex', '0').removeClass('readonly');

      // Format interest rate to 2 decimal places on init
      const $rateInput = $calculatorWrapper.find('[data-field="overpayment-rate"]');
      const rateVal = parseFloat($rateInput.val()) || 0;
      $rateInput.val(rateVal.toFixed(2));

      // Always calculate on initialization to show initial result
      updateOverpaymentCalculator();
    }, 200);
  }

  // Initialize overpayment calculator with delay to ensure sliders are ready
  setTimeout(function () {
    initOverpaymentCalculator();
  }, 300);
});

// ============================================================================
// CONTACT MAP - Tab Handling & Mapbox Integration (Lazy Init on Click)
// ============================================================================

(function () {
  'use strict';

  // ========================================================================
  // CONFIGURATION
  // ========================================================================
  const CONFIG = {
    selectors: {
      wrapper: '[data-js="mapbox-contact"]',
      mapContainer: 'mapbox-contact',
      initButton: '[data-js="init-mapbox"]',
      placeholder: '[data-js="map-placeholder"]',
      tabButton: '[data-js="tab-button"]',
      tabContent: '[data-js="tab-content"]',
      tabContentHeading: '[data-js="tab-content-heading"]'
    },
    map: {
      defaultCenter: [19.1451, 52.2370],
      defaultZoom: 6,
      maxZoom: 16,
      minZoom: 5,
      markerZoom: 16,
      overviewZoom: 14,
      style: 'mapbox://styles/mapbox/light-v11'
    },
    marker: {
      width: 37,
      height: 49,
      iconSize: 1
    },
    animation: {
      speed: 3,
      easing: t => t,
      duration: 2000
    },
    popup: {
      offset: [0, -55],
      anchor: 'bottom',
      closeButton: false,
      closeOnClick: false
    },
    padding: {
      top: 80,
      bottom: 80,
      left: 80,
      right: 80
    },
    cluster: {
      maxZoom: 10,
      radius: 50,
      color: '#0189E4',
      circleRadius: 20
    },
    events: {
      loadCity: 'mapbox:loadCity'
    }
  };
  const DIRECTIONS_ICON_SVG = `
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M9.5 2.3959C9.26726 2.3959 9.0377 2.34174 8.8295 2.2377L5.6705 0.658199C5.4623 0.554161 5.23275 0.5 5 0.5M9.5 2.3959C9.73275 2.3959 9.9623 2.34174 10.1705 2.2377L12.9148 0.865199C13.0292 0.808018 13.1563 0.781056 13.2841 0.786875C13.4119 0.792695 13.5361 0.831103 13.6448 0.898447C13.7536 0.965792 13.8433 1.05983 13.9055 1.17164C13.9677 1.28344 14.0002 1.40928 14 1.5372V11.1102C13.9999 11.2494 13.9611 11.3859 13.8878 11.5043C13.8146 11.6228 13.7098 11.7185 13.5853 11.7807L10.1705 13.4884C9.9623 13.5925 9.73275 13.6466 9.5 13.6466M9.5 2.3959V13.6466M9.5 13.6466C9.26726 13.6466 9.0377 13.5925 8.8295 13.4884L5.6705 11.9089C5.4623 11.8049 5.23275 11.7508 5 11.7508C4.76726 11.7508 4.5377 11.8049 4.3295 11.9089L1.58525 13.2814C1.47077 13.3387 1.34354 13.3656 1.21569 13.3598C1.08784 13.3539 0.963619 13.3154 0.85484 13.248C0.746061 13.1806 0.656348 13.0864 0.594237 12.9745C0.532127 12.8626 0.499686 12.7367 0.500002 12.6087V3.03645C0.500077 2.8972 0.538915 2.76073 0.612167 2.6423C0.685418 2.52388 0.790192 2.42819 0.914752 2.36595L4.3295 0.658199C4.5377 0.554161 4.76726 0.5 5 0.5M5 0.5V11.7499" stroke="#009EE2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `;

  // ========================================================================
  // UTILITY FUNCTIONS
  // ========================================================================

  function getPadding(includeMarkerHeight = true) {
    return {
      top: CONFIG.padding.top + (includeMarkerHeight ? CONFIG.marker.height : 0),
      bottom: CONFIG.padding.bottom,
      left: CONFIG.padding.left,
      right: CONFIG.padding.right
    };
  }
  function setActiveElement(parentElement, selector, activeElement) {
    parentElement.querySelectorAll(selector).forEach(el => {
      el.classList.remove('is-active');
    });
    if (activeElement) {
      activeElement.classList.add('is-active');
    }
  }

  // ========================================================================
  // TAB HANDLING MODULE
  // ========================================================================

  function initMapboxTabs() {
    document.addEventListener("DOMContentLoaded", function () {
      const wrapper = document.querySelector(CONFIG.selectors.wrapper);
      if (!wrapper) return;
      wrapper.addEventListener('click', function (event) {
        const button = event.target.closest(CONFIG.selectors.tabButton);
        if (!button) return;
        const tabName = button.dataset.tab;
        const tabContent = wrapper.querySelector(`.tabs-content[data-tab="${tabName}"]`);
        const tabHeading = wrapper.querySelector(`.tabs-content-heading[data-tab="${tabName}"]`);
        setActiveElement(wrapper, CONFIG.selectors.tabButton, button);
        setActiveElement(wrapper, CONFIG.selectors.tabContent, tabContent);
        setActiveElement(wrapper, CONFIG.selectors.tabContentHeading, tabHeading);
        if (tabContent) {
          window.dispatchEvent(new CustomEvent(CONFIG.events.loadCity, {
            detail: tabContent
          }));
        }
      });
    });
  }

  // ========================================================================
  // MAPBOX MAP MODULE
  // ========================================================================

  function initMapboxContactMap() {
    document.addEventListener("DOMContentLoaded", function () {
      const wrapper = document.querySelector(CONFIG.selectors.wrapper);
      if (!wrapper) return;
      const mapContainer = document.getElementById(CONFIG.selectors.mapContainer);
      if (!mapContainer) return;
      const initButton = wrapper.querySelector(CONFIG.selectors.initButton);
      if (!initButton) return;
      const placeholder = mapContainer.querySelector(CONFIG.selectors.placeholder);
      let isInitialized = false;
      initButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (isInitialized) return;
        isInitialized = true;
        if (placeholder) placeholder.classList.add('is-inactive');
        if (typeof mapboxgl === "undefined") {
          console.warn('Mapbox GL JS library is not loaded');
          return;
        }
        if (!novisaData?.mapbox?.token) {
          console.warn('Mapbox token is not defined');
          return;
        }
        initButton.disabled = true;
        mapboxgl.accessToken = novisaData.mapbox.token;
        const map = new mapboxgl.Map({
          container: CONFIG.selectors.mapContainer,
          style: novisaData?.mapbox?.style || CONFIG.map.style,
          center: CONFIG.map.defaultCenter,
          zoom: CONFIG.map.defaultZoom,
          projection: 'mercator',
          maxZoom: CONFIG.map.maxZoom,
          minZoom: CONFIG.map.minZoom,
          pitchWithRotate: true,
          dragRotate: true,
          attributionControl: false
        });
        map.addControl(new mapboxgl.AttributionControl({
          compact: true
        }), 'bottom-right');
        map.addControl(new mapboxgl.NavigationControl({
          showCompass: true,
          showZoom: true,
          visualizePitch: true
        }), 'top-right');
        let activePopup = null;
        let currentBounds = null;
        const loadedIcons = {};
        function convertSvgToPng(svgUrl, callback) {
          fetch(svgUrl).then(response => response.text()).then(svgText => {
            const image = new Image();
            const svgBlob = new Blob([svgText], {
              type: 'image/svg+xml'
            });
            const blobUrl = URL.createObjectURL(svgBlob);
            image.onload = function () {
              const canvas = document.createElement('canvas');
              canvas.width = CONFIG.marker.width;
              canvas.height = CONFIG.marker.height;
              const context = canvas.getContext('2d');
              context.drawImage(image, 0, 0, CONFIG.marker.width, CONFIG.marker.height);
              URL.revokeObjectURL(blobUrl);
              canvas.toBlob(blob => {
                createImageBitmap(blob).then(imageBitmap => {
                  callback(null, imageBitmap);
                });
              }, 'image/png');
            };
            image.onerror = () => callback(new Error('Failed to load SVG'));
            image.src = blobUrl;
          }).catch(error => callback(error));
        }
        function getIconName(iconUrl) {
          const fileName = iconUrl.split('/').pop().replace(/\.[^/.]+$/, '');
          return `marker-${fileName}`;
        }
        function loadMarkerIcon(iconUrl, callback) {
          const iconName = getIconName(iconUrl);
          if (loadedIcons[iconUrl]) {
            callback(null, iconName);
            return;
          }
          convertSvgToPng(iconUrl, (error, imageBitmap) => {
            if (error) {
              console.error(`Error loading icon ${iconUrl}:`, error);
              callback(error);
              return;
            }
            if (!map.hasImage(iconName)) {
              map.addImage(iconName, imageBitmap);
            }
            loadedIcons[iconUrl] = iconName;
            callback(null, iconName);
          });
        }
        function closeActivePopup(restoreView = false) {
          if (!activePopup) return;
          activePopup.remove();
          activePopup = null;
          if (restoreView && currentBounds) {
            map.fitBounds(currentBounds, {
              padding: getPadding(),
              maxZoom: CONFIG.map.overviewZoom,
              speed: CONFIG.animation.speed,
              easing: CONFIG.animation.easing
            });
          }
        }
        function createPopup(coordinates, city, address, directionsUrl, directionLabel) {
          closeActivePopup();
          const directionsLink = directionsUrl ? `<a href="${directionsUrl}" target="_blank" rel="noopener noreferrer" class="popup-directions">
                            ${directionLabel}
                            ${DIRECTIONS_ICON_SVG}
                        </a>` : '';
          activePopup = new mapboxgl.Popup(CONFIG.popup).setLngLat(coordinates).setHTML(`
                            <div class="popup">
                                <button class="popup-close" aria-label="Close">✕</button>
                                <p class="popup-title">${city}</p>
                                <p class="popup-address">${address}</p>
                                ${directionsLink}
                            </div>
                        `).addTo(map);
          setTimeout(() => {
            const closeButton = activePopup.getElement()?.querySelector(".popup-close");
            if (closeButton) {
              closeButton.addEventListener("click", event => {
                event.stopPropagation();
                closeActivePopup(true);
              });
            }
          }, 10);
        }
        function createMarkerFeatures(pointElements) {
          const markerFeatures = [];
          const iconsToLoad = new Set();
          pointElements.forEach(pointElement => {
            const pointLat = parseFloat(pointElement.dataset.latitude);
            const pointLng = parseFloat(pointElement.dataset.longitude);
            const address = pointElement.dataset.address || "";
            const city = pointElement.dataset.city || "";
            const markerIconUrl = pointElement.dataset.marker;
            const directionsUrl = pointElement.dataset.directionsUrl || "";
            const directionLabel = pointElement.dataset.directionLabel || "Wyznacz trasę";
            if (markerIconUrl) {
              iconsToLoad.add(markerIconUrl);
            }
            if (!isNaN(pointLat) && !isNaN(pointLng)) {
              markerFeatures.push({
                type: 'Feature',
                geometry: {
                  type: 'Point',
                  coordinates: [pointLng, pointLat]
                },
                properties: {
                  address,
                  city,
                  markerIconUrl,
                  iconName: markerIconUrl ? getIconName(markerIconUrl) : 'marker-pin',
                  directionsUrl,
                  directionLabel
                }
              });
            }
          });
          return {
            markerFeatures,
            iconsToLoad
          };
        }
        function updateMapMarkers(markerFeatures) {
          const source = map.getSource('markers');
          if (source) {
            source.setData({
              type: 'FeatureCollection',
              features: markerFeatures
            });
          }
        }
        function loadIconsAndUpdateMarkers(iconsToLoad, markerFeatures) {
          if (iconsToLoad.size === 0) {
            updateMapMarkers(markerFeatures);
            return;
          }
          let iconsLoadedCount = 0;
          const totalIconsCount = iconsToLoad.size;
          iconsToLoad.forEach(iconUrl => {
            loadMarkerIcon(iconUrl, () => {
              iconsLoadedCount++;
              if (iconsLoadedCount === totalIconsCount) {
                updateMapMarkers(markerFeatures);
              }
            });
          });
        }
        function fitMapToMarkers(markerFeatures, isInitial) {
          if (markerFeatures.length === 0) {
            currentBounds = null;
            if (isInitial) {
              map.setCenter(CONFIG.map.defaultCenter);
              map.setZoom(CONFIG.map.defaultZoom);
            } else {
              map.flyTo({
                center: CONFIG.map.defaultCenter,
                zoom: CONFIG.map.defaultZoom,
                speed: CONFIG.animation.speed,
                easing: CONFIG.animation.easing
              });
            }
            return;
          }
          const bounds = new mapboxgl.LngLatBounds();
          markerFeatures.forEach(feature => {
            bounds.extend(feature.geometry.coordinates);
          });
          currentBounds = bounds;
          const fitBoundsOptions = {
            padding: getPadding(),
            maxZoom: CONFIG.map.overviewZoom,
            easing: CONFIG.animation.easing,
            duration: isInitial ? 0 : CONFIG.animation.duration
          };
          map.fitBounds(bounds, fitBoundsOptions);
        }
        function loadCityOnMap(tabContent, isInitial = false) {
          if (!tabContent) return;
          const pointElements = tabContent.querySelectorAll("points point");
          closeActivePopup();
          if (!isInitial) {
            setTimeout(() => {
              map.resize();
            }, 50);
          }
          const {
            markerFeatures,
            iconsToLoad
          } = createMarkerFeatures(pointElements);
          loadIconsAndUpdateMarkers(iconsToLoad, markerFeatures);
          fitMapToMarkers(markerFeatures, isInitial);
        }
        function smoothScrollTo(targetPosition, duration = 800) {
          const startPosition = window.pageYOffset;
          const distance = targetPosition - startPosition;
          let startTime = null;
          function animation(currentTime) {
            if (startTime === null) startTime = currentTime;
            const timeElapsed = currentTime - startTime;
            const progress = Math.min(timeElapsed / duration, 1);
            const ease = progress < 0.5 ? 2 * progress * progress : 1 - Math.pow(-2 * progress + 2, 2) / 2;
            window.scrollTo(0, startPosition + distance * ease);
            if (timeElapsed < duration) {
              requestAnimationFrame(animation);
            }
          }
          requestAnimationFrame(animation);
        }
        function setupAddressLinks() {
          wrapper.addEventListener('click', event => {
            const link = event.target.closest('[data-js="zoom-to-marker"]');
            if (!link) return;
            event.preventDefault();
            const lat = parseFloat(link.dataset.latitude);
            const lng = parseFloat(link.dataset.longitude);
            if (!isNaN(lat) && !isNaN(lng)) {
              const source = map.getSource('markers');
              if (source && source._data && source._data.features) {
                const feature = source._data.features.find(f => {
                  const featureCoords = f.geometry.coordinates;
                  return Math.abs(featureCoords[0] - lng) < 0.0001 && Math.abs(featureCoords[1] - lat) < 0.0001;
                });
                if (feature) {
                  if (window.innerWidth < 1200) {
                    const targetPosition = window.pageYOffset + mapContainer.getBoundingClientRect().top - 100;
                    smoothScrollTo(targetPosition, 800);
                    setTimeout(() => {
                      handleMarkerClick(feature);
                    }, 800);
                  } else {
                    handleMarkerClick(feature);
                  }
                }
              }
            }
          });
        }
        function handleMarkerClick(feature) {
          const coordinates = feature.geometry.coordinates.slice();
          const {
            city,
            address,
            directionsUrl,
            directionLabel
          } = feature.properties;
          if (activePopup) {
            const popupCoords = activePopup.getLngLat();
            if (Math.abs(popupCoords.lng - coordinates[0]) < 0.0001 && Math.abs(popupCoords.lat - coordinates[1]) < 0.0001) {
              return;
            }
          }
          closeActivePopup(false);
          map.flyTo({
            center: coordinates,
            zoom: CONFIG.map.markerZoom,
            speed: CONFIG.animation.speed,
            easing: CONFIG.animation.easing,
            essential: true
          });
          map.once('moveend', () => {
            createPopup(coordinates, city, address, directionsUrl, directionLabel);
          });
        }
        function handleClusterClick(feature) {
          const clusterId = feature.properties.cluster_id;
          const source = map.getSource('markers');
          if (source) {
            source.getClusterExpansionZoom(clusterId, (error, zoom) => {
              if (error) return;
              map.easeTo({
                center: feature.geometry.coordinates,
                zoom: zoom,
                easing: CONFIG.animation.easing
              });
            });
          }
        }
        function setupClickHandlers() {
          map.on('click', event => {
            const markerFeatures = map.queryRenderedFeatures(event.point, {
              layers: ['unclustered-point']
            });
            if (markerFeatures.length > 0) {
              handleMarkerClick(markerFeatures[0]);
              return;
            }
            const clusterFeatures = map.queryRenderedFeatures(event.point, {
              layers: ['clusters']
            });
            if (clusterFeatures.length > 0) {
              handleClusterClick(clusterFeatures[0]);
              return;
            }
            closeActivePopup(true);
          });
        }
        function setupHoverHandlers() {
          ['clusters', 'unclustered-point'].forEach(layerName => {
            map.on('mouseenter', layerName, () => {
              map.getCanvas().style.cursor = 'pointer';
            });
            map.on('mouseleave', layerName, () => {
              map.getCanvas().style.cursor = '';
            });
          });
        }
        map.on('load', () => {
          if (placeholder) placeholder.remove();
          map.addSource('markers', {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            },
            cluster: true,
            clusterMaxZoom: CONFIG.cluster.maxZoom,
            clusterRadius: CONFIG.cluster.radius
          });
          map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'markers',
            filter: ['has', 'point_count'],
            paint: {
              'circle-color': CONFIG.cluster.color,
              'circle-radius': CONFIG.cluster.circleRadius,
              'circle-stroke-width': 0
            }
          });
          map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'markers',
            filter: ['has', 'point_count'],
            layout: {
              'text-field': ['get', 'point_count_abbreviated'],
              'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
              'text-size': 14
            },
            paint: {
              'text-color': '#ffffff'
            }
          });
          map.addLayer({
            id: 'unclustered-point',
            type: 'symbol',
            source: 'markers',
            filter: ['!', ['has', 'point_count']],
            layout: {
              'icon-image': ['get', 'iconName'],
              'icon-size': CONFIG.marker.iconSize,
              'icon-allow-overlap': true,
              'icon-anchor': 'bottom'
            }
          });
          setupClickHandlers();
          setupHoverHandlers();
          setupAddressLinks();
          const firstActiveTab = wrapper.querySelector('.tabs-content.is-active[data-tab]') || wrapper.querySelector('.tabs-content[data-tab]');
          if (firstActiveTab) {
            loadCityOnMap(firstActiveTab, true);
          }
        });
        window.addEventListener(CONFIG.events.loadCity, function (event) {
          const tabContent = event.detail;
          if (tabContent) {
            loadCityOnMap(tabContent, false);
          }
        });
      });
    });
  }

  // ========================================================================
  // INITIALIZATION
  // ========================================================================

  initMapboxTabs();
  initMapboxContactMap();
})();
jQuery(document).ready(function ($) {
  function initModals() {
    $('[data-modal="modal"]').each(function () {
      var $section = $(this);
      var $modal = $section.find('[data-js="modal"]');
      var $slides = $modal.find('[data-js="modal-slide"]');
      var $close = $modal.find('[data-js="modal-close"]');
      var currentIndex = -1;

      // Open modal
      $section.find('[data-js="modal-open"]').on('click', function (e) {
        e.preventDefault();
        var id = $(this).data('modal-title').toString().trim();
        $modal.addClass('is-active');
        $('body').addClass('modal-open');
        var $target = $slides.filter(function () {
          var slideId = $(this).data('modal-title').toString().trim();
          return slideId === id;
        });
        currentIndex = $slides.index($target);
        if (currentIndex === -1) {
          $modal.removeClass('is-active');
          $('body').removeClass('modal-open');
          return;
        }
        showSlide(currentIndex);
      });

      // Close modal
      $close.on('click', function (e) {
        e.preventDefault();
        closeModal();
      });

      // Close on ESC
      $(document).on('keyup', function (e) {
        if (e.key === "Escape" && $modal.hasClass('is-active')) {
          closeModal();
        }
      });

      // Navigation
      $modal.on('click', '.modal__prev', function (e) {
        e.preventDefault();
        changeSlide('prev');
      });
      $modal.on('click', '.modal__next', function (e) {
        e.preventDefault();
        changeSlide('next');
      });

      // Helpers
      function showSlide(index) {
        $slides.removeClass('is-active');
        $slides.eq(index).addClass('is-active');
        updateNavButtons();
      }
      function changeSlide(direction) {
        if (direction === 'next' && currentIndex < $slides.length - 1) {
          currentIndex++;
          showSlide(currentIndex);
        } else if (direction === 'prev' && currentIndex > 0) {
          currentIndex--;
          showSlide(currentIndex);
        }
      }
      function updateNavButtons() {
        var $prevBtn = $modal.find('.modal__prev');
        var $nextBtn = $modal.find('.modal__next');
        $prevBtn.prop('disabled', currentIndex === 0);
        $nextBtn.prop('disabled', currentIndex === $slides.length - 1);
      }
      function closeModal() {
        $modal.removeClass('is-active');
        $slides.removeClass('is-active');
        $('body').removeClass('modal-open');
        currentIndex = -1;
      }
    });
  }
  initModals();
});
jQuery(document).ready(function ($) {
  // posts filter
  function postsFilter(number) {
    var page = 1;
    var categories = [];
    if (number) page = number;
    $('[data-js="post-category"].is-active:visible').each(function () {
      categories.push($(this).data('id'));
    });
    $('[data-js="post-listing"] .ajax').addClass('is-loading');
    $.ajax({
      url: novisaData.ajax_url,
      method: 'post',
      dataType: 'json',
      data: {
        action: 'load_posts',
        page: page,
        categories: categories,
        base: novisaData.page_url
      }
    }).success(function (data) {
      if (data.html) {
        $('[data-js="post-listing"] .ajax').html(data.html);
      }
      if ($('body').hasClass('ajax-pagination-clicked')) {
        $('html, body').animate({
          scrollTop: $('[data-js="post-listing"]').offset().top - $('.m-header').outerHeight()
        }, 500);
      }
      $('[data-js="post-listing"] .ajax').removeClass('is-loading');
      $('body').removeClass('ajax-pagination-clicked');
    }).error(function () {
      $('[data-js="post-listing"] .ajax').removeClass('is-loading');
      $('body').removeClass('ajax-pagination-clicked');
    });
  }

  // category filter
  $('[data-js="post-category"]').on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('is-active')) return;
    var categoryId = $(this).data('id');
    var targetUrl = $(this).attr('href');
    $('[data-js="post-category"]').removeClass('is-active');
    $(this).addClass('is-active');
    history.pushState({}, '', targetUrl);
    $('body').addClass('ajax-pagination-clicked');
    postsFilter();
  });

  // pagination
  $('body').on('click', '[data-js="post-pagination"] a', function (e) {
    e.preventDefault();
    var number = $(this).text();
    if ($(this).hasClass('next')) {
      number = $('[data-js="post-pagination"] .page-numbers.current').next().text();
    }
    if ($(this).hasClass('prev')) {
      number = $('[data-js="post-pagination"] .page-numbers.current').prev().text();
    }
    if (!$(this).hasClass('current')) {
      postsFilter(number);
    }
    var baseUrl = window.location.href.split('/page/')[0].replace(/\/$/, '');
    var pagedUrl = baseUrl + '/page/' + number + '/';
    history.pushState({}, '', pagedUrl);
    $('body').addClass('ajax-pagination-clicked');
  });
});
jQuery(document).ready(function ($) {
  const $post = $('.m-post');
  if ($post.length === 0) {
    return;
  }
  const distance = $post.height() + $post.offset().top - $(window).innerHeight();
  const progressBar = $('[data-js="progressbar"]');
  $(window).scroll(function (event) {
    const scrollY = $(window).scrollTop();
    const progress = scrollY / distance * 100;
    progressBar.css('width', `${progress}%`);
  });
});
jQuery(document).ready(function ($) {
  // Function to open property modal programmatically
  function openPropertyModal(voxId) {
    if (!voxId) {
      console.error('Missing vox_id parameter');
      return;
    }

    // Show loader overlay
    var $loader = $('<div class="m-property-modal-loader"><div class="m-property-modal-loader__spinner"></div></div>');
    $('body').append($loader);

    // Trigger loader overlay animation
    setTimeout(function () {
      $loader.addClass('is-active');
    }, 10);

    // AJAX request
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'novisa_load_property_modal',
        vox_id: voxId
      },
      success: function (response) {
        if (response.success && response.data.html) {
          // Remove loader
          $loader.remove();

          // Append modal to body
          var $modal = $(response.data.html);
          $('body').append($modal);

          // Clone and insert property form from footer template
          var $formTemplate = $('#property-form-template');
          var $formContainer = $modal.find('[data-js="property-modal-form"]');
          if ($formTemplate.length && $formContainer.length) {
            // Temporarily change IDs in template to avoid conflicts
            var originalIds = {};
            $formTemplate.find('[id]').each(function () {
              var $el = $(this);
              var oldId = $el.attr('id');
              var tempId = oldId + '-template-disabled';

              // Store original ID for restoration later
              originalIds[tempId] = oldId;

              // Update element ID
              $el.attr('id', tempId);

              // Update labels pointing to this ID
              $formTemplate.find('label[for="' + oldId + '"]').attr('for', tempId);

              // Update aria-describedby references
              $formTemplate.find('[aria-describedby="' + oldId + '"]').attr('aria-describedby', tempId);
            });

            // Store original IDs in modal data for restoration on close
            $modal.data('template-original-ids', originalIds);

            // Clone the HTML from template (now has modified IDs)
            var $clonedForm = $formTemplate.html();
            $formContainer.html($clonedForm);

            // Restore original IDs in cloned form
            $formContainer.find('[id]').each(function () {
              var $el = $(this);
              var tempId = $el.attr('id');
              var originalId = originalIds[tempId];
              if (originalId) {
                $el.attr('id', originalId);

                // Update labels
                $formContainer.find('label[for="' + tempId + '"]').attr('for', originalId);

                // Update aria-describedby
                $formContainer.find('[aria-describedby="' + tempId + '"]').attr('aria-describedby', originalId);
              }
            });

            // Get property number and investment name from modal
            var propertyNumber = $modal.find('[data-js="property-modal-property-number"]').text().trim();
            var investmentName = $modal.find('[data-js="property-modal-investment-name"]').text().trim();
            var propertyVoxId = $modal.data('vox-id');
            var investmentVoxId = $modal.data('investment-vox-id');

            // Replace {property} with actual property info in hidden fields and textareas
            if (propertyNumber) {
              $formContainer.find('input[type="hidden"]').each(function () {
                if ($(this).attr('value') === '{property}') {
                  $(this).attr('value', propertyNumber);
                }
              });
              $formContainer.find('textarea').each(function () {
                var currentValue = $(this).val();
                if (currentValue && currentValue.indexOf('{property}') !== -1) {
                  $(this).val(currentValue.replace(/{property}/g, propertyNumber));
                }
              });
            }

            // Replace {investment} with actual investment info in hidden fields
            if (investmentName) {
              $formContainer.find('input[type="hidden"]').each(function () {
                if ($(this).attr('value') === '{investment}') {
                  $(this).attr('value', investmentName);
                }
              });
            }

            // Replace property and investment vox_ids with actual vox_ids in hidden fields
            if (propertyVoxId) {
              $formContainer.find('input[type="hidden"]').each(function () {
                if ($(this).attr('value') === '{property_vox_id}') {
                  $(this).attr('value', propertyVoxId);
                }
              });
            }
            if (investmentVoxId) {
              $formContainer.find('input[type="hidden"]').each(function () {
                if ($(this).attr('value') === '{investment_vox_id}') {
                  $(this).attr('value', investmentVoxId);
                }
              });
            }

            // Wait a moment for DOM to settle, then initialize WPForms
            setTimeout(function () {
              var $wpform = $formContainer.find('.wpforms-form');
              if ($wpform.length && typeof wpforms !== 'undefined') {
                // Make sure template form won't be initialized
                var $templateForm = $('#property-form-template .wpforms-form');
                if ($templateForm.length) {
                  // Store original class and remove wpforms-form temporarily
                  $templateForm.data('original-class', $templateForm.attr('class'));
                  $templateForm.removeClass('wpforms-form');
                }

                // Initialize only the modal form (template doesn't have wpforms-form class now)
                if (typeof wpforms.init !== 'undefined') {
                  wpforms.init();
                }

                // Restore template form class after init
                if ($templateForm.length && $templateForm.data('original-class')) {
                  setTimeout(function () {
                    $templateForm.attr('class', $templateForm.data('original-class'));
                  }, 100);
                }
              }

              // // FIX CLOUDFLARE 600010: Czysty wjazd Turnstile (Zabijamy klona i pamięć jQuery)
              // var $oldTurnstile = $formContainer.find('.wpforms-turnstile');
              // if ($oldTurnstile.length && typeof turnstile !== 'undefined') {
              //     var sitekey = $oldTurnstile.attr('data-sitekey') || $oldTurnstile.data('sitekey');
              //     var action = $oldTurnstile.attr('data-action') || 'form';
              //     var theme = $oldTurnstile.data('theme') || 'auto';

              //     if (sitekey) {
              //         // 1. Tworzymy fizycznie nowy element HTML, żeby zabić stary cache wpforms i jQuery
              //         var $newTurnstile = $('<div class="wpforms-turnstile"></div>');
              //         $newTurnstile.attr('data-sitekey', sitekey);
              //         $newTurnstile.attr('data-action', action);
              //         $newTurnstile.attr('data-theme', theme);

              //         // Wymieniamy stary brudny element z nowym, czystym
              //         $oldTurnstile.replaceWith($newTurnstile);

              //         var $hiddenInput = $formContainer.find('.wpforms-recaptcha-hidden');
              //         if ($hiddenInput.length) {
              //             $hiddenInput.val('').removeClass('wpforms-error wpforms-valid').attr('aria-invalid', 'false');
              //         }

              //         try {
              //             // 2. Renderujemy czyste Turnstile
              //             var captchaID = turnstile.render($newTurnstile[0], {
              //                 sitekey: sitekey,
              //                 action: action,
              //                 theme: theme,
              //                 callback: function(token) {
              //                     if ($hiddenInput.length) {
              //                         $hiddenInput.val(token);
              //                         if (typeof $hiddenInput.valid === 'function') {
              //                             $hiddenInput.valid();
              //                         }
              //                     }
              //                 }
              //             });

              //             // 3. Krytyczne dla WPForms! Wpisujemy ID do atrybutu ORAZ do pamięci jQuery.
              //             // Inaczej WPForms.js przy błędzie spróbuje odpalić turnstile.reset() na starym ID.
              //             $newTurnstile.attr('data-recaptcha-id', captchaID);
              //             $newTurnstile.data('recaptcha-id', captchaID);
              //         } catch (e) {
              //             console.error('Turnstile init error:', e);
              //         }
              //     }
              // }

              // FIX CLOUDFLARE: Odtwarzanie widgetu przy wczytywaniu przez AJAX
              if (typeof turnstile !== 'undefined') {
                var $turnstileWidget = $formContainer.find('.wpforms-turnstile, .cf-turnstile');
                if ($turnstileWidget.length) {
                  var sitekey = $turnstileWidget.attr('data-sitekey') || $turnstileWidget.data('sitekey');

                  // 1. Zabezpieczenie! Upewnijmy się, że ID elementu jest absolutnie unikalne dla tego modala
                  var uniqueId = 'turnstile-modal-' + Date.now();
                  $turnstileWidget.attr('id', uniqueId);

                  // Czyścimy zawartość (pozostałości po ewentualnym klonowaniu)
                  $turnstileWidget.empty();
                  if (sitekey) {
                    try {
                      // 2. Oddajemy pełną kontrolę bibliotece
                      var widgetId = turnstile.render('#' + uniqueId, {
                        sitekey: sitekey,
                        theme: $turnstileWidget.attr('data-theme') || 'auto',
                        callback: function (token) {
                          // Kiedy Token wróci pomyślnie, wstrzykujemy go do ukrytego pola WPForms
                          var $hiddenInput = $formContainer.find('input[name="wpforms[recaptcha]"], .wpforms-recaptcha-hidden');
                          if ($hiddenInput.length) {
                            $hiddenInput.val(token).trigger('change');
                          }
                        }
                      });

                      // Zapisujemy prawdziwe ID wygenerowane przez Cloudflare na divie
                      $turnstileWidget.attr('data-turnstile-id', widgetId);
                    } catch (e) {
                      console.error('Błąd inicjalizacji Turnstile w Modalu:', e);
                    }
                  }
                }
              }
            }, 50);
          }

          // Show modal
          $modal.addClass('is-active');

          // Save scroll position and prevent body scroll
          var scrollTop = $(window).scrollTop();
          $('html').addClass('has-property-modal-open');
          $('body').data('scroll-position', scrollTop);
          $('body').addClass('property-modal-open').css('top', -scrollTop + 'px');

          // Update URL based on property type
          if (response.data.investment_permalink) {
            var hashValue = '';

            // For residential properties: use local_number in hash
            if (response.data.property_type === 'residential' && response.data.local_number) {
              hashValue = response.data.local_number;
            }
            // For commercial properties: use vox_id in hash
            else if (response.data.property_type === 'commercial' && response.data.vox_id) {
              hashValue = response.data.vox_id;
            }
            if (hashValue) {
              var newUrl = response.data.investment_permalink + '#' + hashValue;

              // Save current URL to restore it later (only if not already saved)
              if (!$('body').data('modal-previous-url')) {
                $('body').data('modal-previous-url', window.location.href);
              }

              // Update URL without page reload
              history.pushState({
                modalOpen: true
              }, '', newUrl);
            }
          }

          // Initialize tippy.js tooltips for new modal content
          tippy($modal.find('[data-tippy-content]:not([data-tooltip="price-history"]):not([data-tooltip="energy-class"])').get(), {
            allowHTML: true,
            theme: 'light',
            animation: 'shift-away',
            zIndex: 110
          });
          var priceHistoryTooltipPlacement = 'right';
          if (window.innerWidth <= 1024) {
            priceHistoryTooltipPlacement = 'top';
          }
          tippy($modal.find('[data-tooltip="price-history"]').get(), {
            allowHTML: true,
            theme: 'light',
            animation: 'shift-away',
            zIndex: 110,
            placement: priceHistoryTooltipPlacement,
            maxWidth: 'none'
          });
          var energyClassTooltipPlacement = 'right-end';
          if (window.innerWidth <= 1024) {
            energyClassTooltipPlacement = 'top';
          }
          tippy($modal.find('[data-tooltip="energy-class"]').get(), {
            allowHTML: true,
            theme: 'light',
            animation: 'shift-away',
            zIndex: 110,
            placement: energyClassTooltipPlacement,
            maxWidth: 'none'
          });

          // Initialize Fancybox for new modal content
          Fancybox.bind($modal[0], "[data-fancybox]", {
            Hash: false,
            hideScrollbar: false
          });

          // Activate favorite button
          favoritePropertiesActivateButtons();

          // Trigger custom event for property modal opened
          $(document).trigger('propertyModalOpened', [voxId]);
        } else {
          $loader.remove();
        }
      },
      error: function (xhr, status, error) {
        $loader.remove();
      }
    });
  }

  // Open property modal via click on property-link elements
  $(document).on('click', '[data-js="property-link"]', function (e) {
    e.preventDefault();
    var voxId = $(this).data('vox-id');
    openPropertyModal(voxId);
  });
  $(document).on('click', '[data-js="property-link-tooltip"]', function (e) {
    e.preventDefault();
    var voxId = $(this).data('vox-id');
    if (window.innerWidth > 1199) {
      openPropertyModal(voxId);
    }
  });

  // Close property modal
  $(document).on('click', '[data-js="property-modal-close"]', function () {
    var $modal = $(this).closest('[data-js="property-modal"]');
    if ($modal.length) {
      // // FIX: Zniszczenie instancji Turnstile za pomocą jQuery DATA
      // var $turnstileEl = $modal.find('.wpforms-turnstile');
      // if ($turnstileEl.length && typeof turnstile !== 'undefined') {
      //     var widgetId = $turnstileEl.data('recaptcha-id') || $turnstileEl.attr('data-recaptcha-id');
      //     if (widgetId) {
      //         try { turnstile.remove(widgetId); } catch(e) {}
      //     }
      // }
      // Zabezpieczenie przed wyciekami Turnstile
      if (typeof turnstile !== 'undefined') {
        var $turnstileEl = $modal.find('.wpforms-turnstile, .cf-turnstile');
        if ($turnstileEl.length) {
          var widgetId = $turnstileEl.attr('data-turnstile-id');
          if (widgetId) {
            try {
              turnstile.remove(widgetId);
            } catch (e) {
              console.error('Nie można zniszczyć Turnstile:', e);
            }
          }
          $turnstileEl.empty();
        }
      }

      // Restore original IDs in template
      var originalIds = $modal.data('template-original-ids');
      if (originalIds) {
        var $formTemplate = $('#property-form-template');
        $formTemplate.find('[id]').each(function () {
          var $el = $(this);
          var tempId = $el.attr('id');
          var originalId = originalIds[tempId];
          if (originalId) {
            $el.attr('id', originalId);

            // Update labels
            $formTemplate.find('label[for="' + tempId + '"]').attr('for', originalId);

            // Update aria-describedby
            $formTemplate.find('[aria-describedby="' + tempId + '"]').attr('aria-describedby', originalId);
          }
        });
      }

      // Re-enable body scroll and restore scroll position immediately
      var scrollTop = $('body').data('scroll-position') || 0;
      $('html').removeClass('has-property-modal-open');
      $('body').removeClass('property-modal-open').css('top', '');
      $(window).scrollTop(scrollTop);

      // Check if modal was opened from hash
      var openedFromHash = $('body').data('modal-opened-from-hash');

      // Restore previous URL if it was saved
      var previousUrl = $('body').data('modal-previous-url');
      if (previousUrl) {
        // If opened from hash, remove the hash from URL
        if (openedFromHash) {
          var urlWithoutHash = previousUrl.split('#')[0];
          history.pushState({
            modalOpen: false
          }, '', urlWithoutHash);
        } else {
          history.pushState({
            modalOpen: false
          }, '', previousUrl);
        }
        $('body').removeData('modal-previous-url');
      }

      // Clear hash flag
      $('body').removeData('modal-opened-from-hash');

      // Hide modal with animation
      $modal.removeClass('is-active');

      // Remove modal from DOM after animation
      setTimeout(function () {
        $modal.remove();
      }, 300);
    }
  });

  // Tabs
  $(document).on('click', '[data-js="property-modal-tab-button"]', function () {
    if ($(this).hasClass('is-active')) {
      return;
    }
    var tab = $(this).data('tab');
    var $propertyCard = $(this).parents('[data-js="property-modal"]');

    // Pause all YouTube videos in modal before switching tabs
    $propertyCard.find('iframe[src*="youtube.com"], iframe[src*="youtube-nocookie.com"]').each(function () {
      var iframe = this;
      var src = iframe.src;

      // Check if iframe has enablejsapi parameter (required for postMessage)
      if (src.indexOf('enablejsapi=1') !== -1) {
        // Send pause command via postMessage API
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    });
    $propertyCard.find('[data-js="property-modal-tab-button"]').not(this).removeClass('is-active');
    $(this).addClass('is-active');
    $propertyCard.find('[data-js="property-modal-tab"]').removeClass('is-active');
    $propertyCard.find('[data-js="property-modal-tab"][data-tab="' + tab + '"]').addClass('is-active');
  });

  // Plan Images
  $(document).on('click', '[data-js="property-modal-plan-button"]', function () {
    if ($(this).hasClass('is-active')) {
      return;
    }
    var floor = $(this).data('floor');
    var $propertyCard = $(this).parents('[data-js="property-modal"]');
    $propertyCard.find('[data-js="property-modal-plan-button"]').not(this).removeClass('is-active');
    $(this).addClass('is-active');
    $propertyCard.find('[data-js="property-modal-plan-image"]').removeClass('is-active');
    $propertyCard.find('[data-js="property-modal-plan-image"][data-floor="' + floor + '"]').addClass('is-active');
  });

  // Form Button
  $(document).on('click', '[data-js="property-modal-form-button"]', function () {
    var $propertyCard = $(this).parents('[data-js="property-modal"]');
    var $scrollContainer = $propertyCard.find('.m-property-modal__content');
    var $form = $propertyCard.find('[data-js="property-modal-form-container"]');
    if ($form.length && $scrollContainer.length) {
      // Calculate the position of the form relative to the scroll container
      var formTop = $form.offset().top;
      var containerTop = $scrollContainer.offset().top;
      var scrollTop = $scrollContainer.scrollTop();
      var targetScroll = formTop - containerTop + scrollTop;

      // Smooth scroll to the form
      $scrollContainer.animate({
        scrollTop: targetScroll
      }, 1000);
    }
  });

  // Handle browser back/forward button
  $(window).on('popstate', function (e) {
    var $modal = $('[data-js="property-modal"]');

    // If modal is open and user pressed back button, close it
    if ($modal.length && $modal.hasClass('is-active')) {
      // // FIX: Zniszczenie Turnstile dla przycisku Wstecz w przeglądarce
      // var $turnstileEl = $modal.find('.wpforms-turnstile');
      // if ($turnstileEl.length && typeof turnstile !== 'undefined') {
      //     var widgetId = $turnstileEl.data('recaptcha-id') || $turnstileEl.attr('data-recaptcha-id');
      //     if (widgetId) {
      //         try { turnstile.remove(widgetId); } catch(e) {}
      //     }
      // }
      // Zabezpieczenie przed wyciekami Turnstile (Wstecz)
      if (typeof turnstile !== 'undefined') {
        var $turnstileEl = $modal.find('.wpforms-turnstile, .cf-turnstile');
        if ($turnstileEl.length) {
          var widgetId = $turnstileEl.attr('data-turnstile-id');
          if (widgetId) {
            try {
              turnstile.remove(widgetId);
            } catch (e) {
              console.error('Nie można zniszczyć Turnstile:', e);
            }
          }
          $turnstileEl.empty();
        }
      }

      // Restore original IDs in template
      var originalIds = $modal.data('template-original-ids');
      if (originalIds) {
        var $formTemplate = $('#property-form-template');
        $formTemplate.find('[id]').each(function () {
          var $el = $(this);
          var tempId = $el.attr('id');
          var originalId = originalIds[tempId];
          if (originalId) {
            $el.attr('id', originalId);

            // Update labels
            $formTemplate.find('label[for="' + tempId + '"]').attr('for', originalId);

            // Update aria-describedby
            $formTemplate.find('[aria-describedby="' + tempId + '"]').attr('aria-describedby', originalId);
          }
        });
      }

      // Re-enable body scroll and restore scroll position
      var scrollTop = $('body').data('scroll-position') || 0;
      $('html').removeClass('has-property-modal-open');
      $('body').removeClass('property-modal-open').css('top', '');
      $(window).scrollTop(scrollTop);

      // Clear saved URL and flags
      $('body').removeData('modal-previous-url');
      $('body').removeData('modal-opened-from-hash');

      // Hide and remove modal
      $modal.removeClass('is-active');
      setTimeout(function () {
        $modal.remove();
      }, 300);
    }
  });

  // Check URL hash on page load and open modal if hash matches property number
  function checkHashAndOpenModal() {
    var hash = window.location.hash;
    if (hash) {
      var hashValue = hash.substring(1);

      // Check if we're on commercial properties page
      var isCommercialPage = $('form[data-search-mode="commercial-properties"]').length > 0;

      // For commercial properties: hash is vox_id (only digits)
      if (isCommercialPage && /^[0-9]+$/.test(hashValue)) {
        $('body').data('modal-opened-from-hash', true);
        openPropertyModal(hashValue);
      }
      // For residential properties: hash is local_number (e.g. "20", "20B", "H34", "A12")
      // Check if we have investment ID (indicates we're on an investment page)
      else if (typeof novisaData !== 'undefined' && novisaData.investment_id && /^[A-Za-z]?[0-9]+[A-Za-z]?$/.test(hashValue)) {
        // Get vox_id via AJAX based on local_number and investment_id
        $.ajax({
          url: novisaData.ajax_url,
          type: 'POST',
          data: {
            action: 'novisa_get_vox_id_by_local_number',
            local_number: hashValue,
            investment_post_id: novisaData.investment_id
          },
          success: function (response) {
            if (response.success && response.data.vox_id) {
              $('body').data('modal-opened-from-hash', true);
              openPropertyModal(response.data.vox_id);
            }
          },
          error: function () {}
        });
      }
    }
  }

  // Run hash check on page load
  checkHashAndOpenModal();

  // Expose function globally for testing
  window.openPropertyModal = openPropertyModal;
});
jQuery(document).ready(function ($) {
  // Range sliders (2 handles)
  function initRangeSliders() {
    $('[data-range-slider]').each(function () {
      var $field = $(this);
      var sliderEl = $field.find('.slider')[0];
      var $minOutput = $field.find('.value-min');
      var $maxOutput = $field.find('.value-max');
      var $minInput = $field.find('.input-min');
      var $maxInput = $field.find('.input-max');
      var min = $field.data('min');
      var max = $field.data('max');
      var startMin = $field.data('start-min') || min;
      var startMax = $field.data('start-max') || max;
      var suffix = $field.data('suffix') || '';
      var step = $field.data('step') || 1;
      noUiSlider.create(sliderEl, {
        start: [startMin, startMax],
        connect: true,
        range: {
          'min': min,
          'max': max
        },
        step: step,
        format: {
          to: function (value) {
            return Math.round(value);
          },
          from: function (value) {
            return Math.round(value);
          }
        }
      });
      sliderEl.noUiSlider.on('update', function (values) {
        var valMin = Math.round(values[0]);
        var valMax = Math.round(values[1]);
        $minOutput.text(valMin.toLocaleString('pl-PL') + suffix);
        $maxOutput.text(valMax.toLocaleString('pl-PL') + suffix);
        $minInput.val(valMin);
        $maxInput.val(valMax);
      });
    });
  }

  // Single sliders (1 handle)
  function initSingleSliders() {
    $('[data-slider-single]').each(function () {
      var $field = $(this);

      // Skip sliders inside u-card-calculator (handled by _loan-calculator.js)
      if ($field.closest('.u-card-calculator').length > 0) {
        return;
      }
      var sliderEl = $field.find('.slider')[0];
      var $output = $field.find('.input-value');
      var min = parseFloat($field.data('min'));
      var max = parseFloat($field.data('max'));
      var step = parseFloat($field.data('step')) || 1;
      var suffix = $field.data('suffix') || '';
      var start = $field.data('start') ? parseFloat($field.data('start')) : parseFloat($output.val()) || min;
      noUiSlider.create(sliderEl, {
        start: [start],
        connect: [true, false],
        range: {
          'min': min,
          'max': max
        },
        step: step
      });
      sliderEl.noUiSlider.set(start);
      $output.val(start.toFixed(step < 1 ? 1 : 0));

      // slider -> input
      sliderEl.noUiSlider.on('update', function (values) {
        var val = parseFloat(values[0]);
        $output.val(val.toFixed(step < 1 ? 1 : 0));
        $output.next('.unit').text(suffix);
        calculateLoan();
      });

      // input -> slider
      $output.on('input', function () {
        sliderEl.noUiSlider.set($(this).val());
        calculateLoan();
      });
    });
  }

  // Calculate loan payment
  function calculateLoan() {
    var amount = parseFloat($('.filter-field[data-suffix*="zł"] .input-value').val()) || 0;
    var years = parseFloat($('.filter-field[data-suffix*="lat"] .input-value').val()) || 0;
    var rateYear = parseFloat($('.filter-field[data-suffix*="%"] .input-value').val()) || 0;
    var monthlyRate = rateYear / 100 / 12;
    var n = years * 12;
    var payment = 0;
    if (monthlyRate > 0) {
      payment = amount * monthlyRate / (1 - Math.pow(1 + monthlyRate, -n));
    } else {
      payment = amount / n;
    }
    var formatted = payment.toLocaleString('pl-PL', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    $('[data-js="result"]').text(formatted + ' zł');
  }

  // Toggle rate type buttons
  function initRateTypeButtons() {
    $('[data-js="rate-type"] .button').on('click', function () {
      $(this).addClass('is-active').siblings().removeClass('is-active');
      calculateLoan();
    });
  }

  // Initialize
  function initCalculator() {
    initRangeSliders();
    initSingleSliders();
    initRateTypeButtons();
    calculateLoan();
  }
  initCalculator();
});
jQuery(document).ready(function ($) {
  /* YouTube */
  $('[data-js="reels-youtube"]').each(function () {
    $(this).on('click', function (e) {
      e.preventDefault();
      var youtubeUrl = $(this).attr('href');
      Fancybox.show([{
        src: youtubeUrl,
        type: 'youtube',
        autoplay: 1,
        nocookie: 0,
        controls: 0,
        fs: 1,
        vq: 'hd1080',
        hd: 1,
        quality: 'hd1080'
      }], {
        mainClass: 'youtube-embed',
        contentPadding: 0,
        l10n: novisaData.i18n.fancybox
      });
    });
  });

  /* Instagram */
  $('[data-js="reels-instagram"]').each(function () {
    $(this).on('click', function (e) {
      e.preventDefault();
      var instagramUrl = $(this).attr('href');

      // Convert Instagram URL to embed URL
      // Example: https://www.instagram.com/reel/DQwn6L3jDBk/ -> https://www.instagram.com/reel/DQwn6L3jDBk/embed
      var embedUrl = instagramUrl;
      if (instagramUrl && instagramUrl !== '#') {
        // Remove query parameters and ensure proper embed format
        embedUrl = instagramUrl.split('?')[0];
        if (!embedUrl.endsWith('/')) {
          embedUrl += '/';
        }
        if (!embedUrl.endsWith('/embed/')) {
          embedUrl += 'embed/';
        }
      }
      Fancybox.show([{
        src: embedUrl,
        type: 'iframe',
        width: 540,
        height: 700
      }], {
        mainClass: 'instagram-embed',
        contentPadding: 0,
        l10n: novisaData.i18n.fancybox
      });
    });
  });
});
jQuery(document).ready(function ($) {
  function getRegionInvestmentLinks($section) {
    let links = $section.data('regionInvestmentLinks');
    if (links) {
      return links;
    }
    const rawLinks = $section.attr('data-region-investment-links');
    if (!rawLinks) {
      return {};
    }
    try {
      links = JSON.parse(rawLinks);
    } catch (error) {
      links = {};
    }
    $section.data('regionInvestmentLinks', links);
    return links;
  }
  function setRegionFallbackNoticeState($notice, show, url) {
    const $link = $notice.find('[data-js="region-fallback-link"]');
    if ($link.length) {
      if (url) {
        $link.attr('href', url).removeClass('is-hidden');
      } else {
        $link.addClass('is-hidden');
      }
    }
    if (show) {
      $notice.removeClass('is-hidden');
    } else {
      $notice.addClass('is-hidden');
    }
  }
  function updateRegionFallbackNoticeFromServer($section, data) {
    const $notice = $section.find('[data-js="region-fallback-notice"]');
    if (!$notice.length) {
      return;
    }
    setRegionFallbackNoticeState($notice, !!data.region_fallback, data.region_investment_url || '');
  }
  function updateRegionFallbackNotice($section, region) {
    const $notice = $section.find('[data-js="region-fallback-notice"]');
    if (!$notice.length) {
      return;
    }
    const hasRegionTab = region && $section.find('[data-regionalization="' + region + '"]').length > 0;
    if (!region || hasRegionTab) {
      setRegionFallbackNoticeState($notice, false);
      return;
    }
    const links = getRegionInvestmentLinks($section);
    const url = links[region] || '';
    setRegionFallbackNoticeState($notice, true, url);
  }
  if ($('[data-region-fallback-module]').length) {
    $(document).on('novisa:region-changed', function (event, region) {
      $('[data-region-fallback-module]').each(function () {
        const $section = $(this);

        // Properties list updates notice after AJAX filtering completes.
        if ($section.is('[data-js="properties-list"]')) {
          return;
        }
        updateRegionFallbackNotice($section, region);
      });
    });
    $(document).on('novisa:properties-list-filtered', function (event, data) {
      $('[data-js="properties-list"][data-region-fallback-module]').each(function () {
        updateRegionFallbackNoticeFromServer($(this), data);
      });
    });
  }
});

// ============================================================================
// REGIONALIZATION MANAGER
// Manages region selection across the site with cookie persistence
// 
// Architecture:
// - PHP renders correct region based on cookie (WP Rocket cache variations)
// - JS only handles user interactions to switch regions
// - Cookie is used by both PHP (server-side) and JS (client-side)
//
// Usage:
// 1. Add data-regionalization="region-slug" to elements you want to auto-trigger click
// 2. Phone number updates automatically via data-js="regional-phone"
// 3. Switcher uses data-region="region-slug" to define available regions
//
// Examples:
// Click trigger:
// <button data-js="tab-button" 
//         data-tab="warszawa" 
//         data-regionalization="warszawa">Warszawa</button>
//
// Phone replacement:
// <a data-js="regional-phone" 
//    data-regional-phones='{"warszawa":{"number":"123456789","link":"123456789"}}'>
// ============================================================================

jQuery(document).ready(function ($) {
  // ========================================================================
  // CONFIGURATION
  // ========================================================================

  const CONFIG = {
    cookieName: 'novisa_region',
    cookieDays: 90,
    selectors: {
      // Main switcher button
      switcherButton: '[data-js="regionalization-switcher-button"]',
      // Switcher link
      switcherLink: '[data-js="regionalization-switcher-link"]',
      // Elements with data-regionalization="region-slug" will be triggered
      clickTargets: '[data-regionalization]'
    }
  };

  // ========================================================================
  // REGIONALIZATION MANAGER
  // ========================================================================

  const RegionalizationManager = {
    _currentRegion: null,
    _isChanging: false,
    /**
     * Initialize regionalization system
     */
    init: function () {
      // Check if Cookies library is available
      if (typeof Cookies === 'undefined') {
        console.warn('Cookies library (js-cookie) is not loaded');
        return;
      }

      // Setup click handlers for switcher buttons
      this._setupClickHandlers();

      // Note: PHP already renders the correct region based on cookie
      // JS only handles user interactions to switch regions
    },
    /**
     * Setup click handlers for switcher buttons
     */
    _setupClickHandlers: function () {
      const self = this;

      // Handler for switcher buttons (full functionality)
      $(document).on('click', CONFIG.selectors.switcherButton, function (event) {
        event.preventDefault();
        const $button = $(this);
        const region = $button.data('region');

        // Skip if currently changing
        if (self._isChanging) {
          return;
        }

        // If clicking already active region, clear it (toggle off)
        if ($button.hasClass('is-active')) {
          self.clearRegion();
          return;
        }
        self.setRegion(region);
      });

      // Handler for switcher links (only set cookie, then allow navigation)
      $(document).on('click', CONFIG.selectors.switcherLink, function (event) {
        const $link = $(this);
        const region = $link.data('region');
        if (!region) {
          return;
        }

        // Set cookie, then allow link to navigate normally
        Cookies.set(CONFIG.cookieName, region, {
          expires: CONFIG.cookieDays,
          sameSite: 'lax'
        });

        // Store current region for reference
        self._currentRegion = region;
      });
      $(document).on('click', CONFIG.selectors.clickTargets, function (event) {
        const $target = $(this);
        const regionalization = $target.data('regionalization');

        // Check if this is a user click or programmatic trigger
        const isUserClick = !event.isTrigger;

        // Skip if no regionalization data or it's a "default" option
        if (!regionalization || regionalization === 'default') {
          // Clear regionalization when "default" is clicked BY USER (not programmatically)
          if (regionalization === 'default' && self._currentRegion && isUserClick) {
            Cookies.remove(CONFIG.cookieName);
            self._currentRegion = null;
            $(CONFIG.selectors.switcherButton).removeClass('is-active');
            self._updateRegionalPhoneToDefault();
            self._emitRegionChanged(null);
          }
          return;
        }

        // Check if this region exists in switcher buttons
        const $matchingButton = $(CONFIG.selectors.switcherButton + '[data-region="' + regionalization + '"]');
        const regionExistsInSwitcher = $matchingButton.length > 0;
        if (regionExistsInSwitcher) {
          // Skip updating cookie and switcher only if programmatically triggered during clearRegion/setRegion
          // Allow updates for direct user clicks
          if (!self._isChanging || isUserClick) {
            // Region exists - update cookie and UI
            Cookies.set(CONFIG.cookieName, regionalization, {
              expires: CONFIG.cookieDays,
              sameSite: 'lax'
            });

            // Store current region
            self._currentRegion = regionalization;

            // Update switcher buttons UI (mark corresponding button as active)
            $(CONFIG.selectors.switcherButton).removeClass('is-active');
            $matchingButton.addClass('is-active');

            // Update phone number for this region
            self._updateRegionalPhone(regionalization);

            // Notify other modules about the region change
            self._emitRegionChanged(regionalization);
          }
        } else {
          // Region doesn't exist in switcher - use default phone
          self._updateRegionalPhoneToDefault();
        }
      });
    },
    /**
     * Set active region and trigger all related elements
     * @param {string} region - Region identifier (slug)
     */
    setRegion: function (region) {
      // Prevent circular calls
      if (this._isChanging) {
        return;
      }
      this._isChanging = true;
      this._currentRegion = region;

      // Save to cookie
      Cookies.set(CONFIG.cookieName, region, {
        expires: CONFIG.cookieDays,
        sameSite: 'lax'
      });

      // Update switcher buttons UI
      $(CONFIG.selectors.switcherButton).removeClass('is-active');

      // Add class in next tick to ensure all other DOM operations complete first
      const $targetSwitcher = $(CONFIG.selectors.switcherButton + '[data-region="' + region + '"]');
      setTimeout(() => {
        $targetSwitcher.addClass('is-active');
      }, 0);

      // Trigger click on all elements with matching data-regionalization attribute
      const $targets = $('[data-regionalization="' + region + '"]');
      if ($targets.length) {
        $targets.each(function () {
          const $target = $(this);
          // Trigger click only if not already active
          if (!$target.hasClass('is-active')) {
            $target.trigger('click');
          }
        });
      }

      // Find groups where selected region doesn't exist and trigger default
      this._triggerDefaultForMissingRegion(region);

      // Update phone number/link if regional phone element exists
      this._updateRegionalPhone(region);

      // Notify other modules about the region change
      this._emitRegionChanged(region);

      // Reset flag after short delay
      setTimeout(() => {
        this._isChanging = false;
      }, 100);
    },
    /**
     * Clear region selection and trigger all defaults
     */
    clearRegion: function () {
      // Prevent circular calls
      if (this._isChanging) {
        return;
      }
      this._isChanging = true;
      this._currentRegion = null;

      // Remove cookie
      Cookies.remove(CONFIG.cookieName);

      // Remove active class from all switcher buttons
      $(CONFIG.selectors.switcherButton).removeClass('is-active');

      // Find all containers with regionalization buttons
      this._triggerDefaultsOrFirstButtons();

      // Update phone number/link to default (first one)
      this._updateRegionalPhoneToDefault();

      // Notify other modules about the region change
      this._emitRegionChanged(null);

      // Reset flag after short delay
      setTimeout(() => {
        this._isChanging = false;
      }, 100);
    },
    /**
     * Trigger default buttons or first button in each container
     * Handles modules with/without "default" button
     */
    _triggerDefaultsOrFirstButtons: function () {
      // Find all unique containers that have regionalization buttons
      const containers = new Set();
      $('[data-regionalization]').each(function () {
        const $button = $(this);
        const $container = $button.parent().closest('ul, section[data-js], div[data-js], .u-dropdown, .tabs-navigation').first();
        if ($container.length) {
          containers.add($container[0]);
        }
      });

      // For each container, trigger default or first button
      containers.forEach(function (container) {
        const $container = $(container);

        // Check if container has a default button
        const $default = $container.find('[data-regionalization="default"]');
        if ($default.length) {
          // Has default button - trigger it
          if (!$default.hasClass('is-active')) {
            $default.trigger('click');
          }
        } else {
          // No default button - trigger first regionalization button
          const $firstButton = $container.find('[data-regionalization]').first();
          if ($firstButton.length && !$firstButton.hasClass('is-active')) {
            $firstButton.trigger('click');
          }
        }
      });
    },
    /**
     * Trigger default elements in groups where selected region doesn't exist
     * @param {string} region - Region identifier
     */
    _triggerDefaultForMissingRegion: function (region) {
      // Find all elements with data-regionalization="default"
      const $defaults = $('[data-regionalization="default"]');
      if (!$defaults.length) return;
      $defaults.each(function () {
        const $default = $(this);

        // Find the closest common container (parent ul or section/div with data-js)
        // Start from parent to avoid matching the button itself
        const $container = $default.parent().closest('ul, section[data-js], div[data-js], .u-dropdown').first();
        if (!$container.length) return;

        // Check if this container has an element with the selected region
        const $regionInContainer = $container.find('[data-regionalization="' + region + '"]');

        // If region doesn't exist in this container, trigger default
        if (!$regionInContainer.length) {
          // Trigger click only if not already active
          if (!$default.hasClass('is-active')) {
            $default.trigger('click');
          }
        }
      });
    },
    /**
     * Update regional phone number/link
     * Works for both header (with number) and footer (link only)
     * @param {string} region - Region identifier
     */
    _updateRegionalPhone: function (region) {
      const $phoneElements = $('[data-js="regional-phone"]');
      if (!$phoneElements.length) return;
      $phoneElements.each(function () {
        const $phoneElement = $(this);
        try {
          const regionalPhones = $phoneElement.data('regional-phones');
          if (!regionalPhones || !regionalPhones[region]) {
            console.warn('No phone data for region:', region);
            return;
          }
          const phoneData = regionalPhones[region];

          // Update href (always)
          $phoneElement.attr('href', 'tel:' + phoneData.link);

          // Update number if element has it (header only)
          const $number = $phoneElement.find('[data-js="regional-phone-number"]');
          if ($number.length && phoneData.number) {
            $number.text(phoneData.number);
          }
        } catch (error) {
          console.error('Error updating regional phone:', error);
        }
      });
    },
    /**
     * Update phone number/link to default (first one in the list)
     */
    _updateRegionalPhoneToDefault: function () {
      const $phoneElements = $('[data-js="regional-phone"]');
      if (!$phoneElements.length) return;
      $phoneElements.each(function () {
        const $phoneElement = $(this);
        try {
          const regionalPhones = $phoneElement.data('regional-phones');
          if (!regionalPhones) return;

          // Get first region's phone (default)
          const firstRegion = Object.keys(regionalPhones)[0];
          if (firstRegion && regionalPhones[firstRegion]) {
            const phoneData = regionalPhones[firstRegion];

            // Update href (always)
            $phoneElement.attr('href', 'tel:' + phoneData.link);

            // Update number if element has it (header only)
            const $number = $phoneElement.find('[data-js="regional-phone-number"]');
            if ($number.length && phoneData.number) {
              $number.text(phoneData.number);
            }
          }
        } catch (error) {
          console.error('Error updating regional phone to default:', error);
        }
      });
    },
    /**
     * Get current region
     */
    getCurrentRegion: function () {
      return this._currentRegion;
    },
    /**
     * Notify other modules that the active region changed.
     * Modules can listen to 'novisa:region-changed' on document to react
     * regardless of which control triggered the change.
     * @param {string|null} region - Region slug, or null when cleared/default.
     */
    _emitRegionChanged: function (region) {
      $(document).trigger('novisa:region-changed', [region || null]);
    }
  };

  // ========================================================================
  // INITIALIZATION
  // ========================================================================

  RegionalizationManager.init();

  // Export for external use if needed
  window.NovisaRegionalization = RegionalizationManager;
});
jQuery(document).ready(function ($) {
  const $forms = $('[data-js="search-form"]');
  const $dropdowns = $forms.find('[data-js="search-form-dropdown"]');
  let isUpdating = false; // Flag to prevent infinite loops
  let currentXhr = null; // Store current AJAX request to allow aborting
  let skipRangeUpdate = false; // Flag to skip range slider updates after AJAX (when already adjusted before AJAX)

  // Helper function to get search mode from form
  function getSearchMode() {
    return $forms.first().data('search-mode') || 'properties';
  }

  // Function to update URL with current filter parameters
  function updateURL() {
    // Check if dynamic URL updates are disabled for this form
    if ($forms.data('dynamic-url') === false) {
      return; // Skip URL update
    }
    const cityId = $forms.find('input[name="city_id"]').val();
    const agglomerationId = $forms.find('input[name="agglomeration_id"]').val();
    const investmentId = $forms.find('input[name="investment_id"]').val();
    const typeId = $forms.find('input[name="type_id"]').val();
    const transactionType = $('[data-js="transaction-type-input"]').val() || $forms.find('input[name="transaction_type"]').val();
    const priceMin = $forms.find('input[name="price_min"]').val();
    const priceMax = $forms.find('input[name="price_max"]').val();
    const areaMin = $forms.find('input[name="area_min"]').val();
    const areaMax = $forms.find('input[name="area_max"]').val();
    const roomsMin = $forms.find('input[name="rooms_min"]').val();
    const roomsMax = $forms.find('input[name="rooms_max"]').val();
    const page = $('[data-js="page-input"]').val();

    // Build URL parameters - include all filters like form submission
    const params = new URLSearchParams();

    // Always add these parameters (including "all" values)
    if (cityId) {
      params.set('city_id', cityId);
    }
    if (agglomerationId) {
      params.set('agglomeration_id', agglomerationId);
    }
    if (investmentId) {
      params.set('investment_id', investmentId);
    }
    if (typeId) {
      params.set('type_id', typeId);
    }
    // For commercial properties, always include transaction_type (including 'all')
    // For other modes, only include if not 'all'
    const searchMode = getSearchMode();
    if (transactionType) {
      if (searchMode === 'commercial-properties' || transactionType !== 'all') {
        params.set('transaction_type', transactionType);
      }
    }
    if (page && page > 1) {
      params.set('page_number', page);
    }

    // Add range parameters if they have values
    if (priceMin && priceMin !== '') {
      params.set('price_min', priceMin);
    }
    if (priceMax && priceMax !== '') {
      params.set('price_max', priceMax);
    }
    if (areaMin && areaMin !== '') {
      params.set('area_min', areaMin);
    }
    if (areaMax && areaMax !== '') {
      params.set('area_max', areaMax);
    }
    if (roomsMin && roomsMin !== '') {
      params.set('rooms_min', roomsMin);
    }
    if (roomsMax && roomsMax !== '') {
      params.set('rooms_max', roomsMax);
    }

    // Build new URL
    const baseUrl = window.location.pathname;
    const newUrl = params.toString() ? baseUrl + '?' + params.toString() : baseUrl;

    // Update URL without page reload
    window.history.pushState({
      filters: true
    }, '', newUrl);
  }

  // Function to update filter ranges via AJAX
  // changedFilter parameter indicates which filter triggered the update (to avoid circular updates)
  function updateFilterRanges(changedFilter) {
    if (isUpdating) return;
    isUpdating = true;

    // Abort previous AJAX request if still running
    if (currentXhr && currentXhr.readyState !== 4) {
      currentXhr.abort();
    }
    const cityId = $forms.find('input[name="city_id"]').val();
    const agglomerationId = $forms.find('input[name="agglomeration_id"]').val();
    const investmentId = $forms.find('input[name="investment_id"]').val();
    const typeId = $forms.find('input[name="type_id"]').val();

    // Add loading class to form
    $forms.addClass('is-loading');

    // Get search mode dynamically from form
    const searchMode = getSearchMode();

    // Check mode - different AJAX endpoints
    if (searchMode === 'investments') {
      // Investments mode - single AJAX that returns filters + list
      filterInvestments(cityId, agglomerationId, typeId, changedFilter);
    } else if (searchMode === 'properties') {
      // Properties mode - single AJAX that returns filters + list (similar to investments)
      filterProperties(cityId, agglomerationId, typeId, changedFilter);
    } else if (searchMode === 'commercial-properties') {
      // Commercial properties mode - single AJAX that returns filters + list
      const transactionType = $('[data-js="transaction-type-input"]').val() || 'all';
      filterCommercialProperties(cityId, investmentId, transactionType, changedFilter);
    } else {
      // Default properties mode - AJAX for filter ranges only
      currentXhr = $.ajax({
        url: novisaData.ajax_url,
        type: 'POST',
        data: {
          action: 'get_search_filters',
          city_id: cityId,
          agglomeration_id: agglomerationId,
          investment_id: investmentId,
          type_id: typeId
        },
        success: function (response) {
          if (response.success && response.ranges) {
            // Update range sliders (unless they were already adjusted before AJAX)
            if (!skipRangeUpdate) {
              updateRangeSlider('price', response.ranges.price);
              updateRangeSlider('area', response.ranges.area);
              updateRangeSlider('rooms', response.ranges.rooms);
            }
            skipRangeUpdate = false; // Reset flag

            // If this is a reset (all filters = 'all'), restore full lists
            if (response.reset) {
              if (response.investments && changedFilter !== 'investment_id') {
                updateInvestmentDropdown(response.investments, response.ranges);
              }
              if (response.types && changedFilter !== 'type_id') {
                updateTypeDropdown(response.types, response.type_ranges, response.ranges);
              }
              // Don't reset city here - it may have been manually selected
            } else {
              // Update investment dropdown if changed filter is not investment
              // The function will preserve selection if it exists in new list
              if (response.investments && changedFilter !== 'investment_id') {
                updateInvestmentDropdown(response.investments, response.ranges);
              }

              // Update type dropdown if changed filter is not type
              // This prevents type from filtering itself
              if (response.types && changedFilter !== 'type_id') {
                updateTypeDropdown(response.types, response.type_ranges, response.ranges);
              }

              // Highlight city for selected investment (smart: dropdown or tab based on agglomeration)
              if (investmentId !== 'all' && response.highlighted_city_id) {
                highlightCityForInvestment(response.highlighted_city_id);
              }
            }
          }

          // Remove loading class
          $forms.removeClass('is-loading');
          isUpdating = false;
        },
        error: function () {
          console.error('Failed to update filter ranges');

          // Remove loading class even on error
          $forms.removeClass('is-loading');
          isUpdating = false;
        }
      });
    }
  }

  // Function to adjust range slider BEFORE AJAX when changing location
  // This ensures we send correct values to the server for the new location
  function adjustRangeSliderToNewLocation(type, newMin, newMax, forceReset = false) {
    const $field = $forms.find('[data-range-slider]').filter(function () {
      return $(this).find(`input[name="${type}_min"]`).length > 0;
    });
    if (!$field.length) return;
    const sliderEl = $field.find('.slider')[0];
    if (!sliderEl || !sliderEl.noUiSlider) return;
    let adjustedMin, adjustedMax;

    // If forceReset is true, always reset to new range
    if (forceReset) {
      adjustedMin = newMin;
      adjustedMax = newMax;
    } else {
      // Get current slider values and old range
      const currentValues = sliderEl.noUiSlider.get();
      const currentMin = Math.round(parseFloat(currentValues[0]));
      const currentMax = Math.round(parseFloat(currentValues[1]));
      const oldMin = parseInt($field.attr('data-min'), 10);
      const oldMax = parseInt($field.attr('data-max'), 10);

      // Check MIN and MAX separately (user might have changed only one)
      const isMinAtDefault = currentMin === oldMin;
      const isMaxAtDefault = currentMax === oldMax;

      // If MIN is at default (not changed by user), reset to new min
      if (isMinAtDefault) {
        adjustedMin = newMin;
      } else {
        // User changed MIN - preserve if it fits in new range
        adjustedMin = currentMin;
        if (currentMin < newMin) {
          adjustedMin = newMin;
        }
        if (currentMin > newMax) {
          adjustedMin = newMin;
        }
      }

      // If MAX is at default (not changed by user), reset to new max
      if (isMaxAtDefault) {
        adjustedMax = newMax;
      } else {
        // User changed MAX - preserve if it fits in new range
        adjustedMax = currentMax;
        if (currentMax > newMax) {
          adjustedMax = newMax;
        }
        if (currentMax < newMin) {
          adjustedMax = newMax;
        }
      }

      // Ensure min <= max
      if (adjustedMin > adjustedMax) {
        adjustedMin = newMin;
        adjustedMax = newMax;
      }
    }

    // Update slider immediately (fire 'update' event to update hidden inputs)
    sliderEl.noUiSlider.updateOptions({
      start: [adjustedMin, adjustedMax],
      range: {
        'min': newMin,
        'max': newMax
      }
    }, true); // true = fire 'update' event to sync hidden inputs

    // Update data attributes
    $field.attr('data-min', newMin);
    $field.attr('data-max', newMax);
    $field.attr('data-start-min', newMin);
    $field.attr('data-start-max', newMax);
  }

  // Function to update range slider
  function updateRangeSlider(type, range) {
    const $field = $forms.find('[data-range-slider]').filter(function () {
      return $(this).find(`input[name="${type}_min"]`).length > 0;
    });
    if (!$field.length) return;
    const sliderEl = $field.find('.slider')[0];
    if (!sliderEl || !sliderEl.noUiSlider) return;

    // Get current slider values and old range
    const currentValues = sliderEl.noUiSlider.get();
    const currentMin = Math.round(parseFloat(currentValues[0]));
    const currentMax = Math.round(parseFloat(currentValues[1]));
    const oldMin = parseInt($field.attr('data-min'), 10);
    const oldMax = parseInt($field.attr('data-max'), 10);

    // Check MIN and MAX separately (user might have changed only one)
    const isMinAtDefault = currentMin === oldMin;
    const isMaxAtDefault = currentMax === oldMax;
    let newMin, newMax;

    // If MIN is at default (not changed by user), reset to new min
    if (isMinAtDefault) {
      newMin = range.min;
    } else {
      // User changed MIN - preserve if it fits in new range
      if (currentMin >= range.min && currentMin <= range.max) {
        newMin = currentMin;
      } else {
        newMin = range.min;
      }
    }

    // If MAX is at default (not changed by user), reset to new max
    if (isMaxAtDefault) {
      newMax = range.max;
    } else {
      // User changed MAX - preserve if it fits in new range
      if (currentMax >= range.min && currentMax <= range.max) {
        newMax = currentMax;
      } else {
        newMax = range.max;
      }
    }

    // Ensure min is not greater than max
    if (newMin > newMax) {
      newMin = range.min;
      newMax = range.max;
    }

    // Use updateOptions to preserve event handlers
    sliderEl.noUiSlider.updateOptions({
      start: [newMin, newMax],
      range: {
        'min': range.min,
        'max': range.max
      }
    }, true); // true = fire 'update' event after update

    // Update data attributes
    $field.attr('data-min', range.min);
    $field.attr('data-max', range.max);
    $field.attr('data-start-min', range.min);
    $field.attr('data-start-max', range.max);
  }

  // Function to update investment dropdown options
  function updateInvestmentDropdown(investments, ranges) {
    const $dropdown = $forms.find('input[name="investment_id"]').closest('[data-js="search-form-dropdown"]');
    const $list = $dropdown.find('[data-js="search-form-dropdown-list"] ul');
    const $input = $dropdown.find('[data-js="search-form-dropdown-input"]');
    const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');

    // Remember currently selected investment ID
    const currentValue = $input.val();

    // Keep "All" option and rebuild list
    const allOption = $list.find('li:first').clone();

    // Update "All" option ranges with current location ranges
    if (ranges) {
      const $allButton = allOption.find('[data-js="search-form-dropdown-option"]');
      $allButton.attr('data-price-min', ranges.price.min);
      $allButton.attr('data-price-max', ranges.price.max);
      $allButton.attr('data-area-min', ranges.area.min);
      $allButton.attr('data-area-max', ranges.area.max);
      $allButton.attr('data-rooms-min', ranges.rooms.min);
      $allButton.attr('data-rooms-max', ranges.rooms.max);
    }
    $list.empty().append(allOption);
    let selectedInvestmentExists = false;
    let selectedInvestmentLabel = '';
    investments.forEach(function (investment) {
      const $li = $('<li class="text-lg text-mobile-md"></li>');
      const $btn = $('<button type="button" class="u-dropdown__option" data-js="search-form-dropdown-option"></button>').attr('data-value', investment.id).attr('data-label', investment.title).attr('data-city-id', investment.city_id || '');

      // Add range data attributes
      if (investment.price_min !== undefined) $btn.attr('data-price-min', investment.price_min);
      if (investment.price_max !== undefined) $btn.attr('data-price-max', investment.price_max);
      if (investment.area_min !== undefined) $btn.attr('data-area-min', investment.area_min);
      if (investment.area_max !== undefined) $btn.attr('data-area-max', investment.area_max);
      if (investment.rooms_min !== undefined) $btn.attr('data-rooms-min', investment.rooms_min);
      if (investment.rooms_max !== undefined) $btn.attr('data-rooms-max', investment.rooms_max);
      $btn.text(investment.title);

      // Add city and location info if available
      if (investment.city || investment.location) {
        const infoText = [];
        if (investment.city) infoText.push(investment.city);
        if (investment.location) infoText.push(investment.location);
        const $info = $('<span class="info text-xs"></span>').text(infoText.join(', '));
        $btn.append($info);
      }

      // If this is the currently selected investment, mark it as active
      if (currentValue == investment.id) {
        $btn.addClass('is-active');
        selectedInvestmentExists = true;
        selectedInvestmentLabel = investment.title;
      }
      $li.append($btn);
      $list.append($li);
    });

    // Reinitialize click handlers for new options
    initDropdownOptions($dropdown);

    // If currently selected investment still exists in new list, keep it selected
    if (selectedInvestmentExists) {
      $button.text(selectedInvestmentLabel);
      $button.addClass('is-selected');
    } else if (currentValue !== 'all') {
      // If selected investment doesn't exist in new list, reset to "all"
      resetInvestmentFilter();
    }
  }

  // Function to update type dropdown options
  function updateTypeDropdown(types, typeRanges, ranges) {
    const $dropdown = $forms.find('input[name="type_id"]').closest('[data-js="search-form-dropdown"]');
    const $list = $dropdown.find('[data-js="search-form-dropdown-list"] ul');
    const $input = $dropdown.find('[data-js="search-form-dropdown-input"]');
    const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');

    // Remember currently selected type ID
    const currentValue = $input.val();

    // Keep "All" option and rebuild list
    const allOption = $list.find('li:first').clone();

    // Update "All" option ranges with current location ranges
    if (ranges) {
      const $allButton = allOption.find('[data-js="search-form-dropdown-option"]');
      $allButton.attr('data-price-min', ranges.price.min);
      $allButton.attr('data-price-max', ranges.price.max);
      $allButton.attr('data-area-min', ranges.area.min);
      $allButton.attr('data-area-max', ranges.area.max);
      $allButton.attr('data-rooms-min', ranges.rooms.min);
      $allButton.attr('data-rooms-max', ranges.rooms.max);
    }
    $list.empty().append(allOption);
    let selectedTypeExists = false;
    let selectedTypeLabel = '';
    types.forEach(function (type) {
      const typeId = String(type.id);
      const typeRange = typeRanges && typeRanges[typeId] ? typeRanges[typeId] : null;
      const $li = $('<li class="text-lg text-mobile-md"></li>');
      const $btn = $('<button type="button" class="u-dropdown__option" data-js="search-form-dropdown-option"></button>').attr('data-value', type.id).attr('data-label', type.name).text(type.name);

      // Add range data attributes if available
      if (typeRange) {
        $btn.attr('data-price-min', typeRange.price_min || 0);
        $btn.attr('data-price-max', typeRange.price_max || 0);
        $btn.attr('data-area-min', typeRange.area_min || 0);
        $btn.attr('data-area-max', typeRange.area_max || 0);
        $btn.attr('data-rooms-min', typeRange.rooms_min || 0);
        $btn.attr('data-rooms-max', typeRange.rooms_max || 0);
      }

      // If this is the currently selected type, mark it as active
      if (currentValue == type.id) {
        $btn.addClass('is-active');
        selectedTypeExists = true;
        selectedTypeLabel = type.name;
      }
      $li.append($btn);
      $list.append($li);
    });

    // Reinitialize click handlers for new options
    initDropdownOptions($dropdown);

    // If currently selected type still exists in new list, keep it selected
    if (selectedTypeExists) {
      $button.text(selectedTypeLabel);
      $button.addClass('is-selected');
    } else if (currentValue !== 'all') {
      // If selected type doesn't exist in new list, reset to "all"
      resetTypeFilter();
    }
  }

  // Function to highlight city in dropdown (without rebuilding the list)
  function highlightCity(cityId) {
    const $dropdown = $forms.find('input[name="city_id"]').closest('[data-js="search-form-dropdown"]');
    const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');
    const $input = $dropdown.find('[data-js="search-form-dropdown-input"]');
    const $options = $dropdown.find('[data-js="search-form-dropdown-option"]');

    // Find the option with matching city ID
    const $targetOption = $options.filter(function () {
      return $(this).data('value') == cityId;
    });
    if ($targetOption.length) {
      const label = $targetOption.data('label');

      // Update active state
      $targetOption.addClass('is-active');
      $options.not($targetOption).removeClass('is-active');

      // Update button text and input value
      $input.val(cityId);
      $button.text(label);
      $button.addClass('is-selected');
    }
  }

  // Function to highlight city for selected investment (smart logic)
  // If agglomeration is selected, only update city tab (don't change dropdown)
  // If no agglomeration, update dropdown to show city
  function highlightCityForInvestment(cityId) {
    const agglomerationId = $forms.find('input[name="agglomeration_id"]').val();

    // If agglomeration is selected and not "all", keep it and only update city tab
    if (agglomerationId && agglomerationId !== 'all') {
      // Update city_id input (for filtering) but don't change dropdown display
      $forms.find('input[name="city_id"]').val(cityId);

      // Update city tab if it exists (investments mode)
      const $cityTab = $('[data-js="investments-list-city"][data-city-id="' + cityId + '"]');
      if ($cityTab.length) {
        $('[data-js="investments-list-city"]').removeClass('is-active');
        $cityTab.addClass('is-active');
      }
    } else {
      // No agglomeration selected - update dropdown to show city
      highlightCity(cityId);
    }
  }

  // Function to reset city filter to "All"
  function resetCityFilter() {
    const $dropdown = $forms.find('input[name="city_id"]').closest('[data-js="search-form-dropdown"]');
    const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');
    const $input = $dropdown.find('[data-js="search-form-dropdown-input"]');
    const $options = $dropdown.find('[data-js="search-form-dropdown-option"]');

    // Find the "All" option (value = 'all')
    const $allOption = $options.filter(function () {
      return $(this).data('value') === 'all';
    });
    if ($allOption.length) {
      const label = $allOption.data('label');

      // Update active state
      $allOption.addClass('is-active');
      $options.not($allOption).removeClass('is-active');

      // Update button text and input value
      $input.val('all');
      $button.text(label);
      $button.removeClass('is-selected');
    }
  }

  // Function to reset investment filter to "All"
  function resetInvestmentFilter() {
    const $dropdown = $forms.find('input[name="investment_id"]').closest('[data-js="search-form-dropdown"]');
    const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');
    const $input = $dropdown.find('[data-js="search-form-dropdown-input"]');
    const $options = $dropdown.find('[data-js="search-form-dropdown-option"]');

    // Find the "All" option (value = 'all')
    const $allOption = $options.filter(function () {
      return $(this).data('value') === 'all';
    });
    if ($allOption.length) {
      const label = $allOption.data('label');

      // Update active state
      $allOption.addClass('is-active');
      $options.not($allOption).removeClass('is-active');

      // Update button text and input value
      $input.val('all');
      $button.text(label);
      $button.removeClass('is-selected');
    }
  }

  // Function to reset type filter to "All"
  function resetTypeFilter() {
    const $dropdown = $forms.find('input[name="type_id"]').closest('[data-js="search-form-dropdown"]');
    const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');
    const $input = $dropdown.find('[data-js="search-form-dropdown-input"]');
    const $options = $dropdown.find('[data-js="search-form-dropdown-option"]');

    // Find the "All" option (value = 'all')
    const $allOption = $options.filter(function () {
      return $(this).data('value') === 'all';
    });
    if ($allOption.length) {
      const label = $allOption.data('label');

      // Update active state
      $allOption.addClass('is-active');
      $options.not($allOption).removeClass('is-active');

      // Update button text and input value
      $input.val('all');
      $button.text(label);
      $button.removeClass('is-selected');
    }
  }

  // Function to reset all range sliders to their full range
  function resetRangeSliders() {
    $forms.find('[data-range-slider]').each(function () {
      const $field = $(this);
      const sliderEl = $field.find('.slider')[0];
      if (!sliderEl || !sliderEl.noUiSlider) return;

      // Get the full range from data attributes
      const min = parseInt($field.attr('data-min'), 10);
      const max = parseInt($field.attr('data-max'), 10);

      // Reset slider to full range
      sliderEl.noUiSlider.set([min, max]);
    });
  }

  // Initialize dropdown option click handlers
  function initDropdownOptions($dropdown) {
    const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');
    const $list = $dropdown.find('[data-js="search-form-dropdown-list"]');
    const $options = $dropdown.find('[data-js="search-form-dropdown-option"]');
    const $input = $dropdown.find('[data-js="search-form-dropdown-input"]');
    $options.off('click').on('click', function () {
      const value = $(this).data('value');
      const label = $(this).data('label');
      const type = $(this).data('type'); // 'city', 'agglomeration', or 'location' (for "all")
      const inputName = $input.attr('name');
      $(this).addClass('is-active');
      $options.not($(this)).removeClass('is-active');

      // Handle location dropdown (city + agglomeration)
      if (inputName === 'city_id') {
        // Get both inputs
        const $cityInput = $forms.find('input[name="city_id"]');
        const $agglomerationInput = $forms.find('input[name="agglomeration_id"]');

        // Reset both inputs first
        $cityInput.val('all');
        $agglomerationInput.val('all');

        // Set correct input based on type
        if (type === 'agglomeration') {
          $agglomerationInput.val(value);
        } else if (type === 'city') {
          $cityInput.val(value);
        } else {
          // type === 'location' means "all"
          // Both are already set to 'all'
        }
        $button.text(label);
        if (value !== 'all') {
          $button.addClass('is-selected');
        } else {
          $button.removeClass('is-selected');
        }

        // When changing location (any value), reset investment filter
        // This prevents conflicts when selected investment doesn't exist in new location
        resetInvestmentFilter();

        // Note: We DON'T clear range sliders when changing location (including "all")
        // Range sliders are preserved and AJAX will return matching investments

        // Also reset type when resetting to "all"
        if (value === 'all') {
          resetTypeFilter();
        }
      }
      // Handle other dropdowns (investment, type)
      else {
        $input.val(value);
        $button.text(label);
        if (value !== 'all') {
          $button.addClass('is-selected');

          // If selecting an investment, immediately highlight its city (before AJAX)
          if (inputName === 'investment_id') {
            const cityId = $(this).data('city-id');
            if (cityId) {
              highlightCityForInvestment(cityId);
            }
          }

          // When changing type, reset investment to show all investments for new type
          if (inputName === 'type_id') {
            resetInvestmentFilter();
          }
        } else {
          $button.removeClass('is-selected');

          // When selecting "all" in investment_id, reset city if agglomeration is selected
          if (inputName === 'investment_id') {
            const agglomerationId = $forms.find('input[name="agglomeration_id"]').val();

            // If agglomeration is selected, reset city to show all cities from agglomeration
            if (agglomerationId && agglomerationId !== 'all') {
              $forms.find('input[name="city_id"]').val('all');

              // Update city tab if it exists (investments mode)
              $('[data-js="investments-list-city"]').removeClass('is-active');
              $('[data-js="investments-list-city"][data-city-id="all"]').addClass('is-active');
            }
            // If no agglomeration, keep city as is (user might have specific city selected)
          }

          // When selecting "all" in type_id, reset investment to show all investments
          if (inputName === 'type_id') {
            resetInvestmentFilter();
          }
        }
      }
      $button.removeClass('is-active');
      $list.removeClass('is-active');

      // If clicking location option (city/agglomeration/all), adjust range sliders BEFORE AJAX
      // This ensures we send correct range values for the new location
      if (inputName === 'city_id') {
        const newRanges = {
          priceMin: $(this).data('price-min'),
          priceMax: $(this).data('price-max'),
          areaMin: $(this).data('area-min'),
          areaMax: $(this).data('area-max'),
          roomsMin: $(this).data('rooms-min'),
          roomsMax: $(this).data('rooms-max')
        };

        // Adjust sliders to fit new location ranges (before AJAX)
        if (newRanges.priceMin !== undefined && newRanges.priceMax !== undefined) {
          adjustRangeSliderToNewLocation('price', newRanges.priceMin, newRanges.priceMax);
        }
        if (newRanges.areaMin !== undefined && newRanges.areaMax !== undefined) {
          adjustRangeSliderToNewLocation('area', newRanges.areaMin, newRanges.areaMax);
        }
        if (newRanges.roomsMin !== undefined && newRanges.roomsMax !== undefined) {
          adjustRangeSliderToNewLocation('rooms', newRanges.roomsMin, newRanges.roomsMax);
        }

        // Set flag to skip range slider updates in AJAX response
        // (we already adjusted them here, no need to do it again)
        skipRangeUpdate = true;
      }

      // If clicking investment option (including "All"), adjust range sliders BEFORE AJAX
      if (inputName === 'investment_id') {
        const newRanges = {
          priceMin: $(this).data('price-min'),
          priceMax: $(this).data('price-max'),
          areaMin: $(this).data('area-min'),
          areaMax: $(this).data('area-max'),
          roomsMin: $(this).data('rooms-min'),
          roomsMax: $(this).data('rooms-max')
        };

        // Adjust sliders to fit investment ranges (before AJAX)
        if (newRanges.priceMin !== undefined && newRanges.priceMax !== undefined) {
          adjustRangeSliderToNewLocation('price', newRanges.priceMin, newRanges.priceMax);
        }
        if (newRanges.areaMin !== undefined && newRanges.areaMax !== undefined) {
          adjustRangeSliderToNewLocation('area', newRanges.areaMin, newRanges.areaMax);
        }
        if (newRanges.roomsMin !== undefined && newRanges.roomsMax !== undefined) {
          adjustRangeSliderToNewLocation('rooms', newRanges.roomsMin, newRanges.roomsMax);
        }

        // Set flag to skip range slider updates in AJAX response
        skipRangeUpdate = true;
      }

      // If clicking type option, adjust range sliders BEFORE AJAX (same logic as investment)
      if (inputName === 'type_id') {
        const newRanges = {
          priceMin: $(this).data('price-min'),
          priceMax: $(this).data('price-max'),
          areaMin: $(this).data('area-min'),
          areaMax: $(this).data('area-max'),
          roomsMin: $(this).data('rooms-min'),
          roomsMax: $(this).data('rooms-max')
        };

        // Adjust sliders to fit type ranges (before AJAX)
        if (newRanges.priceMin !== undefined && newRanges.priceMax !== undefined) {
          adjustRangeSliderToNewLocation('price', newRanges.priceMin, newRanges.priceMax);
        }
        if (newRanges.areaMin !== undefined && newRanges.areaMax !== undefined) {
          adjustRangeSliderToNewLocation('area', newRanges.areaMin, newRanges.areaMax);
        }
        if (newRanges.roomsMin !== undefined && newRanges.roomsMax !== undefined) {
          adjustRangeSliderToNewLocation('rooms', newRanges.roomsMin, newRanges.roomsMax);
        }

        // Set flag to skip range slider updates in AJAX response
        skipRangeUpdate = true;
      }

      // Trigger dynamic filter update for city/investment/type changes
      // Pass which filter changed to avoid circular updates (e.g., type filtering itself)
      if (inputName === 'city_id' || inputName === 'investment_id' || inputName === 'type_id') {
        updateFilterRanges(inputName);
      }
    });
  }

  // Initialize all dropdowns
  $dropdowns.each(function () {
    const $dropdown = $(this);
    const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');
    const $list = $dropdown.find('[data-js="search-form-dropdown-list"]');
    $button.on('click', function (e) {
      e.stopPropagation();
      $dropdowns.not($dropdown).each(function () {
        const $otherDropdown = $(this);
        const $otherButton = $otherDropdown.find('[data-js="search-form-dropdown-button"]');
        const $otherList = $otherDropdown.find('[data-js="search-form-dropdown-list"]');
        $otherButton.removeClass('is-active');
        $otherList.removeClass('is-active');
      });
      $button.toggleClass('is-active');
      $list.toggleClass('is-active');
    });

    // Initialize options for this dropdown
    initDropdownOptions($dropdown);
  });

  // Close dropdowns on outside click
  $(document).on('click', function (el) {
    $dropdowns.each(function () {
      const $dropdown = $(this);
      const $button = $dropdown.find('[data-js="search-form-dropdown-button"]');
      const $list = $dropdown.find('[data-js="search-form-dropdown-list"]');
      if (!$(el.target).closest($dropdown).length) {
        $button.removeClass('is-active');
        $list.removeClass('is-active');
      }
    });
  });

  // ========================================================================
  // Functions for investments mode
  // ========================================================================

  /**
   * Filter investments list via AJAX (investments mode only).
   * Single AJAX call that updates both filters and list.
   */
  function filterInvestments(cityId, agglomerationId, typeId, changedFilter) {
    // Abort previous AJAX request if still running
    if (currentXhr && currentXhr.readyState !== 4) {
      currentXhr.abort();
    }

    // Get featured articles from section (as JSON)
    const $section = $('[data-js="investments-list"]');
    const featuredArticles = $section.data('featured-articles') || null;

    // Get investment_id from form
    const investmentId = $forms.find('input[name="investment_id"]').val();

    // Get range values from form
    const priceMin = $forms.find('input[name="price_min"]').val();
    const priceMax = $forms.find('input[name="price_max"]').val();
    const areaMin = $forms.find('input[name="area_min"]').val();
    const areaMax = $forms.find('input[name="area_max"]').val();
    const roomsMin = $forms.find('input[name="rooms_min"]').val();
    const roomsMax = $forms.find('input[name="rooms_max"]').val();
    currentXhr = $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'filter_investments',
        city_id: cityId,
        agglomeration_id: agglomerationId,
        type_id: typeId,
        investment_id: investmentId,
        price_min: priceMin,
        price_max: priceMax,
        area_min: areaMin,
        area_max: areaMax,
        rooms_min: roomsMin,
        rooms_max: roomsMax,
        featured_articles: featuredArticles
      },
      success: function (response) {
        if (response.success) {
          // Update filter ranges (unless they were already adjusted before AJAX)
          if (response.data.ranges && !skipRangeUpdate) {
            updateRangeSlider('price', response.data.ranges.price);
            updateRangeSlider('area', response.data.ranges.area);
            updateRangeSlider('rooms', response.data.ranges.rooms);
          }
          skipRangeUpdate = false; // Reset flag

          // Update dropdowns
          if (response.data.investments && changedFilter !== 'investment_id') {
            updateInvestmentDropdown(response.data.investments, response.data.ranges);
          }
          if (response.data.types && changedFilter !== 'type_id') {
            updateTypeDropdown(response.data.types, response.data.type_ranges, response.data.ranges);
          }

          // Replace entire list with new HTML and update count class
          updateInvestmentsList(response.data.html, response.data.count, response.data.articles_count);

          // Update counter HTML from server (includes proper translations)
          updateInvestmentsCounter(response.data.counter_html);

          // Update city tabs (submenu)
          updateCityTabs(response.data.cities, response.data.agglomeration_ranges, cityId);

          // Update URL with current filter parameters
          updateURL();

          // Reinitialize Swiper if needed
          reinitializeSwiper();

          // Reinitialize Tippy tooltips
          reinitializeTippyForLists();
        }
        $forms.removeClass('is-loading');
        isUpdating = false;
      },
      error: function () {
        $forms.removeClass('is-loading');
        isUpdating = false;
      }
    });
  }

  /**
   * Filter properties and update list (similar to filterInvestments but for properties mode).
   * This is used when data-search-mode is 'properties' and sends range parameters.
   */
  function filterProperties(cityId, agglomerationId, typeId, changedFilter) {
    // Abort previous AJAX request if still running
    if (currentXhr && currentXhr.readyState !== 4) {
      currentXhr.abort();
    }

    // Get investment_id from form
    const investmentId = $forms.find('input[name="investment_id"]').val();

    // Get range values from form
    const priceMin = $forms.find('input[name="price_min"]').val();
    const priceMax = $forms.find('input[name="price_max"]').val();
    const areaMin = $forms.find('input[name="area_min"]').val();
    const areaMax = $forms.find('input[name="area_max"]').val();
    const roomsMin = $forms.find('input[name="rooms_min"]').val();
    const roomsMax = $forms.find('input[name="rooms_max"]').val();

    // Get show_investment_info setting from form
    const showInvestmentInfo = $forms.data('show-investment-info') !== false;

    // Get property status (string: 'available' or 'ready_to_handover')
    const propertyStatus = $forms.find('[data-js="property-status"]').val() || 'available';
    currentXhr = $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'filter_properties',
        city_id: cityId,
        agglomeration_id: agglomerationId,
        type_id: typeId,
        investment_id: investmentId,
        price_min: priceMin,
        price_max: priceMax,
        area_min: areaMin,
        area_max: areaMax,
        rooms_min: roomsMin,
        rooms_max: roomsMax,
        show_investment_info: showInvestmentInfo,
        property_status: propertyStatus
      },
      success: function (response) {
        if (response.success) {
          // Update filter ranges (unless they were already adjusted before AJAX)
          if (response.data.ranges && !skipRangeUpdate) {
            updateRangeSlider('price', response.data.ranges.price);
            updateRangeSlider('area', response.data.ranges.area);
            updateRangeSlider('rooms', response.data.ranges.rooms);
          }
          skipRangeUpdate = false; // Reset flag

          // Update dropdowns
          if (response.data.investments && changedFilter !== 'investment_id') {
            updateInvestmentDropdown(response.data.investments, response.data.ranges);
          }
          if (response.data.types && changedFilter !== 'type_id') {
            updateTypeDropdown(response.data.types, response.data.type_ranges, response.data.ranges);
          }

          // Replace entire properties list with new HTML
          updatePropertiesList(response.data.html);
          if (propertyStatus === 'ready_to_handover' && typeof response.data.region_fallback !== 'undefined') {
            $(document).trigger('novisa:properties-list-filtered', [{
              region_fallback: response.data.region_fallback,
              region_investment_url: response.data.region_investment_url || ''
            }]);
          }

          // Update city tabs (submenu)
          updateCityTabsForProperties(response.data.cities, response.data.agglomeration_ranges, cityId);
          initDragToScroll();

          // Update related properties slider
          if (response.data.related_properties_html) {
            updateRelatedPropertiesSlider(response.data.related_properties_html, response.data.related_properties_count);
          }

          // Update URL with current filter parameters
          updateURL();

          // Reinitialize table interactions
          reinitializeTableInteractions();
        }
        $forms.removeClass('is-loading');
        isUpdating = false;
      },
      error: function () {
        $forms.removeClass('is-loading');
        isUpdating = false;
      }
    });
  }

  /**
   * Update investments list with new HTML and update item count class.
   */
  function updateInvestmentsList(html, count, articlesCount) {
    const $list = $('[data-js="investments-list-items"]');

    // Replace entire list content
    $list.html(html);

    // Update has-X-items class
    if (typeof count !== 'undefined') {
      // Remove all existing has-*-items classes
      $list.attr('class', function (i, className) {
        return className.replace(/\bhas-\d+-items\b/g, '');
      });

      // Add new has-X-items class
      $list.addClass('has-' + count + '-items');
    }

    // Update has-X-articles class
    if (typeof articlesCount !== 'undefined') {
      // Remove all existing has-*-articles classes
      $list.attr('class', function (i, className) {
        return className.replace(/\bhas-\d+-articles\b/g, '');
      });

      // Add new has-X-articles class
      $list.addClass('has-' + articlesCount + '-articles');
    }
  }

  /**
   * Update properties list with new HTML.
   */
  function updatePropertiesList(html) {
    const $list = $('[data-js="properties-list-items"]');

    // Replace entire list content
    $list.html(html);

    // Reinitialize Tippy tooltips
    reinitializeTippyForLists();
  }

  /**
   * Update properties counter with new HTML.
   */
  function updatePropertiesCounter(html) {
    const $counter = $('[data-js="properties-list-counter"]');
    if ($counter.length) {
      $counter.html(html);
    }
  }

  /**
   * Reinitialize table interactions after properties list update.
   * Uses global helper from _table.js (includes tooltips, show more, sorting, favorite buttons)
   */
  function reinitializeTableInteractions() {
    if (typeof tableReinitialize === 'function') {
      tableReinitialize();
    }
  }

  /**
   * Reinitialize Swiper slider after list update.
   */
  function reinitializeSwiper() {
    const $slider = $('[data-slider="slider"]');
    if ($slider.length && $slider[0].swiper) {
      // Destroy existing swiper
      $slider[0].swiper.destroy(true, true);

      // Reinitialize swiper (assuming you have initialization code)
      // This depends on your Swiper initialization code
      // You may need to trigger a custom event or call init function
      if (typeof window.initInvestmentsSlider === 'function') {
        window.initInvestmentsSlider();
      }
    }
  }

  /**
   * Reinitialize Tippy tooltips after list update.
   * Works for both investments and properties lists.
   */
  function reinitializeTippyForLists() {
    const selectors = ['[data-js="investments-list-items"]', '[data-js="properties-list-items"]'];
    selectors.forEach(function (selector) {
      const $list = $(selector);
      if ($list.length && typeof reinitializeTippy === 'function') {
        reinitializeTippy($list);
      }
    });
  }

  /**
   * Update related properties slider with new HTML.
   */
  function updateRelatedPropertiesSlider(html, count) {
    const $wrapper = $('[data-js="related-properties-wrapper"]');
    const $section = $('[data-slider="properties-related"]');
    if (!$wrapper.length) {
      return; // No related properties slider on this page
    }

    // Hide entire section if no properties found
    if (!count || count === 0) {
      if ($section.length) {
        $section.hide();
      }
      return;
    }

    // Show section if it was hidden
    if ($section.length) {
      $section.show();
    }

    // Update HTML
    $wrapper.html(html);

    // Update counter if element exists
    const $counter = $('[data-js="related-properties-counter"]');
    if ($counter.length && count !== undefined) {
      $counter.text(count);
    }

    // Reinitialize tooltips for new content
    if ($wrapper.length && typeof reinitializeTippy === 'function') {
      reinitializeTippy($wrapper);
    }

    // Activate favorite buttons
    if (typeof favoritePropertiesActivateButtons === 'function') {
      favoritePropertiesActivateButtons();
    }

    // Reinitialize Swiper
    reinitializeRelatedSlider();
  }

  /**
   * Reinitialize related properties Swiper slider after content update.
   */
  function reinitializeRelatedSlider() {
    const $slider = $('[data-slider="properties-related"]');
    if (!$slider.length) {
      return;
    }
    const swiperEl = $slider.find('[data-slider="slider"]')[0];
    if (swiperEl && swiperEl.swiper) {
      // Destroy existing swiper instance
      swiperEl.swiper.destroy(true, true);

      // Reinitialize swiper with same config as original
      // This depends on your Swiper initialization code
      // You may need to trigger a custom event or call init function
      if (typeof window.initPropertiesRelatedSlider === 'function') {
        window.initPropertiesRelatedSlider();
      } else {
        // If no init function, create new Swiper instance
        new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: $slider.find('[data-js="slider-next-desktop"], [data-js="slider-next-mobile"]').get(),
            prevEl: $slider.find('[data-js="slider-prev-desktop"], [data-js="slider-prev-mobile"]').get()
          },
          pagination: {
            el: $slider.find('.swiper-pagination')[0],
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 24
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 32
            }
          }
        });
      }
    }
  }

  /**
   * Update investments counter label with HTML from server.
   * This ensures proper translations (WPML compatible).
   */
  function updateInvestmentsCounter(counterHtml) {
    const $counter = $('[data-js="investments-list-counter"]');
    $counter.html(counterHtml);
  }

  /**
   * Update city tabs (submenu) based on agglomeration.
   */
  function updateCityTabs(cities, agglomerationRanges, selectedCityId) {
    const $tabs = $('[data-js="investments-list-cities"]');
    if (!$tabs.length) {
      return; // No tabs element on this page
    }

    // Clear existing tabs except "All"
    $tabs.find('[data-city-id]:not([data-city-id="all"])').parent().remove();

    // Update "All" button with agglomeration ranges
    if (agglomerationRanges) {
      const $allButton = $tabs.find('[data-city-id="all"]');
      $allButton.attr('data-price-min', agglomerationRanges.price_min || 0);
      $allButton.attr('data-price-max', agglomerationRanges.price_max || 0);
      $allButton.attr('data-area-min', agglomerationRanges.area_min || 0);
      $allButton.attr('data-area-max', agglomerationRanges.area_max || 0);
      $allButton.attr('data-rooms-min', agglomerationRanges.rooms_min || 0);
      $allButton.attr('data-rooms-max', agglomerationRanges.rooms_max || 0);
    }

    // If we have cities (agglomeration selected), add them
    if (cities && cities.length > 0) {
      cities.forEach(function (city) {
        const isActive = selectedCityId == city.id ? 'is-active' : '';
        const $tab = $('<li class="tab"></li>');
        const $button = $('<button class="button ' + isActive + '" data-city-id="' + city.id + '" data-city-name="' + city.name + '" data-js="investments-list-city">' + city.name + '</button>');

        // Add range data attributes
        if (city.price_min !== undefined) $button.attr('data-price-min', city.price_min);
        if (city.price_max !== undefined) $button.attr('data-price-max', city.price_max);
        if (city.area_min !== undefined) $button.attr('data-area-min', city.area_min);
        if (city.area_max !== undefined) $button.attr('data-area-max', city.area_max);
        if (city.rooms_min !== undefined) $button.attr('data-rooms-min', city.rooms_min);
        if (city.rooms_max !== undefined) $button.attr('data-rooms-max', city.rooms_max);
        $tab.append($button);
        $tabs.append($tab);
      });

      // Initialize click handlers for new tabs
      initCityTabHandlers();
      initDragToScroll();

      // Show tabs navigation
      $tabs.closest('.tabs-navigation').show();
    } else {
      // Hide tabs if no cities
      $tabs.closest('.tabs-navigation').hide();
    }

    // Update "All" active state
    $tabs.find('[data-city-id="all"]').toggleClass('is-active', !selectedCityId || selectedCityId === 'all');
  }

  /**
   * Update city tabs (submenu) for properties mode based on agglomeration.
   */
  function updateCityTabsForProperties(cities, agglomerationRanges, selectedCityId) {
    const $tabs = $('[data-js="properties-list-cities"]');
    if (!$tabs.length) {
      return; // No tabs element on this page
    }

    // Clear existing tabs except "All"
    $tabs.find('[data-city-id]:not([data-city-id="all"])').parent().remove();

    // Update "All" button with agglomeration ranges
    if (agglomerationRanges) {
      const $allButton = $tabs.find('[data-city-id="all"]');
      $allButton.attr('data-price-min', agglomerationRanges.price_min || 0);
      $allButton.attr('data-price-max', agglomerationRanges.price_max || 0);
      $allButton.attr('data-area-min', agglomerationRanges.area_min || 0);
      $allButton.attr('data-area-max', agglomerationRanges.area_max || 0);
      $allButton.attr('data-rooms-min', agglomerationRanges.rooms_min || 0);
      $allButton.attr('data-rooms-max', agglomerationRanges.rooms_max || 0);
    }

    // If we have cities (agglomeration selected), add them
    if (cities && cities.length > 0) {
      cities.forEach(function (city) {
        const isActive = selectedCityId == city.id ? 'is-active' : '';
        const $tab = $('<li class="tab"></li>');
        const $button = $('<button class="button ' + isActive + '" data-city-id="' + city.id + '" data-city-name="' + city.name + '" data-js="properties-list-city">' + city.name + '</button>');

        // Add range data attributes
        if (city.price_min !== undefined) $button.attr('data-price-min', city.price_min);
        if (city.price_max !== undefined) $button.attr('data-price-max', city.price_max);
        if (city.area_min !== undefined) $button.attr('data-area-min', city.area_min);
        if (city.area_max !== undefined) $button.attr('data-area-max', city.area_max);
        if (city.rooms_min !== undefined) $button.attr('data-rooms-min', city.rooms_min);
        if (city.rooms_max !== undefined) $button.attr('data-rooms-max', city.rooms_max);
        $tab.append($button);
        $tabs.append($tab);
      });

      // Initialize click handlers for new tabs
      initCityTabHandlersForProperties();

      // Show tabs navigation
      $tabs.closest('.tabs-navigation').show();
    } else {
      // Hide tabs if no cities
      $tabs.closest('.tabs-navigation').hide();
    }

    // Update "All" active state
    $tabs.find('[data-city-id="all"]').toggleClass('is-active', !selectedCityId || selectedCityId === 'all');
  }

  /**
   * Initialize city tab click handlers.
   */
  function initCityTabHandlers() {
    $('[data-js="investments-list-city"]').off('click').on('click', function () {
      const cityId = $(this).data('city-id');
      const cityName = $(this).data('city-name');

      // Update active state
      $('[data-js="investments-list-city"]').removeClass('is-active');
      $(this).addClass('is-active');

      // Update hidden inputs
      if (cityId === 'all') {
        // Keep agglomeration, reset city (show all cities in agglomeration)
        $('input[name="city_id"]').val('all');
      } else {
        // Set specific city, keep agglomeration (for tabs to stay visible)
        $('input[name="city_id"]').val(cityId);
        // Don't reset agglomeration - we need it to show tabs!
      }

      // Adjust range sliders BEFORE AJAX (same logic as location dropdown)
      const newRanges = {
        priceMin: $(this).data('price-min'),
        priceMax: $(this).data('price-max'),
        areaMin: $(this).data('area-min'),
        areaMax: $(this).data('area-max'),
        roomsMin: $(this).data('rooms-min'),
        roomsMax: $(this).data('rooms-max')
      };

      // Adjust sliders to fit new location ranges (before AJAX)
      if (newRanges.priceMin !== undefined && newRanges.priceMax !== undefined) {
        adjustRangeSliderToNewLocation('price', newRanges.priceMin, newRanges.priceMax);
      }
      if (newRanges.areaMin !== undefined && newRanges.areaMax !== undefined) {
        adjustRangeSliderToNewLocation('area', newRanges.areaMin, newRanges.areaMax);
      }
      if (newRanges.roomsMin !== undefined && newRanges.roomsMax !== undefined) {
        adjustRangeSliderToNewLocation('rooms', newRanges.roomsMin, newRanges.roomsMax);
      }

      // Set flag to skip range slider updates in AJAX response
      skipRangeUpdate = true;

      // Force reset isUpdating flag to allow immediate filter update
      // This ensures that clicking city tab immediately after agglomeration works
      isUpdating = false;

      // Trigger filter update
      updateFilterRanges('city_tab');
    });
  }

  /**
   * Initialize city tab click handlers for properties mode.
   */
  function initCityTabHandlersForProperties() {
    $('[data-js="properties-list-city"]').off('click').on('click', function () {
      const cityId = $(this).data('city-id');
      const cityName = $(this).data('city-name');

      // Update active state
      $('[data-js="properties-list-city"]').removeClass('is-active');
      $(this).addClass('is-active');

      // Update hidden inputs
      if (cityId === 'all') {
        // Keep agglomeration, reset city (show all cities in agglomeration)
        $('input[name="city_id"]').val('all');
      } else {
        // Set specific city, keep agglomeration (for tabs to stay visible)
        $('input[name="city_id"]').val(cityId);
        // Don't reset agglomeration - we need it to show tabs!
      }

      // Adjust range sliders BEFORE AJAX (same logic as location dropdown)
      const newRanges = {
        priceMin: $(this).data('price-min'),
        priceMax: $(this).data('price-max'),
        areaMin: $(this).data('area-min'),
        areaMax: $(this).data('area-max'),
        roomsMin: $(this).data('rooms-min'),
        roomsMax: $(this).data('rooms-max')
      };

      // Adjust sliders to fit new location ranges (before AJAX)
      if (newRanges.priceMin !== undefined && newRanges.priceMax !== undefined) {
        adjustRangeSliderToNewLocation('price', newRanges.priceMin, newRanges.priceMax);
      }
      if (newRanges.areaMin !== undefined && newRanges.areaMax !== undefined) {
        adjustRangeSliderToNewLocation('area', newRanges.areaMin, newRanges.areaMax);
      }
      if (newRanges.roomsMin !== undefined && newRanges.roomsMax !== undefined) {
        adjustRangeSliderToNewLocation('rooms', newRanges.roomsMin, newRanges.roomsMax);
      }

      // Set flag to skip range slider updates in AJAX response
      skipRangeUpdate = true;

      // Force reset isUpdating flag to allow immediate filter update
      // This ensures that clicking city tab immediately after agglomeration works
      isUpdating = false;

      // Trigger filter update
      updateFilterRanges('city_tab');
    });
  }

  // Initialize city tab handlers on page load (if tabs exist)
  if ($('[data-js="investments-list-city"]').length) {
    initCityTabHandlers();
  }

  // Initialize city tab handlers for properties on page load (if tabs exist)
  if ($('[data-js="properties-list-city"]').length) {
    initCityTabHandlersForProperties();
  }

  // Initialize range slider change handlers for investments mode
  if ($('[data-js="search-form"][data-search-mode="investments"]').length > 0) {
    $('[data-js="search-form"][data-search-mode="investments"]').find('[data-range-slider]').each(function () {
      const sliderEl = $(this).find('.slider')[0];
      if (sliderEl && sliderEl.noUiSlider) {
        // Use 'change' event (fires after user finishes dragging)
        sliderEl.noUiSlider.on('change', function () {
          // Trigger filter update without specifying changedFilter
          // This will update everything including the investments list
          updateFilterRanges();
        });
      }
    });
  }

  // Initialize range slider change handlers for properties mode
  if ($('[data-js="search-form"][data-search-mode="properties"]').length > 0) {
    $('[data-js="search-form"][data-search-mode="properties"]').find('[data-range-slider]').each(function () {
      const sliderEl = $(this).find('.slider')[0];
      if (sliderEl && sliderEl.noUiSlider) {
        // Use 'change' event (fires after user finishes dragging)
        sliderEl.noUiSlider.on('change', function () {
          // Trigger filter update without specifying changedFilter
          // This will update everything including the properties list
          updateFilterRanges();
        });
      }
    });
  }

  // ========================================================================
  // Functions for commercial-properties mode
  // ========================================================================

  /**
   * Filter commercial properties list via AJAX (commercial-properties mode only).
   * Single AJAX call that updates both filters and list.
   */
  function filterCommercialProperties(cityId, investmentId, transactionType, changedFilter) {
    // Abort previous AJAX request if still running
    if (currentXhr && currentXhr.readyState !== 4) {
      currentXhr.abort();
    }

    // Get commercial properties form specifically
    const $commercialForm = $('[data-js="search-form"][data-search-mode="commercial-properties"]');

    // Get range values from form
    const priceMin = $commercialForm.find('input[name="price_min"]').val();
    const priceMax = $commercialForm.find('input[name="price_max"]').val();
    const areaMin = $commercialForm.find('input[name="area_min"]').val();
    const areaMax = $commercialForm.find('input[name="area_max"]').val();

    // Get pagination
    const page = $('[data-js="page-input"]').val() || 1;
    const perPage = $('[data-js="per-page-input"]').val() || 12;
    currentXhr = $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'filter_commercial_properties',
        city_id: cityId,
        investment_id: investmentId,
        transaction_type: transactionType,
        price_min: priceMin,
        price_max: priceMax,
        area_min: areaMin,
        area_max: areaMax,
        page_number: page,
        per_page: perPage
      },
      success: function (response) {
        if (response.success) {
          // Update filter ranges ONLY when location changes (city/investment)
          // Don't reset sliders during normal filtering
          if (response.data.ranges && !skipRangeUpdate && (changedFilter === 'city_id' || changedFilter === 'investment_id')) {
            updateRangeSlider('price', response.data.ranges.price);
            updateRangeSlider('area', response.data.ranges.area);
          }
          skipRangeUpdate = false; // Reset flag

          // Update dropdowns
          if (response.data.investments && changedFilter !== 'investment_id') {
            updateInvestmentDropdown(response.data.investments, response.data.ranges);
          }

          // Replace entire list with new HTML
          updateCommercialPropertiesList(response.data.html);

          // Update pagination HTML
          updateCommercialPagination(response.data.pagination_html);

          // Update counter HTML from server
          updateCommercialCounter(response.data.counter_html);

          // Update transaction type tabs with new ranges
          if (response.data.transaction_ranges) {
            updateTransactionTypeTabs(response.data.transaction_ranges);
          }

          // Update URL with current filter parameters
          updateURL();
        }
        $forms.removeClass('is-loading');
        isUpdating = false;
      },
      error: function () {
        $forms.removeClass('is-loading');
        isUpdating = false;
      }
    });
  }

  /**
   * Update commercial properties list with new HTML.
   */
  function updateCommercialPropertiesList(html) {
    const $list = $('[data-js="commercial-list-items"]');

    // Replace entire list content
    $list.html(html);
  }

  /**
   * Update commercial pagination with new HTML.
   */
  function updateCommercialPagination(html) {
    const $pagination = $('[data-js="commercial-pagination"]');
    if ($pagination.length) {
      $pagination.html(html);
    }
  }

  /**
   * Update commercial properties counter with HTML from server.
   */
  function updateCommercialCounter(counterHtml) {
    const $counterDesktop = $('[data-js="commercial-list-counter"]');
    const $counterMobile = $('[data-js="commercial-list-counter-mobile"]');
    if ($counterDesktop.length) {
      $counterDesktop.html(counterHtml);
    }
    if ($counterMobile.length) {
      $counterMobile.html(counterHtml);
    }
  }

  /**
   * Update transaction type tabs with new ranges from AJAX response.
   * Updates data- attributes on tabs.
   */
  function updateTransactionTypeTabs(transactionRanges) {
    // Update 'all' tab
    if (transactionRanges.all) {
      const $allTab = $('[data-js="transaction-type-tab"][data-transaction-type="all"]');
      $allTab.attr('data-price-min', transactionRanges.all.price_min || 0);
      $allTab.attr('data-price-max', transactionRanges.all.price_max || 0);
      $allTab.attr('data-area-min', transactionRanges.all.area_min || 0);
      $allTab.attr('data-area-max', transactionRanges.all.area_max || 0);
    }

    // Update 'sale' tab
    if (transactionRanges.sale) {
      const $saleTab = $('[data-js="transaction-type-tab"][data-transaction-type="sale"]');
      $saleTab.attr('data-price-min', transactionRanges.sale.price_min || 0);
      $saleTab.attr('data-price-max', transactionRanges.sale.price_max || 0);
      $saleTab.attr('data-area-min', transactionRanges.sale.area_min || 0);
      $saleTab.attr('data-area-max', transactionRanges.sale.area_max || 0);
    }

    // Update 'rent' tab
    if (transactionRanges.rent) {
      const $rentTab = $('[data-js="transaction-type-tab"][data-transaction-type="rent"]');
      $rentTab.attr('data-price-min', transactionRanges.rent.price_min || 0);
      $rentTab.attr('data-price-max', transactionRanges.rent.price_max || 0);
      $rentTab.attr('data-area-min', transactionRanges.rent.area_min || 0);
      $rentTab.attr('data-area-max', transactionRanges.rent.area_max || 0);
    }
  }

  // Initialize transaction type tabs for commercial properties
  if ($('[data-js="search-form"][data-search-mode="commercial-properties"]').length > 0) {
    const $commercialForm = $('[data-js="search-form"][data-search-mode="commercial-properties"]');
    $('[data-js="transaction-type-tab"]').on('click', function () {
      if ($(this).hasClass('is-active')) {
        return; // Already active
      }
      const transactionType = $(this).data('transaction-type'); // 'all', 'sale', 'rent'

      // Update active state
      $('[data-js="transaction-type-tab"]').removeClass('is-active');
      $(this).addClass('is-active');

      // Update hidden input
      $('[data-js="transaction-type-input"]').val(transactionType);

      // Reset to page 1 when changing transaction type
      $('[data-js="page-input"]').val(1);

      // Adjust range sliders BEFORE AJAX based on data- attributes
      const newRanges = {
        priceMin: $(this).data('price-min'),
        priceMax: $(this).data('price-max'),
        areaMin: $(this).data('area-min'),
        areaMax: $(this).data('area-max')
      };

      // Adjust sliders to fit new transaction type ranges (before AJAX)
      // Preserve user's selected values if they fit within new ranges (same behavior as city/investment)
      if (newRanges.priceMin !== undefined && newRanges.priceMax !== undefined) {
        adjustRangeSliderToNewLocation('price', newRanges.priceMin, newRanges.priceMax);
      }
      if (newRanges.areaMin !== undefined && newRanges.areaMax !== undefined) {
        adjustRangeSliderToNewLocation('area', newRanges.areaMin, newRanges.areaMax);
      }

      // Set flag to skip range slider updates in AJAX response
      skipRangeUpdate = true;

      // Force reset isUpdating flag
      isUpdating = false;

      // Trigger filter update
      updateFilterRanges('transaction_type');
    });

    // Initialize range slider change handlers for commercial-properties mode
    $('[data-js="search-form"][data-search-mode="commercial-properties"]').find('[data-range-slider]').each(function () {
      const sliderEl = $(this).find('.slider')[0];
      if (sliderEl && sliderEl.noUiSlider) {
        // Use 'change' event (fires after user finishes dragging)
        sliderEl.noUiSlider.on('change', function () {
          // Reset to page 1 when changing ranges
          $('[data-js="page-input"]').val(1);

          // Trigger filter update
          updateFilterRanges();
        });
      }
    });

    // Initialize pagination click handlers for commercial properties
    $(document).on('click', '[data-js="commercial-pagination"] .page-numbers', function (e) {
      e.preventDefault();
      const page = $(this).data('page');
      if (!page || $(this).hasClass('disabled') || $(this).hasClass('current')) {
        return;
      }

      // Update page input
      $('[data-js="page-input"]').val(page);

      // Force reset isUpdating flag
      isUpdating = false;

      // Trigger filter update
      updateFilterRanges('pagination');

      // Scroll to top of results
      const $list = $('[data-js="commercial-properties-list"]');
      if ($list.length) {
        $('html, body').animate({
          scrollTop: $list.offset().top - 100
        }, 300);
      }
    });
  }

  // // ========================================================================
  // // Drag to Scroll dla tabów z miastami
  // // ========================================================================

  // function initDragToScroll() {
  //     const sliders = document.querySelectorAll('[data-js="investments-list-cities"], [data-js="properties-list-cities"]');

  //     sliders.forEach(slider => {
  //         // Najlepiej podpiąć mechanizm pod nadrzędny kontener z overflow: auto
  //         const container = slider.closest('.tabs-navigation');
  //         if (!container) return;

  //         let isDown = false;
  //         let startX;
  //         let scrollLeft;

  //         // Kursor i logikę zapinamy na u-navigation-tabs
  //         slider.addEventListener('mousedown', (e) => {
  //             isDown = true;
  //             slider.classList.add('is-dragging');
  //             startX = e.pageX - container.offsetLeft;
  //             scrollLeft = container.scrollLeft;
  //         });

  //         slider.addEventListener('mouseleave', () => {
  //             isDown = false;
  //             slider.classList.remove('is-dragging');
  //         });

  //         slider.addEventListener('mouseup', () => {
  //             isDown = false;
  //             slider.classList.remove('is-dragging');
  //         });

  //         slider.addEventListener('mousemove', (e) => {
  //             if (!isDown) return;
  //             e.preventDefault();
  //             const x = e.pageX - container.offsetLeft;
  //             const walk = (x - startX) * 1.5; // Prędkość przesuwania
  //             container.scrollLeft = scrollLeft - walk;
  //         });

  //         // Dodatkowe zabezpieczenie: blokada kliknięcia po dragowaniu
  //         // SCSS wyłącza pointer-events w trakcie pociągania (is-dragging),
  //         // ale ten kod łapie przypadki brzegowe podczas puszczania myszki
  //         slider.querySelectorAll('button').forEach(btn => {
  //             btn.addEventListener('click', (e) => {
  //                 if (slider.classList.contains('is-dragging')) {
  //                     e.preventDefault();
  //                     e.stopPropagation();
  //                 }
  //             });
  //         });
  //     });
  // }

  // // Inicjalizuj od razu po załadowaniu
  // initDragToScroll();
  // ========================================================================
  // Drag to Scroll dla tabów z miastami + Gradient UX
  // ========================================================================

  function initDragToScroll() {
    const sliders = document.querySelectorAll('[data-js="investments-list-cities"], [data-js="properties-list-cities"]');
    sliders.forEach(slider => {
      // Zabezpieczenie przed wielokrotnym podpinaniem eventów przez AJAX
      if (slider.dataset.dragInitialized) return;
      slider.dataset.dragInitialized = 'true';
      const container = slider.closest('.tabs-navigation');
      let isDown = false;
      let isMoved = false;
      let startX;
      let scrollLeft;

      // LOGIKA: Włączanie i wyłączanie cienia w zależności od pozycji scrolla
      const handleScrollShadow = () => {
        if (!container) return;
        const isScrollable = slider.scrollWidth > slider.clientWidth;
        // Z marginesem błędu (-4px) dla elastyczności na telefonach (iOS rubber-band effect)
        const isAtEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4;
        if (isScrollable && !isAtEnd) {
          container.classList.add('has-more-content');
        } else {
          container.classList.remove('has-more-content');
        }
      };

      // Nasłuchujemy przesuwania
      slider.addEventListener('scroll', handleScrollShadow);
      window.addEventListener('resize', handleScrollShadow);
      // Wywołujemy z małym opóźnieniem po załadowaniu
      setTimeout(handleScrollShadow, 50);

      // LOGIKA: Drag to scroll
      slider.addEventListener('mousedown', e => {
        isDown = true;
        isMoved = false;
        slider.classList.add('is-dragging');
        startX = e.pageX;
        scrollLeft = slider.scrollLeft;
      });
      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
      });
      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('is-dragging');
      });
      slider.addEventListener('mousemove', e => {
        if (!isDown) return;
        const x = e.pageX;
        const walk = (x - startX) * 1.5;
        if (Math.abs(walk) > 4) {
          isMoved = true;
          e.preventDefault();
        }
        slider.scrollLeft = scrollLeft - walk;
      });

      // LOGIKA: Zabezpieczenie kliknięć podczas dragowania
      slider.addEventListener('click', e => {
        const btn = e.target.closest('button');
        if (btn && isMoved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }
  initDragToScroll();
});

// jQuery(document).ready(function($) {

//     const $stickyForm = $('[data-js="sticky-form"]');
//     if (!$stickyForm.length) return;

//     const fixStickyConsentIds = () => {
//         const $checkboxFields = $stickyForm.find('.wpforms-field.wpforms-field-checkbox');
//         if ($checkboxFields.length < 2) return;

//         const $lastTwo = $checkboxFields.slice(-2);

//         $lastTwo.each(function() {
//             const $field = $(this);

//             $field.find('input[type="checkbox"][id]').each(function() {
//                 const $input = $(this);
//                 const oldId = $input.attr('id');

//                 if (!oldId || oldId.endsWith('-agree')) return;

//                 const newId = `${oldId}-agree`;
//                 $input.attr('id', newId);

//                 const $label = $field.find(`label[for="${oldId}"]`);
//                 if ($label.length) {
//                     $label.attr('for', newId);
//                 }
//             });
//         });
//     };
//     fixStickyConsentIds();

//     const $openBtn = $stickyForm.find('[data-js="sticky-form-open"]');
//     const $content = $stickyForm.find('[data-js="sticky-form-content"]');
//     const $closeTriggers = $stickyForm.find('[data-js="sticky-form-close"]');

//     $openBtn.on('click', function(e) {
//         e.preventDefault();

//         $content.addClass('is-active');
//         $('html').addClass('u-sticky-form-active');
//     });

//     $closeTriggers.on('click', function(e) {
//         e.preventDefault();

//         $content.removeClass('is-active');
//         $('html').removeClass('u-sticky-form-active');
//     });

//     $(document).on('keyup', function(e) {
//         if (e.key === 'Escape' && $content.hasClass('is-active')) {
//             $content.removeClass('is-active');
//             $('html').removeClass('u-sticky-form-active');
//         }
//     });

// });

// DO ZATWIERDZENIA - NOWA WERSJA
jQuery(document).ready(function ($) {
  const $stickyForm = $('[data-js="sticky-form"]');
  if (!$stickyForm.length) return;
  const $openBtn = $stickyForm.find('[data-js="sticky-form-open"]');
  let initialTimer, heartbeatTimer, fallbackToPulseTimer;

  // Zawsze startujemy pasywne pulsowanie 2 sekundy po załadowaniu strony
  initialTimer = setTimeout(() => {
    if (!$('html').hasClass('u-sticky-form-active')) {
      $openBtn.addClass('is-pulsing');
    }
  }, 2000);
  const fixStickyConsentIds = () => {
    const $checkboxFields = $stickyForm.find('.wpforms-field.wpforms-field-checkbox');
    if ($checkboxFields.length < 2) return;
    const $lastTwo = $checkboxFields.slice(-2);
    $lastTwo.each(function () {
      const $field = $(this);
      $field.find('input[type="checkbox"][id]').each(function () {
        const $input = $(this);
        const oldId = $input.attr('id');
        if (!oldId || oldId.endsWith('-agree')) return;
        const newId = `${oldId}-agree`;
        $input.attr('id', newId);
        const $label = $field.find(`label[for="${oldId}"]`);
        if ($label.length) {
          $label.attr('for', newId);
        }
      });
    });
  };
  fixStickyConsentIds();
  const $content = $stickyForm.find('[data-js="sticky-form-content"]');
  const $closeTriggers = $stickyForm.find('[data-js="sticky-form-close"]');
  $openBtn.on('click', function (e) {
    e.preventDefault();

    // Czyścimy wszystko przy otwarciu
    clearTimeout(initialTimer);
    clearTimeout(heartbeatTimer);
    clearTimeout(fallbackToPulseTimer);
    $openBtn.removeClass('is-pulsing is-heartbeat');
    $content.addClass('is-active');
    $('html').addClass('u-sticky-form-active');
  });
  const handleClose = () => {
    $content.removeClass('is-active');
    $('html').removeClass('u-sticky-form-active');
    clearTimeout(heartbeatTimer);
    clearTimeout(fallbackToPulseTimer);

    // Po zamknięciu formularza czekamy 2 sekundy i odpalamy spokojniejszy heartbeat
    heartbeatTimer = setTimeout(() => {
      if (!$('html').hasClass('u-sticky-form-active')) {
        $openBtn.removeClass('is-pulsing').addClass('is-heartbeat');

        // Po 12 sekundach bicia serca, wracamy do cichego pulsowania (radaru)
        fallbackToPulseTimer = setTimeout(() => {
          if (!$('html').hasClass('u-sticky-form-active')) {
            $openBtn.removeClass('is-heartbeat').addClass('is-pulsing');
          }
        }, 12000);
      }
    }, 2000);
  };
  $closeTriggers.on('click', function (e) {
    e.preventDefault();
    handleClose();
  });
  $(document).on('keyup', function (e) {
    if (e.key === 'Escape' && $content.hasClass('is-active')) {
      handleClose();
    }
  });
});
jQuery(document).ready(function ($) {
  var $submenu = $('[data-js="submenu"]');
  if (!$submenu.length) return;
  var $submenuLinks = $submenu.find('a');
  var $window = $(window);
  var isScrolling = false;

  // Get header height
  function getHeaderOffset() {
    var $header = $('#header');
    return $header.length ? $header.outerHeight() : 0;
  }

  // Smooth scroll
  $submenuLinks.on('click', function (e) {
    var href = $(this).attr('href');
    if (href && href.startsWith('#')) {
      var $target = $(href);
      if ($target.length) {
        e.preventDefault();
        $submenuLinks.parent().removeClass('is-active');
        $(this).parent().addClass('is-active');
        var headerOffset = getHeaderOffset();
        var submenuHeight = $submenu.outerHeight() || 0;
        var scrollOffset = headerOffset + submenuHeight;
        isScrolling = true;
        $('html, body').stop().animate({
          scrollTop: $target.offset().top - scrollOffset - 1
        }, 500, function () {
          isScrolling = false;
          updateActiveSubmenuLink();
        });
      }
    }
  });

  // Update submenu
  function updateActiveSubmenuLink() {
    if (isScrolling) return;
    var headerOffset = getHeaderOffset();
    var submenuHeight = $submenu.outerHeight() || 0;
    var scrollPosition = $window.scrollTop() + headerOffset + submenuHeight + 2;
    var currentActive = null;
    $submenuLinks.each(function () {
      var href = $(this).attr('href');
      if (href && href.startsWith('#')) {
        var $target = $(href);
        if ($target.length) {
          var targetTop = $target.offset().top - 1;
          if (scrollPosition >= targetTop) {
            currentActive = $(this);
          }
        }
      }
    });
    $submenuLinks.parent().removeClass('is-active');
    if (currentActive) {
      currentActive.parent().addClass('is-active');
    } else if ($window.scrollTop() === 0) {
      $submenuLinks.parent().first().addClass('is-active');
    }
  }

  // Debounce helper
  function debounce(func, wait) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(func, wait);
    };
  }
  var debouncedUpdate = debounce(updateActiveSubmenuLink, 50);

  // Event listeners
  $window.on('scroll', debouncedUpdate);
  $window.on('resize', debouncedUpdate);

  // Initial activation
  updateActiveSubmenuLink();

  // Recalculate lazy-loaded images
  $('img[loading="lazy"]').on('load', function () {
    updateActiveSubmenuLink();
  });
});

/**
 * Table Helper Functions
 * Global utilities for table reinitialization after AJAX updates
 */

/**
 * Reinitialize Tippy tooltips for all tables
 * Finds all tables and reinitializes tooltips inside them
 */
function tableReinitializeTippy() {
  var $tables = jQuery('[data-js="table"]');
  if (!$tables.length) {
    return;
  }
  $tables.each(function () {
    // Use global reinitializeTippy function for each table
    if (typeof reinitializeTippy === 'function') {
      reinitializeTippy(this);
    }
  });
}

/**
 * Reinitialize table "show more" button
 * Handles show-10/show-all tbody classes and button visibility
 * Works with all tables that have [data-js="table"] attribute
 */
function tableReinitializeShowMore() {
  var $tables = jQuery('[data-js="table"]');
  if (!$tables.length) {
    return;
  }
  $tables.each(function () {
    var $table = jQuery(this);
    var $button = $table.find('[data-js="table-button"]');
    var $tbody = $table.find('tbody');
    var $rows = $tbody.find('tr');

    // Ensure tbody has proper class if it doesn't have any
    if (!$tbody.hasClass('show-10') && !$tbody.hasClass('show-all')) {
      $tbody.addClass('show-10');
    }

    // Reset button click handler
    $button.off('click').on('click', function () {
      // Change tbody class from show-10 to show-all
      $tbody.removeClass('show-10').addClass('show-all');
      $button.hide();
    });

    // Show/hide button based on row count
    if ($rows.length > 10) {
      $button.show();
    } else {
      $button.hide();
    }
  });
}

/**
 * Initialize table sorting for all tables with th-sort buttons
 */
function tableInitializeSorting() {
  var $tables = jQuery('[data-js="table"]');
  if (!$tables.length) {
    return;
  }
  $tables.each(function () {
    var $table = jQuery(this);
    var $sortButtons = $table.find('.th-sort');

    // Remove previous click handlers to avoid duplicates
    $sortButtons.off('click.tableSort').on('click.tableSort', function () {
      var $button = jQuery(this);
      var $th = $button.closest('th');
      var $thead = $th.closest('thead');
      var $tbody = $thead.next('tbody');
      var colName = $button.data('col-name');
      var sortType = $th.data('sort-type');
      var currentSort = $th.attr('aria-sort');

      // Save current tbody class (show-10 or show-all)
      var tbodyClass = $tbody.hasClass('show-all') ? 'show-all' : 'show-10';

      // Determine new sort direction (toggle between ascending and descending only)
      var newSort = 'ascending';
      if (currentSort === 'ascending') {
        newSort = 'descending';
      } else if (currentSort === 'descending') {
        newSort = 'ascending';
      }

      // Reset all other columns to 'none'
      $thead.find('th').attr('aria-sort', 'none');

      // Set new sort direction
      $th.attr('aria-sort', newSort);

      // Get all rows as jQuery objects (detach to preserve data and events)
      var $rows = $tbody.find('tr').detach();

      // Store original indexes if not already stored
      $rows.each(function (index) {
        if (jQuery(this).data('original-index') === undefined) {
          jQuery(this).data('original-index', index);
        }
      });

      // Convert to array for sorting
      var rowsArray = $rows.get();

      // Sort rows
      rowsArray.sort(function (a, b) {
        var $a = jQuery(a);
        var $b = jQuery(b);

        // Get cells by column name class
        var $cellA = $a.find('.col-' + colName);
        var $cellB = $b.find('.col-' + colName);

        // Get sort values
        var valA = $cellA.data('value');
        var valB = $cellB.data('value');

        // Convert to appropriate type based on sortType
        var result = 0;
        if (sortType === 'natural') {
          // Natural string sorting (for property numbers like '1', '2', '10')
          result = tableNaturalCompare(String(valA || ''), String(valB || ''));
        } else if (sortType === 'number' || sortType === 'area' || sortType === 'price') {
          // Numeric sorting
          valA = parseFloat(valA) || 0;
          valB = parseFloat(valB) || 0;
          result = valA - valB;
        } else {
          // Default string sorting
          valA = String(valA || '').toLowerCase();
          valB = String(valB || '').toLowerCase();
          result = valA.localeCompare(valB);
        }

        // Reverse for descending
        if (newSort === 'descending') {
          result = -result;
        }
        return result;
      });

      // Append sorted rows back to tbody
      $tbody.empty().append(rowsArray);

      // Restore tbody class
      $tbody.removeClass('show-10 show-all').addClass(tbodyClass);
    });
  });
}

/**
 * Natural sort comparison (handles numbers in strings)
 */
function tableNaturalCompare(a, b) {
  var ax = [];
  var bx = [];
  a.replace(/(\d+)|(\D+)/g, function (_, num, str) {
    ax.push([num || Infinity, str || '']);
  });
  b.replace(/(\d+)|(\D+)/g, function (_, num, str) {
    bx.push([num || Infinity, str || '']);
  });
  while (ax.length && bx.length) {
    var an = ax.shift();
    var bn = bx.shift();
    var nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
    if (nn) return nn;
  }
  return ax.length - bx.length;
}

/**
 * Reinitialize all table interactions
 * Call this after dynamically loading table content via AJAX
 * Reinitializes tooltips, show more buttons, sorting, and favorite buttons for all tables
 */
function tableReinitialize() {
  // Reinitialize tooltips for all tables
  tableReinitializeTippy();

  // Reinitialize "show more" buttons for all tables
  tableReinitializeShowMore();

  // Reinitialize table sorting
  tableInitializeSorting();

  // Activate favorite buttons if function exists
  if (typeof favoritePropertiesActivateButtons === 'function') {
    favoritePropertiesActivateButtons();
  }
}

/**
 * Initialize all tables on page load
 */
jQuery(document).ready(function ($) {
  tableReinitializeShowMore();
  tableInitializeSorting();
});
// Tabs activation
function activateTab($tabsWrapper, tabName) {
  if (!$tabsWrapper || !$tabsWrapper.length) return;
  const $button = $tabsWrapper.find('[data-js="tab-button"][data-tab="' + tabName + '"]');
  const $content = $tabsWrapper.find('[data-js="tab-content"][data-tab="' + tabName + '"]');
  if (!$button.length || !$content.length) return;
  $tabsWrapper.find('[data-js="tab-button"]').removeClass('is-active');
  $tabsWrapper.find('[data-js="tab-content"]').removeClass('is-active');
  $button.addClass('is-active');
  $content.addClass('is-active');
}

// Close toggles
function closeToggles($root) {
  $root.find('[data-js="toggle"]').each(function () {
    const $section = $(this);
    const $button = $section.find('[data-js="toggle-button"]');
    const $content = $section.find('[data-js="toggle-content"]');
    if ($button.attr('aria-expanded') === 'true') {
      $content.removeClass('is-active').attr('hidden', true);
      $button.removeClass('is-active').attr('aria-expanded', 'false');
      $button.contents().first()[0].textContent = $button.data('open-label');
    }
  });
}
jQuery(document).ready(function ($) {
  /* Toggle */
  $('[data-js="toggle"]').each(function () {
    var $section = $(this);
    $section.find('[data-js="toggle-button"]').on('click', function () {
      var $button = $(this);
      var $content = $section.find('[data-js="toggle-content"]');
      var isExpanded = $button.attr('aria-expanded') === 'true';
      if (!isExpanded) {
        $content.addClass('is-active').removeAttr('hidden');
        $button.addClass('is-active').attr('aria-expanded', 'true');
        $button.contents().first()[0].textContent = $button.data('close-label');
      } else {
        $content.removeClass('is-active').attr('hidden', true);
        $button.removeClass('is-active').attr('aria-expanded', 'false');
        $button.contents().first()[0].textContent = $button.data('open-label');
      }
    });
  });

  /* Default show-more */
  $('[data-js="showmore"]').each(function () {
    const $section = $(this);
    $section.find('[data-js="showmore-button"]').on('click', function () {
      const $button = $(this);
      const $items = $section.find('[data-js="showmore-item"]');
      if ($button.attr('aria-expanded') !== 'true') {
        $items.addClass('is-active');
        $button.attr('aria-expanded', 'true').hide();
      }
    });
  });

  /* Tabs: show-more + reset */
  $('[data-js="tabs"]').each(function () {
    const $tabsWrapper = $(this);
    const chunk = 4;
    $tabsWrapper.on('click', '[data-js="showmore-button"]', function () {
      const $btn = $(this);
      const $tabContent = $btn.closest('[data-js="tab-content"]');
      const $hiddenItems = $tabContent.find('.is-inactive').slice(0, chunk);
      $hiddenItems.removeClass('is-inactive');
      if ($tabContent.find('.is-inactive').length === 0) {
        $btn.hide();
      }
    });
    $tabsWrapper.find('[data-js="tab-button"]').on('click', function () {
      const tabName = $(this).data('tab');
      const $activeContent = $tabsWrapper.find('[data-js="tab-content"][data-tab="' + tabName + '"]');
      const $items = $activeContent.children().not('[data-js="showmore-button"]');
      $items.removeClass('is-inactive');
      $items.each(function (index) {
        if (index >= chunk) {
          $(this).addClass('is-inactive');
        }
      });
      const $button = $activeContent.find('[data-js="showmore-button"]');
      $button.hide();
      if ($activeContent.find('.is-inactive').length > 0) {
        $button.show();
      }
      activateTab($tabsWrapper, tabName);
      closeToggles($tabsWrapper);

      // Scroll button into view
      this.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    });
  });

  /* Deep Link */
  const hash = window.location.hash;
  if (hash && hash.length > 1) {
    const id = hash.substring(1);
    const $target = $('[data-js="deep-link"]#' + id);
    if ($target.length) {
      const $tabsWrapper = $target.closest('[data-js="tabs"]');
      const $tab = $target.closest('[data-js="tab-content"]');
      if ($tab.length) {
        const tabName = $tab.data('tab');
        activateTab($tabsWrapper, tabName);
        closeToggles($tabsWrapper);
      }
      const $toggleBtn = $target.find('[data-js="toggle-button"]');
      if ($toggleBtn.length && $toggleBtn.attr('aria-expanded') === 'false') {
        $toggleBtn.trigger('click');
      }
      setTimeout(() => {
        const offset = $target.offset().top - 120;
        $('html, body').animate({
          scrollTop: offset
        }, 600);
      }, 300);
    }
  }

  /* Reset URL */
  $('[data-js="tabs"] [data-js="tab-button"]').on('click', function () {
    history.replaceState(null, null, window.location.pathname + window.location.search);
  });
  $('[data-js="toggle-button"]').on('click', function () {
    history.replaceState(null, null, window.location.pathname + window.location.search);
  });
});

/**
 * Tracking parameters handler
 * Reads tracking parameters from URL and saves them to cookies
 * PHP will automatically read these cookies when processing forms
 */
(function () {
  // Cookie name prefix
  const cookiePrefix = 'novisa_';

  // List of tracking parameters to handle
  const trackingParams = ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

  /**
   * Get URL parameters
   * @param {string} param - Parameter name to get from URL
   * @returns {string|null} Parameter value or null if not found
   */
  function getUrlParameter(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  /**
   * Save tracking parameter to cookie
   * @param {string} param - Parameter name
   * @param {string} value - Parameter value
   */
  function saveTrackingToCookie(param, value) {
    if (value) {
      Cookies.set(cookiePrefix + param, value, {
        expires: 30
      }); // Cookie expires in 30 days
    }
  }

  /**
   * Initialize tracking handling
   */
  function init() {
    trackingParams.forEach(param => {
      // Try to get parameter from URL
      let value = getUrlParameter(param);

      // If not in URL, try to get from cookie
      if (!value) {
        value = Cookies.get(cookiePrefix + param);
      }

      // If we have a value from either source, save to cookie
      if (value) {
        saveTrackingToCookie(param, value);
      }
    });
  }

  // Run initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
jQuery(document).ready(function ($) {
  // Property product event (https://developers.youlead.io/#tag/ApiRequests/product)
  $(document).on('propertyModalOpened', function (e, voxId) {
    if (!voxId) {
      return;
    }
    window.ylData = window.ylData || [];
    window.ylData.push({
      'product': {
        'products': [voxId]
      }
    });
  });

  // Property plan download event (https://developers.youlead.io/#tag/ApiRequests/event)
  $(document).on('click', '[data-js="property-modal-plan-download"]', function (e) {
    var voxId = $(this).data('vox-id');
    if (!voxId) {
      return;
    }
    window.ylData = window.ylData || [];
    window.ylData.push({
      'event': {
        'eventName': 'pdfDownload',
        'params': 'alias=' + voxId
      }
    });
  });

  // Favorite property cart event (https://developers.youlead.io/#tag/ApiRequests/cart)
  $(document).on('favoritePropertyChanged', function (e) {
    // Get all favorite properties from cookie
    var favorite = Cookies.get('novisa_favorite_properties');
    var voxIds = [];
    if (favorite) {
      try {
        voxIds = JSON.parse(favorite);
      } catch (err) {
        console.error('Error parsing favorite properties cookie:', err);
        voxIds = [];
      }
    }

    // If cart is empty, send empty cart event
    if (voxIds.length === 0) {
      window.ylData = window.ylData || [];
      window.ylData.push({
        'cart': {
          'products': []
        }
      });
      return;
    }

    // Get properties prices from backend
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'novisa_get_properties_prices',
        vox_ids: voxIds
      },
      success: function (response) {
        if (response.success && response.data.prices) {
          // Prepare cart items for YouLead
          var cartItems = [];
          for (var id in response.data.prices) {
            cartItems.push({
              'productId': id,
              'quantity': 1,
              'price': response.data.prices[id].price
            });
          }

          // Send cart event to YouLead
          window.ylData = window.ylData || [];
          window.ylData.push({
            'cart': {
              'products': cartItems
            }
          });
        }
      },
      error: function (xhr, status, error) {
        console.error('Error getting properties prices:', error);
      }
    });
  });
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="company-timeline"]');
  let swipers = [];
  let currentBreakpoint = window.innerWidth >= 1200 ? 'desktop' : 'mobile';
  function toggleNav(swiper, prevEl, nextEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
    }
  }
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this);
      $section.find('[data-slider="slider"]').each(function () {
        const $slider = $(this);
        const paginationEl = window.innerWidth >= 1200 ? $section.find('.navigation-slider-desktop .swiper-pagination')[0] : $section.find('.navigation-slider-mobile .swiper-pagination')[0];
        let prevEl, nextEl;
        if (window.innerWidth >= 1200) {
          prevEl = $section.find('.navigation-slider-desktop [data-js="slider-prev"]')[0];
          nextEl = $section.find('.navigation-slider-desktop [data-js="slider-next"]')[0];
        } else {
          prevEl = $section.find('.navigation-slider-mobile [data-js="slider-prev"]')[0];
          nextEl = $section.find('.navigation-slider-mobile [data-js="slider-next"]')[0];
        }
        const paginationType = window.innerWidth >= 1200 ? 'progressbar' : 'bullets';
        const swiper = new Swiper($slider[0], {
          slidesPerView: 'auto',
          spaceBetween: 16,
          speed: 700,
          grabCursor: true,
          a11y: false,
          navigation: {
            prevEl,
            nextEl
          },
          pagination: {
            el: paginationEl,
            type: paginationType,
            clickable: paginationType === 'bullets'
          },
          breakpoints: {
            767: {
              spaceBetween: 32
            }
          },
          on: {
            init: function () {
              toggleNav(this, prevEl, nextEl);
            },
            resize: function () {
              toggleNav(this, prevEl, nextEl);
            },
            update: function () {
              toggleNav(this, prevEl, nextEl);
            }
          }
        });
        swipers.push(swiper);
      });
    });
  }

  // Initialize
  if ($sliders.length > 0) {
    initSliders();
  }

  // Re-initialize
  $(window).on('resize', function () {
    const newBreakpoint = window.innerWidth >= 1200 ? 'desktop' : 'mobile';
    if (newBreakpoint !== currentBreakpoint) {
      if ($sliders.length > 0) {
        initSliders();
      }
      currentBreakpoint = newBreakpoint;
    }
  });
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-js="slider-hero"]');
  if ($sliders.length > 0) {
    $sliders.each(function () {
      const $slider = $(this);
      const prevEl = $slider.find('[data-js="slider-prev"]')[0] || null;
      const nextEl = $slider.find('[data-js="slider-next"]')[0] || null;
      const slidesCount = $slider.find('.swiper-slide').length;
      const swiper = new Swiper($slider[0], {
        slidesPerView: 1,
        effect: 'fade',
        speed: 700,
        loop: slidesCount > 1,
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl
        } : {},
        autoplay: {
          delay: 7000,
          disableOnInteraction: false
        },
        on: {
          init: function () {
            updateSwiperHeight(this);
          },
          slideChange: function () {
            updateSwiperHeight(this);
          }
        }
      });

      // Manual adaptive height for fade effect
      function updateSwiperHeight(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        if (activeSlide) {
          const photo = activeSlide.querySelector('.photo');
          if (photo) {
            const slideHeight = photo.offsetHeight;
            swiper.wrapperEl.style.height = slideHeight + 'px';
          }
        }
      }
    });
  }
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="investment-benefits"]');
  let swipers = [];
  let isSwiperInitialized = false;
  function toggleNav(swiper, prevEl, nextEl, paginationEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
      if (paginationEl) $(paginationEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
      if (paginationEl) $(paginationEl).show();
    }
  }
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this);
      const $slider = $section.find('[data-slider="slider"]');
      const prevEl = $section.find('[data-js="slider-prev"]')[0] || null;
      const nextEl = $section.find('[data-js="slider-next"]')[0] || null;
      const paginationEl = $section.find('.swiper-pagination')[0] || null;
      const swiper = new Swiper($slider[0], {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 700,
        grabCursor: true,
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl
        } : {},
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true
        } : {},
        breakpoints: {
          768: {
            spaceBetween: 24
          }
        },
        on: {
          init: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          },
          resize: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          },
          update: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          }
        }
      });
      swipers.push(swiper);
    });
    isSwiperInitialized = true;
  }
  function destroySliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    isSwiperInitialized = false;
  }
  function checkBreakpoint() {
    if (window.innerWidth < 1200) {
      if (!isSwiperInitialized) {
        initSliders();
      }
    } else {
      if (isSwiperInitialized) {
        destroySliders();
      }
    }
  }

  // Initialize
  checkBreakpoint();

  // Re-initialize
  $(window).on('resize', function () {
    checkBreakpoint();
  });
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="investment-gallery"]');
  let swipers = [];
  function toggleNav(swiper, prevEl, nextEl, paginationEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
      if (paginationEl) $(paginationEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
      if (paginationEl) $(paginationEl).show();
    }
  }
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this);
      $section.find('[data-slider="slider"]').each(function () {
        const $slider = $(this);
        const $tabContent = $slider.closest('[data-js="tab-content"]');
        const tabName = $tabContent.data('tab');
        const paginationEl = $section.find('.swiper-pagination[data-tab="' + tabName + '"]')[0] || null;
        const prevEl = $section.find('.navigation-slider[data-tab="' + tabName + '"] [data-js="slider-prev"]')[0] || null;
        const nextEl = $section.find('.navigation-slider[data-tab="' + tabName + '"] [data-js="slider-next"]')[0] || null;
        const swiper = new Swiper($slider[0], {
          slidesPerView: 'auto',
          spaceBetween: 16,
          speed: 700,
          grabCursor: true,
          a11y: false,
          navigation: {
            prevEl,
            nextEl
          },
          pagination: {
            el: paginationEl,
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 5
          },
          breakpoints: {
            767: {
              spaceBetween: 24
            }
          },
          on: {
            init: function () {
              toggleNav(this, prevEl, nextEl, paginationEl);
            },
            resize: function () {
              toggleNav(this, prevEl, nextEl, paginationEl);
            },
            update: function () {
              toggleNav(this, prevEl, nextEl, paginationEl);
            }
          }
        });
        swipers.push(swiper);
      });
    });
  }

  // Initialize
  if ($sliders.length > 0) {
    initSliders();
  }

  // Reinitialize on tab switch
  $(document).on('click', '[data-js="tab-button"]', function () {
    const tabName = $(this).data('tab');
    const $targetSlider = $('[data-js="tab-content"][data-tab="' + tabName + '"]').find('[data-slider="slider"]');
    if ($targetSlider.length && $targetSlider[0].swiper) {
      setTimeout(() => {
        $targetSlider[0].swiper.update();
      }, 50);
    }
  });
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-js="slider-hero-investment"]');
  if ($sliders.length > 0) {
    $sliders.each(function () {
      const $slider = $(this);
      const prevEl = $slider.find('[data-js="slider-prev"]')[0] || null;
      const nextEl = $slider.find('[data-js="slider-next"]')[0] || null;
      const slidesCount = $slider.find('.swiper-slide').length;
      new Swiper($slider[0], {
        slidesPerView: 1,
        effect: 'fade',
        speed: 700,
        loop: slidesCount > 1,
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl
        } : {},
        autoplay: {
          delay: 7000,
          disableOnInteraction: false
        }
      });
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  let scrollHandler = null;
  let resizeHandler = null;
  function initPinned() {
    const pinItems = Array.from(document.querySelectorAll('[data-js="pinned-item"]'));
    const pinMedia = Array.from(document.querySelectorAll('[data-js="pinned-media"]'));
    const pinSection = document.querySelector('[data-js="pinned"]');
    if (scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }
    if (window.innerWidth < 1200) {
      pinItems.forEach(function (item) {
        item.classList.remove('is-active');
        item.classList.remove('scroll-down');
        item.classList.remove('scroll-up');
      });
      pinMedia.forEach(function (media) {
        media.classList.remove('is-active');
      });
      return;
    }
    if (!pinItems.length || !pinMedia.length || !pinSection) {
      return;
    }
    let lastScrollY = window.scrollY;
    let previousActiveIndex = -1;
    function update() {
      const sectionRect = pinSection.getBoundingClientRect();
      const viewportCenter = window.innerHeight / 2;
      const currentScrollY = window.scrollY;
      const scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
      let activeIndex = -1;
      let minDistance = Infinity;
      pinItems.forEach(function (item, index) {
        const rect = item.getBoundingClientRect();
        const itemCenter = rect.top + rect.height / 2;
        const distance = Math.abs(itemCenter - viewportCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });
      if (activeIndex >= 0 && activeIndex !== previousActiveIndex) {
        pinItems.forEach(function (item, idx) {
          item.classList.remove('is-active', 'scroll-down', 'scroll-up');
        });
        pinItems[activeIndex].classList.add('is-active');
        pinItems[activeIndex].classList.add('scroll-' + scrollDirection);
        const activeId = pinItems[activeIndex].dataset.id;
        pinMedia.forEach(function (media) {
          if (media.dataset.id === activeId) {
            media.classList.add('is-active');
          } else {
            media.classList.remove('is-active');
          }
        });
        previousActiveIndex = activeIndex;
      }
      lastScrollY = currentScrollY;
    }
    scrollHandler = update;
    window.addEventListener('scroll', scrollHandler, {
      passive: true
    });
    update();
  }
  initPinned();
  let resizeTimeout;
  resizeHandler = function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function () {
      initPinned();
    }, 150);
  };
  window.addEventListener('resize', resizeHandler);
});
jQuery(document).ready(function ($) {
  const $investmentPlan = $('[data-js="investment-plan"]');
  if (!$investmentPlan.length) return;
  const $navigation = $investmentPlan.find('[data-js="plan-navigation"]');
  const navType = $navigation.data('nav-type');

  /**
   * Switch to a specific plan
   */
  function switchToPlan(planId, skipAnimation) {
    const $targetPlan = $investmentPlan.find('[data-js="plan-container"][data-plan-id="' + planId + '"]');
    if (!$targetPlan.length) {
      return;
    }
    const $currentPlan = $investmentPlan.find('[data-js="plan-container"]:visible');
    const targetPlanLevel = $targetPlan.data('plan-level');
    if (skipAnimation || !$currentPlan.length) {
      $investmentPlan.find('[data-js="plan-container"]').hide();
      $targetPlan.show();
      // Initialize interactive features for this plan
      initializePlanInteractivity($targetPlan);
      // Switch legend based on plan level
      switchLegend(targetPlanLevel);
    } else {
      $currentPlan.fadeOut(200, function () {
        $targetPlan.fadeIn(200, function () {
          // Initialize interactive features for this plan after animation
          initializePlanInteractivity($targetPlan);
          // Switch legend based on plan level
          switchLegend(targetPlanLevel);
        });
      });
    }
  }

  /**
   * Center default visible plan on mobile (after full page load)
   */
  function centerDefaultPlanOnLoad() {
    // Only center on mobile devices
    if (window.innerWidth > 1199) {
      return;
    }
    const $visiblePlan = $investmentPlan.find('[data-js="plan-container"]:visible').first();
    if (!$visiblePlan.length) {
      return;
    }
    const $mapContainer = $visiblePlan.find('.b-investment-plan__map');
    if (!$mapContainer.length) {
      return;
    }
    const scrollWidth = $mapContainer[0].scrollWidth;
    const clientWidth = $mapContainer[0].clientWidth;
    const centerPosition = (scrollWidth - clientWidth) / 2;

    // Set scroll position
    $mapContainer[0].scrollLeft = centerPosition;
  }

  /**
   * Switch legend based on plan level
   */
  function switchLegend(planLevel) {
    const $mainLegend = $investmentPlan.find('[data-js="plan-legend"]');
    const $buildingsLegend = $investmentPlan.find('[data-js="plan-legend-buildings"]');
    if (!$mainLegend.length && !$buildingsLegend.length) {
      return;
    }

    // Show main legend for main and additional plans
    // Show buildings legend only for floor plans
    // Hide all legends for building plans
    if (planLevel === 'floor') {
      $mainLegend.removeClass('is-active');
      $buildingsLegend.addClass('is-active');
    } else if (planLevel === 'building') {
      $mainLegend.removeClass('is-active');
      $buildingsLegend.removeClass('is-active');
    } else {
      $mainLegend.addClass('is-active');
      $buildingsLegend.removeClass('is-active');
    }
  }

  /**
   * Handle navigation button clicks
   */
  $investmentPlan.on('click', '[data-js="plan-button"]', function () {
    const $button = $(this);

    // Don't do anything if already active
    if ($button.hasClass('is-active')) {
      return;
    }
    const planId = $button.data('plan-id');
    const planLevel = $button.data('plan-level');
    const hasChildren = $button.data('has-children') === 'true' || $button.data('has-children') === true;

    // Remove active class from all buttons in current context
    $button.closest('ul').find('.button').removeClass('is-active');
    $button.addClass('is-active');

    // Switch to selected plan
    switchToPlan(planId);

    // Handle building navigation (two-level)
    if (navType === 'buildings') {
      const $allFloorNavs = $navigation.find('[data-js="plan-nav-floors"]');
      const $backButton = $navigation.find('[data-js="plan-back"]');
      if (planLevel === 'building' && hasChildren) {
        // Clear all floor active states when switching buildings
        $allFloorNavs.find('.button').removeClass('is-active');

        // Hide all floor navigations
        $allFloorNavs.hide();

        // Show floor navigation for this specific building
        const $floorNav = $navigation.find('[data-js="plan-nav-floors"][data-building-id="' + planId + '"]');
        $floorNav.show();

        // Show back button
        $backButton.show();
      } else if (planLevel === 'floor') {
        // Just show back button for floors
        $backButton.show();
      }
    }
  });

  /**
   * Handle back button click
   */
  $investmentPlan.on('click', '[data-js="plan-back"]', function () {
    const $backButton = $(this);
    const $allFloorNavs = $navigation.find('[data-js="plan-nav-floors"]');
    const $mainNav = $navigation.find('[data-js="plan-nav-main"]');

    // Hide all floor navigations and back button
    $allFloorNavs.hide();
    $backButton.hide();

    // Clear all active states
    $mainNav.find('.button').removeClass('is-active');
    $allFloorNavs.find('.button').removeClass('is-active');

    // Switch back to main plan
    const mainPlanId = $investmentPlan.find('[data-js="plan-container"][data-plan-level="main"]').data('plan-id');
    switchToPlan(mainPlanId);
  });

  /**
   * Initialize interactive features for a plan
   */
  function initializePlanInteractivity($plan) {
    const planRelation = $plan.data('plan-relation');
    const $svg = $plan.find('svg');
    const $paths = $svg.find('path');
    if (!$paths.length) return;

    // Get plan mapping data from data attribute using attr() to avoid jQuery auto-parsing
    let mappingDataString = $plan.attr('data-plan-mapping');
    let mappingData = {};
    if (mappingDataString) {
      try {
        mappingData = JSON.parse(mappingDataString);
      } catch (e) {
        console.error('Error parsing plan mapping data:', e);
        mappingData = {};
      }
    }

    // Apply mapping to paths
    applyMappingToPaths($paths, mappingData, planRelation);
  }

  /**
   * Apply mapping data to SVG paths as data attributes
   */
  function applyMappingToPaths($paths, mappingData, planRelation) {
    // If this is a property relation, load properties data from database
    if (planRelation === 'property') {
      const planId = $paths.closest('[data-js="plan-container"]').data('plan-id');
      loadPropertiesData(planId, function (properties) {
        applyMappingToPathsWithData($paths, mappingData, planRelation, properties);
      });
    } else {
      applyMappingToPathsWithData($paths, mappingData, planRelation, null);
    }
  }

  /**
   * Apply mapping with loaded data
   */
  function applyMappingToPathsWithData($paths, mappingData, planRelation, properties) {
    $paths.each(function (index) {
      const $path = $(this);
      const acfIndex = index + 1; // ACF indices start from 1
      let mappedValue = mappingData[acfIndex];
      if (mappedValue) {
        // If mappedValue is an object, extract the id
        if (typeof mappedValue === 'object' && mappedValue !== null) {
          mappedValue = mappedValue.id || mappedValue.value || null;
        }
        if (mappedValue) {
          // Add appropriate data attribute based on relation type
          if (planRelation === 'property') {
            $path.attr('data-vox-id', mappedValue);

            // Find property data
            const property = properties ? properties.find(p => p.vox_id == mappedValue) : null;
            if (property) {
              // Highlight available properties (status_id = 1 or 2)
              if (property.status_id == 1 || property.status_id == 2) {
                $path.addClass('status-available');
                $path.attr('data-js', 'property-link-tooltip');
              }

              // Add tooltip
              initializePropertyTooltip($path, property);
            } else {
              // Property not found in database
              initializePropertyTooltip($path, null);
            }
          } else if (planRelation === 'building' || planRelation === 'floor') {
            $path.attr('data-plan-id', mappedValue);
          }

          // Make path interactive
          $path.addClass('has-mapping');

          // Add click handler (only for building/floor)
          if (planRelation === 'building' || planRelation === 'floor') {
            $path.off('click.plan').on('click.plan', function (e) {
              e.preventDefault();
              e.stopPropagation();
              handlePathClick($path, planRelation);
            });
          }
        }
      } else {
        // No mapping - add tooltip for future properties
        if (planRelation === 'property') {
          initializeNoMappingTooltip($path);
          $path.addClass('status-planned');
        }
      }
    });
  }

  /**
   * Handle path click
   */
  function handlePathClick($path, planRelation) {
    if (planRelation === 'building' || planRelation === 'floor') {
      const mappedPlanId = parseInt($path.attr('data-plan-id'));
      if (mappedPlanId) {
        navigateToMappedPlan(mappedPlanId, planRelation);
      }
    }
  }

  /**
   * Navigate to a mapped plan (from path click)
   */
  function navigateToMappedPlan(planId, relationType) {
    const $targetPlan = $investmentPlan.find('[data-js="plan-container"][data-plan-id="' + planId + '"]');
    const $targetButton = $investmentPlan.find('[data-js="plan-button"][data-plan-id="' + planId + '"]');
    if (!$targetPlan.length) {
      return;
    }
    const targetPlanLevel = $targetPlan.data('plan-level');
    const targetParentId = $targetPlan.data('parent-id');
    if (navType === 'buildings') {
      const $backButton = $navigation.find('[data-js="plan-back"]');
      const $allFloorNavs = $navigation.find('[data-js="plan-nav-floors"]');
      const $mainNav = $navigation.find('[data-js="plan-nav-main"]');
      if (targetPlanLevel === 'building') {
        // Click on building button in main nav
        if ($targetButton.length) {
          $targetButton.trigger('click');
        }
      } else if (targetPlanLevel === 'floor') {
        // Need to show the parent building first, then select floor
        const $parentButton = $mainNav.find('[data-js="plan-button"][data-plan-id="' + targetParentId + '"]');
        if ($parentButton.length) {
          // Activate parent building
          $mainNav.find('.button').removeClass('is-active');
          $parentButton.addClass('is-active');

          // Hide all floor navs, show only the one for parent building
          $allFloorNavs.hide();
          const $floorNav = $navigation.find('[data-js="plan-nav-floors"][data-building-id="' + targetParentId + '"]');
          $floorNav.show();

          // Show back button
          $backButton.show();

          // Activate and switch to target floor
          $allFloorNavs.find('.button').removeClass('is-active');
          if ($targetButton.length) {
            $targetButton.addClass('is-active');
          }
          switchToPlan(planId);
        }
      }
    } else if ($targetButton.length) {
      $targetButton.trigger('click');
    } else {
      switchToPlan(planId);
    }
  }

  /**
   * Load properties data from database
   */
  function loadPropertiesData(planId, callback) {
    $.ajax({
      url: novisaData.ajax_url,
      type: 'POST',
      data: {
        action: 'novisa_get_properties_for_plan',
        plan_id: planId
      },
      success: function (response) {
        if (response.success && response.data) {
          callback(response.data);
        } else {
          callback([]);
        }
      },
      error: function () {
        callback([]);
      }
    });
  }

  /**
   * Initialize tooltip for property
   */
  function initializePropertyTooltip($path, property) {
    let tooltipContent;
    if (!property) {
      // Property not found or sold
      tooltipContent = window.novisaData.i18n.propertyTooltip.sold;
    } else if (property.status_id == 1 || property.status_id == 2) {
      // Available property - full tooltip (status 1 or 2)
      tooltipContent = createPropertyTooltipContent(property);
    } else {
      // Sold property
      tooltipContent = window.novisaData.i18n.propertyTooltip.sold;
    }
    if (window.innerWidth > 1199) {
      tippy($path[0], {
        content: tooltipContent,
        allowHTML: true,
        placement: 'top',
        theme: 'light',
        animation: 'shift-away',
        arrow: true,
        interactive: false
      });
    } else {
      const instance = tippy($path[0], {
        content: tooltipContent,
        allowHTML: true,
        placement: 'top',
        theme: 'light',
        animation: 'shift-away',
        arrow: true,
        interactive: true,
        appendTo: document.body,
        onCreate(instance) {
          const button = instance.popper.querySelector('[data-js="property-link"]');
          if (button) {
            button.addEventListener('click', function () {
              instance.hide();
            });
          }
        }
      });
    }
  }

  /**
   * Initialize tooltip for paths without mapping
   */
  function initializeNoMappingTooltip($path) {
    tippy($path[0], {
      content: window.novisaData.i18n.propertyTooltip.info,
      allowHTML: true,
      placement: 'top',
      theme: 'light',
      animation: 'shift-away',
      arrow: true,
      interactive: false
    });
  }

  /**
   * Create tooltip content for available property
   */
  function createPropertyTooltipContent(property) {
    let content = '<div class="tooltip-property-info"><div class="content">';

    // Heading with name, number and price
    content += '<div class="heading">';
    if (property.local_number) {
      content += '<p class="title text-md">' + window.novisaData.i18n.propertyTooltip.number + '</p>';
      content += '<p class="number text-md font-bold">' + escapeHtml(property.local_number) + '</p>';
    }
    if (property.price_formatted) {
      if (property.dont_send_to_www == 1) {
        content += '<p class="price text-xl font-bold"><span class="planned-label">' + window.novisaData.i18n.propertyTooltip.estimatedPrice + '</span>' + escapeHtml(property.price_formatted) + '</p>';
      } else {
        content += '<p class="price text-xl font-bold">' + escapeHtml(property.price_formatted) + '</p>';
      }
    }
    content += '</div>';

    // Property details
    content += '<ul class="info">';
    if (property.area_formatted) {
      content += '<li class="item">';
      content += '<span class="label text-sm">' + window.novisaData.i18n.propertyTooltip.area + '</span>';
      content += '<span class="value text-sm font-bold">' + escapeHtml(property.area_formatted) + '</span>';
      content += '</li>';
    }
    if (property.rooms) {
      content += '<li class="item">';
      content += '<span class="label text-sm">' + window.novisaData.i18n.propertyTooltip.rooms + '</span>';
      content += '<span class="value text-sm font-bold">' + escapeHtml(property.rooms) + '</span>';
      content += '</li>';
    }
    if (property.garden_formatted) {
      content += '<li class="item">';
      content += '<span class="label text-sm">' + window.novisaData.i18n.propertyTooltip.garden + '</span>';
      content += '<span class="value text-sm font-bold">' + escapeHtml(property.garden_formatted) + '</span>';
      content += '</li>';
    }
    if (property.balcony_formatted) {
      content += '<li class="item">';
      content += '<span class="label text-sm">' + window.novisaData.i18n.propertyTooltip.balcony + '</span>';
      content += '<span class="value text-sm font-bold">' + escapeHtml(property.balcony_formatted) + '</span>';
      content += '</li>';
    }
    if (property.terrace_formatted) {
      content += '<li class="item">';
      content += '<span class="label text-sm">' + window.novisaData.i18n.propertyTooltip.terrace + '</span>';
      content += '<span class="value text-sm font-bold">' + escapeHtml(property.terrace_formatted) + '</span>';
      content += '</li>';
    }

    // Storey list - display area for each floor level
    if (property.storey_list) {
      try {
        const storeyList = typeof property.storey_list === 'string' ? JSON.parse(property.storey_list) : property.storey_list;
        if (Array.isArray(storeyList) && storeyList.length > 0) {
          storeyList.forEach(function (storey, index) {
            if (storey.storey_area) {
              const floorLabel = getFloorLabel(index, storeyList.length, storeyList);
              content += '<li class="item">';
              content += '<span class="label text-sm">' + window.novisaData.i18n.propertyTooltip.area + ' - ' + escapeHtml(floorLabel) + '</span>';
              content += '<span class="value text-sm font-bold">' + formatArea(storey.storey_area) + '</span>';
              content += '</li>';
            }
          });
        }
      } catch (e) {
        console.error('Error parsing storey_list:', e);
      }
    }
    content += '</ul>';

    // Contiguities (parking spaces, storage, etc.)
    if (property.contiguities && property.contiguities.length > 0) {
      content += '<ul class="info">';
      property.contiguities.forEach(function (contiguity) {
        if (contiguity.contiguity_price_formatted) {
          content += '<li class="item">';
          content += '<span class="label text-sm">' + window.novisaData.i18n.propertyTooltip.price + ' - ' + escapeHtml(contiguity.contiguity_type) + '</span>';
          content += '<span class="value text-sm font-bold">' + escapeHtml(contiguity.contiguity_price_formatted) + '</span>';
          content += '</li>';
        }
      });
      content += '</ul>';
    }
    content += '<button data-js="property-link" data-vox-id="' + property.vox_id + '">' + window.novisaData.i18n.propertyTooltip.link + '</button>';
    content += '</div></div>';
    return content;
  }

  /**
   * Helper: Format area value
   * Returns formatted area with m² suffix (e.g., "45.50 m²")
   */
  function formatArea(area) {
    if (!area || isNaN(area)) {
      return '';
    }
    const numArea = parseFloat(area);
    return numArea.toFixed(2).replace(/\.?0+$/, '') + ' m²';
  }

  /**
   * Helper: Get floor label based on index and total count
   * Matches the logic from Property::get_floor_label() in PHP
   */
  function getFloorLabel(index, totalCount, storeyList) {
    // Check if storey_name exists in storeyList for this index
    // Note: storey_name is already translated by WPML in PHP
    if (storeyList && storeyList[index] && storeyList[index].storey_name && storeyList[index].storey_name !== '') {
      return storeyList[index].storey_name;
    }

    // Get translated labels from localized data
    const i18n = window.novisaData && window.novisaData.i18n && window.novisaData.i18n.floorLabels ? window.novisaData.i18n.floorLabels : {
      groundFloor: 'Parter',
      floor: 'Piętro'
    };

    // Fallback to default labels
    if (index === 0) {
      return i18n.groundFloor;
    }
    if (totalCount === 2 && index === 1) {
      return i18n.floor;
    }
    return i18n.floor + ' ' + index;
  }

  /**
   * Helper: Escape HTML
   */
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Initialize first visible plan
  const $initialPlan = $investmentPlan.find('[data-js="plan-container"]:visible').first();
  if ($initialPlan.length) {
    initializePlanInteractivity($initialPlan);
  }

  // Center default visible plan after full page load (including all images)
  // Using window.load instead of document.ready to ensure images are loaded
  // $(window).on('load', function() {
  //     centerDefaultPlanOnLoad();
  // });

  // Remove swipe overlay on click
  $investmentPlan.on('click touchend', '.b-investment-plan__map-swipe', function () {
    $(this).fadeOut(200, function () {
      $(this).remove();
    });
  });
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-js="slider-investment-presentation"]');
  if ($sliders.length > 0) {
    $sliders.each(function () {
      const $slider = $(this);
      const prevEl = $slider.find('[data-js="slider-prev"]')[0] || null;
      const nextEl = $slider.find('[data-js="slider-next"]')[0] || null;
      const slidesCount = $slider.find('.swiper-slide').length;
      new Swiper($slider[0], {
        slidesPerView: 1,
        spaceBetween: 20,
        speed: 700,
        loop: false,
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl
        } : {}
      });
    });
  }
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="investment-timeline"] [data-slider="slider"]');
  $sliders.each(function () {
    const $section = $(this).closest('[data-slider="investment-timeline"]');
    const $slider = $(this);
    const prevEl = $section.find('[data-js="slider-prev"]')[0];
    const nextEl = $section.find('[data-js="slider-next"]')[0];
    const $pagination = $section.find('[data-js="timeline-pagination"]');
    const $dots = $pagination.find('.dot');
    const $track = $pagination.find('.timeline-track-active');
    const initialSlide = parseInt($slider.data('initial-slide')) || 0;
    const swiper = new Swiper($slider[0], {
      slidesPerView: 1,
      spaceBetween: 16,
      speed: 700,
      grabCursor: true,
      a11y: false,
      initialSlide: initialSlide,
      navigation: {
        prevEl,
        nextEl
      },
      on: {
        init() {
          setTimeout(() => updateTimeline(this.activeIndex), 50);
        },
        slideChange() {
          updateTimeline(this.activeIndex);
        }
      }
    });
    $dots.on('click', function () {
      const index = $(this).data('index');
      swiper.slideTo(index);
      updateTimeline(index);
    });
    function updateTimeline(activeIndex) {
      $dots.removeClass('is-active is-completed');
      $dots.each(function (i) {
        if (i < activeIndex) $(this).addClass('is-completed');
        if (i === activeIndex) $(this).addClass('is-active');
      });
      const totalDots = $dots.length - 1;
      let progress = activeIndex / totalDots * 100;
      if (activeIndex === 0) progress = 0;
      if (activeIndex >= totalDots) progress = 100;
      $track.css('width', progress + '%');
    }
  });
});
jQuery(document).ready(function ($) {
  const $slider = $('[data-slider="investments-list"] [data-slider="slider"]');
  let swiper = null;
  let isSwiperInitialized = false;
  function toggleNav(swiper, prevEl, nextEl, paginationEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
      if (paginationEl) $(paginationEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
      if (paginationEl) $(paginationEl).show();
    }
  }
  function initSlider() {
    // Update selector to get fresh element after AJAX
    const $currentSlider = $('[data-slider="investments-list"] [data-slider="slider"]');
    if (!$currentSlider.length || !$currentSlider.find('.swiper-wrapper').length) return;
    const prevEl = $('.navigation-slider-mobile [data-js="slider-prev-mobile"]')[0] || undefined;
    const nextEl = $('.navigation-slider-mobile [data-js="slider-next-mobile"]')[0] || undefined;
    const paginationEl = $('.navigation-slider-mobile .swiper-pagination')[0] || undefined;

    // Clean pagination element from previous Swiper classes
    if (paginationEl) {
      $(paginationEl).removeClass('swiper-pagination-bullets-dynamic');
      $(paginationEl).empty();
    }
    swiper = new Swiper($currentSlider[0], {
      slidesPerView: 'auto',
      spaceBetween: 16,
      speed: 700,
      grabCursor: true,
      navigation: prevEl && nextEl ? {
        prevEl,
        nextEl
      } : undefined,
      pagination: paginationEl ? {
        el: paginationEl,
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 5
      } : undefined,
      breakpoints: {
        728: {
          spaceBetween: 24
        }
      },
      on: {
        init: function () {
          toggleNav(this, prevEl, nextEl, paginationEl);
        },
        resize: function () {
          toggleNav(this, prevEl, nextEl, paginationEl);
        },
        update: function () {
          toggleNav(this, prevEl, nextEl, paginationEl);
        }
      }
    });
    isSwiperInitialized = true;
  }
  function destroySlider() {
    if (swiper && swiper.destroy) swiper.destroy(true, true);
    swiper = null;
    isSwiperInitialized = false;
  }
  function checkBreakpoint() {
    if (window.innerWidth < 1200) {
      if (!isSwiperInitialized) {
        initSlider();
      }
    } else {
      if (isSwiperInitialized) {
        destroySlider();
      }
    }
  }

  // Expose reinit function globally for AJAX calls
  window.initInvestmentsSlider = function () {
    destroySlider();
    checkBreakpoint();
  };
  checkBreakpoint();
  $(window).on('resize', function () {
    checkBreakpoint();
  });
});
jQuery(document).ready(function ($) {
  if ($('[data-js="investments-most-popular"]').length > 0) {
    $('[data-js="investments-most-popular"]').each(function () {
      const $section = $(this);

      // Slider
      const swiper = new Swiper($section.find('[data-js="slider"]')[0], {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 700,
        grabCursor: false,
        navigation: {
          prevEl: $section.find('[data-js="slider-prev"]').toArray(),
          nextEl: $section.find('[data-js="slider-next"]').toArray()
        },
        pagination: {
          el: $section.find('[data-js="slider-pagination"]')[0],
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 5
        },
        breakpoints: {
          767: {
            spaceBetween: 24
          }
        }
      });

      // Set slider height to prevent jumping on filter change
      $section.find('[data-js="slider"]').css('min-height', $section.find('[data-js="slider"]').outerHeight());

      // Add initial animation to all slides
      $section.find('.swiper-slide').addClass('is-animated');

      // Filter
      $section.find('[data-js="filter"]').on('click', function () {
        if ($(this).hasClass('is-active')) return;
        const location = $(this).data('location');

        // Remove active class from all filters
        $section.find('[data-js="filter"]').removeClass('is-active');
        $(this).addClass('is-active');

        // Remove animation class to reset animation
        $section.find('.swiper-slide').removeClass('is-animated');

        // Show/hide investments by location (agglomeration or city)
        $section.find('.swiper-slide').hide();
        if (location === 'all') {
          $section.find('.swiper-slide').show();
        } else {
          $section.find('.swiper-slide[data-location="' + location + '"]').show();
        }

        // Update swiper after filtering
        swiper.updateSlides();
        swiper.update();
        if (swiper.pagination) {
          swiper.pagination.render();
          swiper.pagination.update();
        }

        // Add animation class back to visible slides
        $section.find('.swiper-slide:visible').addClass('is-animated');
      });
    });
  }
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="investments-recommended"]');
  let swipers = [];
  let isSwiperInitialized = false;
  function toggleNav(swiper, prevEl, nextEl, paginationEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
      if (paginationEl) $(paginationEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
      if (paginationEl) $(paginationEl).show();
    }
  }
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this);
      const $slider = $section.find('[data-slider="slider"]');
      const prevEl = $section.find('[data-js="slider-prev"]')[0] || null;
      const nextEl = $section.find('[data-js="slider-next"]')[0] || null;
      const paginationEl = $section.find('.swiper-pagination')[0] || null;
      const swiper = new Swiper($slider[0], {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 700,
        grabCursor: true,
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl
        } : {},
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true
        } : {},
        breakpoints: {
          767: {
            spaceBetween: 24
          }
        },
        on: {
          init: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          },
          resize: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          },
          update: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          }
        }
      });
      swipers.push(swiper);
    });
    isSwiperInitialized = true;
  }
  function destroySliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    isSwiperInitialized = false;
  }
  function checkBreakpoint() {
    if (window.innerWidth < 1200) {
      if (!isSwiperInitialized) {
        initSliders();
      }
    } else {
      if (isSwiperInitialized) {
        destroySliders();
      }
    }
  }

  // Initialize
  checkBreakpoint();

  // Re-initialize
  $(window).on('resize', function () {
    checkBreakpoint();
  });
});
const logoCarousel = () => {
  const carousels = document.querySelectorAll("[data-slider='logos'] .carousel-track");
  if (!carousels.length) return;
  carousels.forEach(track => {
    const wrapper = track.parentElement;
    const originalSlides = Array.from(track.children);
    if (!originalSlides.length) return;
    let columnGap = getColumnGap();
    function getColumnGap() {
      const style = window.getComputedStyle(track);
      return parseFloat(style.columnGap) || 0;
    }
    function measureSetWidth(slides) {
      let total = 0;
      slides.forEach((slide, index) => {
        total += slide.offsetWidth;
        if (index !== slides.length - 1) {
          total += columnGap;
        }
      });
      return total;
    }
    function setupSlides() {
      track.innerHTML = "";
      originalSlides.forEach(slide => track.appendChild(slide.cloneNode(true)));
      const baseSet = Array.from(track.children);
      const baseSetWidth = measureSetWidth(baseSet);
      for (let i = 0; i < 2; i++) {
        originalSlides.forEach(slide => track.appendChild(slide.cloneNode(true)));
      }
      return {
        baseSetWidth
      };
    }
    let {
      baseSetWidth: originalSetWidth
    } = setupSlides();
    let pos = 0;
    const speed = 0.5;
    let paused = false;
    wrapper.addEventListener("mouseenter", () => {
      if (!isDragging) {
        wrapper.style.cursor = "grab";
      }
      paused = true;
    });
    wrapper.addEventListener("mouseleave", () => {
      if (!isDragging) {
        wrapper.style.cursor = "default";
      }
      paused = false;
    });
    let isDragging = false;
    let dragStartX = 0;
    let dragLastX = 0;
    function onDragStart(clientX) {
      paused = true;
      isDragging = true;
      dragStartX = clientX;
      dragLastX = clientX;
      wrapper.style.cursor = "grabbing";
    }
    function onDragMove(clientX) {
      if (!isDragging) return;
      const deltaX = clientX - dragLastX;
      pos += deltaX;
      dragLastX = clientX;
      if (pos > 0) {
        pos -= originalSetWidth + columnGap;
      } else if (pos <= -(originalSetWidth + columnGap)) {
        pos += originalSetWidth + columnGap;
      }
      track.style.transform = `translateX(${pos}px)`;
    }
    function onDragEnd() {
      isDragging = false;
      paused = false;
      wrapper.style.cursor = "grab";
    }
    wrapper.addEventListener("mousedown", e => {
      e.preventDefault();
      onDragStart(e.clientX);
    });
    wrapper.addEventListener("touchstart", e => {
      if (e.touches.length === 1) {
        onDragStart(e.touches[0].clientX);
      }
    });
    window.addEventListener("mousemove", e => {
      if (isDragging) {
        e.preventDefault();
        onDragMove(e.clientX);
      }
    });
    window.addEventListener("touchmove", e => {
      if (isDragging && e.touches.length === 1) {
        onDragMove(e.touches[0].clientX);
      }
    }, {
      passive: false
    });
    window.addEventListener("mouseup", () => {
      if (isDragging) onDragEnd();
    });
    window.addEventListener("touchend", () => {
      if (isDragging) onDragEnd();
    });
    function animate() {
      if (!paused && !isDragging) {
        pos -= speed;
        if (pos <= -(originalSetWidth + columnGap)) {
          pos += originalSetWidth + columnGap;
        }
        track.style.transform = `translateX(${pos}px)`;
      }
      requestAnimationFrame(animate);
    }
    animate();
    window.addEventListener("resize", () => {
      columnGap = getColumnGap();
      track.style.transition = "none";
      pos = 0;
      track.style.transform = `translateX(${pos}px)`;
      const setup = setupSlides();
      originalSetWidth = setup.baseSetWidth;
      paused = false;
    });
  });
};
document.addEventListener('DOMContentLoaded', logoCarousel);
(function () {
  'use strict';

  const CONFIG = {
    selectors: {
      wrapper: '[data-js="mapbox-investment-location"]',
      mapContainer: 'mapbox-investment-location',
      initButton: '[data-js="init-mapbox"]',
      placeholder: '[data-js="map-placeholder"]'
    },
    map: {
      defaultCenter: [19.1451, 52.2370],
      defaultZoom: 6,
      maxZoom: 16,
      minZoom: 5,
      markerZoom: 16,
      overviewZoom: 12,
      style: 'mapbox://styles/mapbox/light-v11'
    },
    marker: {
      width: 40,
      height: 40,
      iconSize: 1,
      padding: 0,
      backgroundColor: ''
    },
    animation: {
      speed: 3,
      easing: t => t,
      duration: 0
    },
    popup: {
      offset: [0, -45],
      anchor: 'bottom',
      closeButton: false,
      closeOnClick: false,
      focusAfterOpen: false
    },
    padding: {
      top: 80,
      bottom: 80,
      left: 80,
      right: 80
    },
    cluster: {
      maxZoom: 10,
      radius: 50,
      color: '#0189E4',
      circleRadius: 20
    }
  };
  function getPadding(includeMarkerHeight = true) {
    return {
      top: CONFIG.padding.top + (includeMarkerHeight ? CONFIG.marker.height : 0),
      bottom: CONFIG.padding.bottom,
      left: CONFIG.padding.left,
      right: CONFIG.padding.right
    };
  }
  function initMapboxLocationMap() {
    document.addEventListener('DOMContentLoaded', function () {
      const wrapper = document.querySelector(CONFIG.selectors.wrapper);
      if (!wrapper) return;
      const mapContainer = document.getElementById(CONFIG.selectors.mapContainer);
      if (!mapContainer) return;
      const initButton = wrapper.querySelector(CONFIG.selectors.initButton);
      if (!initButton) return;
      const placeholder = mapContainer.querySelector(CONFIG.selectors.placeholder);
      let isInitialized = false;
      initButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (isInitialized) return;
        isInitialized = true;
        if (placeholder) placeholder.classList.add('is-inactive');
        if (typeof mapboxgl === 'undefined') return;
        if (!novisaData?.mapbox?.token) return;
        initButton.disabled = true;
        mapboxgl.accessToken = novisaData.mapbox.token;
        const map = new mapboxgl.Map({
          container: CONFIG.selectors.mapContainer,
          style: novisaData?.mapbox?.style || CONFIG.map.style,
          center: CONFIG.map.defaultCenter,
          zoom: CONFIG.map.defaultZoom,
          projection: 'mercator',
          maxZoom: CONFIG.map.maxZoom,
          minZoom: CONFIG.map.minZoom,
          pitchWithRotate: true,
          dragRotate: true,
          attributionControl: false
        });
        map.addControl(new mapboxgl.AttributionControl({
          compact: true
        }), 'bottom-right');
        map.addControl(new mapboxgl.NavigationControl({
          showCompass: true,
          showZoom: true,
          visualizePitch: true
        }), 'top-right');
        let activePopup = null;
        let currentBounds = null;
        const loadedIcons = {};
        function convertSvgToPng(svgUrl, callback) {
          fetch(svgUrl).then(r => {
            if (!r.ok) throw new Error('HTTP error');
            return r.text();
          }).then(svgText => {
            const canvas = document.createElement('canvas');
            canvas.width = CONFIG.marker.width;
            canvas.height = CONFIG.marker.height;
            const ctx = canvas.getContext('2d');
            const img = new Image();
            const blob = new Blob([svgText], {
              type: 'image/svg+xml'
            });
            const url = URL.createObjectURL(blob);
            img.onload = () => {
              const size = CONFIG.marker.width - CONFIG.marker.padding * 2;
              ctx.drawImage(img, CONFIG.marker.padding, CONFIG.marker.padding, size, size);
              URL.revokeObjectURL(url);
              canvas.toBlob(b => {
                if (!b) {
                  callback(new Error('PNG create error'));
                  return;
                }
                createImageBitmap(b).then(bitmap => callback(null, bitmap)).catch(err => callback(err));
              }, 'image/png');
            };
            img.onerror = () => callback(new Error('SVG load error'));
            img.src = url;
          }).catch(err => callback(err));
        }
        function getIconName(iconUrl) {
          const name = iconUrl.split('/').pop().replace(/\.[^/.]+$/, '');
          return `marker-${name}`;
        }
        function isValidIconUrl(iconUrl) {
          if (!iconUrl) return false;
          if (typeof iconUrl !== 'string') return false;
          if (iconUrl.includes('//.svg') || iconUrl.endsWith('/.svg')) return false;
          return true;
        }
        function loadMarkerIcon(iconUrl, callback) {
          const iconName = getIconName(iconUrl);
          if (loadedIcons[iconUrl]) {
            callback(null, iconName);
            return;
          }
          convertSvgToPng(iconUrl, (err, bitmap) => {
            if (err) {
              callback(err);
              return;
            }
            if (!map.hasImage(iconName)) {
              map.addImage(iconName, bitmap);
            }
            loadedIcons[iconUrl] = iconName;
            callback(null, iconName);
          });
        }
        function closeActivePopup(restoreView = false) {
          if (!activePopup) return;
          activePopup.remove();
          activePopup = null;
          if (restoreView && currentBounds) {
            map.fitBounds(currentBounds, {
              padding: getPadding(),
              maxZoom: CONFIG.map.overviewZoom,
              speed: CONFIG.animation.speed,
              easing: CONFIG.animation.easing
            });
          }
        }
        function createPopup(coordinates, address) {
          closeActivePopup();
          activePopup = new mapboxgl.Popup(CONFIG.popup).setLngLat(coordinates).setHTML(`
                            <div class="popup">
                                <button class="popup-close" tabindex="-1" aria-label="Close">✕</button>
                                <p class="popup-title">${address}</p>
                            </div>
                        `).addTo(map);
          setTimeout(() => {
            const btn = activePopup.getElement()?.querySelector('.popup-close');
            if (btn) {
              btn.addEventListener('click', e => {
                e.stopPropagation();
                closeActivePopup(true);
              });
            }
          }, 10);
        }
        function createMarkerFeatures(pointElements) {
          const features = [];
          const icons = new Set();
          pointElements.forEach(el => {
            const lat = parseFloat(el.dataset.latitude);
            const lng = parseFloat(el.dataset.longitude);
            if (isNaN(lat) || isNaN(lng)) return;
            const iconUrlRaw = el.dataset.marker;
            const iconUrl = isValidIconUrl(iconUrlRaw) ? iconUrlRaw : '';
            if (iconUrl) icons.add(iconUrl);
            const isDefault = el.dataset.defaultPopup === 'true';
            features.push({
              type: 'Feature',
              geometry: {
                type: 'Point',
                coordinates: [lng, lat]
              },
              properties: {
                address: el.dataset.address || '',
                iconName: iconUrl ? getIconName(iconUrl) : 'marker-pin',
                defaultPopup: isDefault,
                sortKey: isDefault ? 9999 : 0
              }
            });
          });
          return {
            features,
            icons
          };
        }
        function loadLocationPoints() {
          const points = wrapper.querySelector('points');
          if (!points) return {
            features: [],
            icons: new Set()
          };
          return createMarkerFeatures(points.querySelectorAll('point'));
        }
        function updateMarkers(features) {
          const src = map.getSource('markers');
          if (!src) return;
          src.setData({
            type: 'FeatureCollection',
            features
          });
        }
        function loadIconsAndMarkers(icons, features, cb) {
          if (!icons.size) {
            updateMarkers(features);
            cb && cb();
            return;
          }
          let loaded = 0;
          const total = icons.size;
          const done = () => {
            loaded++;
            if (loaded === total) {
              updateMarkers(features);
              cb && cb();
            }
          };
          icons.forEach(url => {
            loadMarkerIcon(url, () => done());
          });
        }
        function fitToMarkers(features) {
          if (!features.length) return;
          const bounds = new mapboxgl.LngLatBounds();
          features.forEach(f => bounds.extend(f.geometry.coordinates));
          currentBounds = bounds;
          map.fitBounds(bounds, {
            padding: getPadding(),
            maxZoom: CONFIG.map.overviewZoom,
            duration: 0,
            animate: false
          });
        }
        function handleMarkerClick(feature) {
          const coords = feature.geometry.coordinates.slice();
          const address = feature.properties.address;
          if (activePopup) {
            const p = activePopup.getLngLat();
            if (Math.abs(p.lng - coords[0]) < 0.0001 && Math.abs(p.lat - coords[1]) < 0.0001) {
              return;
            }
          }
          closeActivePopup(false);
          createPopup(coords, address);
        }
        function handleClusterClick(feature) {
          const id = feature.properties.cluster_id;
          const src = map.getSource('markers');
          src.getClusterExpansionZoom(id, (err, zoom) => {
            if (err) return;
            map.easeTo({
              center: feature.geometry.coordinates,
              zoom,
              easing: CONFIG.animation.easing
            });
          });
        }
        function setupEvents() {
          map.on('click', e => {
            const marker = map.queryRenderedFeatures(e.point, {
              layers: ['unclustered-point']
            });
            if (marker.length) {
              handleMarkerClick(marker[0]);
              return;
            }
            const cluster = map.queryRenderedFeatures(e.point, {
              layers: ['clusters']
            });
            if (cluster.length) {
              handleClusterClick(cluster[0]);
              return;
            }
            closeActivePopup(true);
          });
          ['clusters', 'unclustered-point'].forEach(layer => {
            map.on('mouseenter', layer, () => map.getCanvas().style.cursor = 'pointer');
            map.on('mouseleave', layer, () => map.getCanvas().style.cursor = '');
          });
        }
        map.on('load', () => {
          if (placeholder) placeholder.remove();
          const {
            features,
            icons
          } = loadLocationPoints();
          map.addSource('markers', {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            },
            cluster: true,
            clusterMaxZoom: CONFIG.cluster.maxZoom,
            clusterRadius: CONFIG.cluster.radius
          });
          map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'markers',
            filter: ['has', 'point_count'],
            paint: {
              'circle-color': CONFIG.cluster.color,
              'circle-radius': CONFIG.cluster.circleRadius
            }
          });
          map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'markers',
            filter: ['has', 'point_count'],
            layout: {
              'text-field': ['get', 'point_count_abbreviated'],
              'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
              'text-size': 14
            },
            paint: {
              'text-color': '#fff'
            }
          });
          map.addLayer({
            id: 'unclustered-point',
            type: 'symbol',
            source: 'markers',
            filter: ['!', ['has', 'point_count']],
            layout: {
              'icon-image': ['get', 'iconName'],
              'icon-size': CONFIG.marker.iconSize,
              'icon-allow-overlap': true,
              'icon-anchor': 'bottom',
              'symbol-sort-key': ['get', 'sortKey']
            }
          });
          loadIconsAndMarkers(icons, features, () => {
            fitToMarkers(features);
            const def = features.find(f => f.properties.defaultPopup);
            if (def) {
              setTimeout(() => {
                createPopup(def.geometry.coordinates, def.properties.address);
              }, 100);
            }
          });
          setupEvents();
        });
      });
    });
  }
  initMapboxLocationMap();
})();
// ============================================================================
// INVESTMENTS MAP - Mapbox Integration
// ============================================================================

(function () {
  'use strict';

  // ========================================================================
  // CONFIGURATION
  // ========================================================================
  const CONFIG = {
    selectors: {
      wrapper: '[data-js="mapbox-investments"]',
      mapContainer: 'mapbox-investments',
      initButton: '[data-js="init-mapbox"]',
      placeholder: '[data-js="map-placeholder"]'
    },
    map: {
      defaultCenter: [19.1451, 52.2370],
      defaultZoom: 6,
      maxZoom: 16,
      minZoom: 5,
      markerZoom: 16,
      overviewZoom: 12,
      style: 'mapbox://styles/mapbox/light-v11'
    },
    marker: {
      maxHeight: 40,
      iconSize: 1
    },
    animation: {
      speed: 3,
      easing: t => t,
      duration: 0
    },
    popup: {
      offset: [0, -45],
      anchor: 'bottom',
      closeButton: false,
      closeOnClick: false
    },
    padding: {
      top: 80,
      bottom: 80,
      left: 80,
      right: 80
    },
    cluster: {
      maxZoom: 10,
      radius: 50,
      color: '#0189E4',
      circleRadius: 20
    }
  };

  // ========================================================================
  // UTILITY FUNCTIONS
  // ========================================================================

  function getPadding(includeMarkerHeight = true) {
    return {
      top: CONFIG.padding.top + (includeMarkerHeight ? CONFIG.marker.maxHeight : 0),
      bottom: CONFIG.padding.bottom,
      left: CONFIG.padding.left,
      right: CONFIG.padding.right
    };
  }

  // ========================================================================
  // MAPBOX MAP MODULE
  // ========================================================================

  function initMapboxInvestmentMap() {
    document.addEventListener("DOMContentLoaded", function () {
      const wrapper = document.querySelector(CONFIG.selectors.wrapper);
      if (!wrapper) return;
      const mapContainer = document.getElementById(CONFIG.selectors.mapContainer);
      if (!mapContainer) return;
      const initButton = wrapper.querySelector(CONFIG.selectors.initButton);
      if (!initButton) return;
      const placeholder = mapContainer.querySelector(CONFIG.selectors.placeholder);
      let isInitialized = false;
      initButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (isInitialized) return;
        isInitialized = true;
        if (placeholder) placeholder.classList.add('is-inactive');
        if (typeof mapboxgl === "undefined") {
          console.warn('Mapbox GL JS library is not loaded');
          return;
        }
        if (!novisaData?.mapbox?.token) {
          console.warn('Mapbox token is not defined');
          return;
        }
        initButton.disabled = true;
        mapboxgl.accessToken = novisaData.mapbox.token;
        const map = new mapboxgl.Map({
          container: CONFIG.selectors.mapContainer,
          style: novisaData?.mapbox?.style || CONFIG.map.style,
          center: CONFIG.map.defaultCenter,
          zoom: CONFIG.map.defaultZoom,
          projection: 'mercator',
          maxZoom: CONFIG.map.maxZoom,
          minZoom: CONFIG.map.minZoom,
          pitchWithRotate: true,
          dragRotate: true,
          attributionControl: false
        });
        map.addControl(new mapboxgl.AttributionControl({
          compact: true
        }), 'bottom-right');
        map.addControl(new mapboxgl.NavigationControl({
          showCompass: true,
          showZoom: true,
          visualizePitch: true
        }), 'top-right');
        let activePopup = null;
        let currentBounds = null;
        const loadedIcons = {};
        function convertSvgToPng(svgUrl, callback) {
          fetch(svgUrl).then(response => response.text()).then(svgText => {
            const image = new Image();
            const svgBlob = new Blob([svgText], {
              type: 'image/svg+xml'
            });
            const blobUrl = URL.createObjectURL(svgBlob);
            image.onload = function () {
              const aspectRatio = image.width / image.height;
              const height = CONFIG.marker.maxHeight;
              const width = Math.round(height * aspectRatio);
              const canvas = document.createElement('canvas');
              canvas.width = width;
              canvas.height = height;
              const context = canvas.getContext('2d');
              context.drawImage(image, 0, 0, width, height);
              URL.revokeObjectURL(blobUrl);
              canvas.toBlob(blob => {
                createImageBitmap(blob).then(imageBitmap => {
                  callback(null, imageBitmap);
                });
              }, 'image/png');
            };
            image.onerror = () => callback(new Error('Failed to load SVG'));
            image.src = blobUrl;
          }).catch(error => callback(error));
        }
        function getIconName(iconUrl) {
          const fileName = iconUrl.split('/').pop().replace(/\.[^/.]+$/, '');
          return `marker-${fileName}`;
        }
        function loadMarkerIcon(iconUrl, callback) {
          const iconName = getIconName(iconUrl);
          if (loadedIcons[iconUrl]) {
            callback(null, iconName);
            return;
          }
          convertSvgToPng(iconUrl, (error, imageBitmap) => {
            if (error) {
              console.error(`Error loading icon ${iconUrl}:`, error);
              callback(error);
              return;
            }
            if (!map.hasImage(iconName)) {
              map.addImage(iconName, imageBitmap);
            }
            loadedIcons[iconUrl] = iconName;
            callback(null, iconName);
          });
        }
        function closeActivePopup(restoreView = false) {
          if (!activePopup) return;
          activePopup.remove();
          activePopup = null;
          if (restoreView && currentBounds) {
            map.fitBounds(currentBounds, {
              padding: getPadding(),
              maxZoom: CONFIG.map.overviewZoom,
              speed: CONFIG.animation.speed,
              easing: CONFIG.animation.easing
            });
          }
        }
        function createPopup(coordinates, title) {
          closeActivePopup();
          activePopup = new mapboxgl.Popup(CONFIG.popup).setLngLat(coordinates).setHTML(`
                            <div class="popup">
                                <button class="popup-close" aria-label="Close">✕</button>
                                <p class="popup-title">${title}</p>
                            </div>
                        `).addTo(map);
          setTimeout(() => {
            const closeButton = activePopup.getElement()?.querySelector(".popup-close");
            if (closeButton) {
              closeButton.addEventListener("click", event => {
                event.stopPropagation();
                closeActivePopup(true);
              });
            }
          }, 10);
        }
        function createMarkerFeatures(pointElements) {
          const markerFeatures = [];
          const iconsToLoad = new Set();
          pointElements.forEach(pointElement => {
            const pointLat = parseFloat(pointElement.dataset.latitude);
            const pointLng = parseFloat(pointElement.dataset.longitude);
            const title = pointElement.dataset.title || "";
            const markerIconUrl = pointElement.dataset.marker;
            if (markerIconUrl) {
              iconsToLoad.add(markerIconUrl);
            }
            if (!isNaN(pointLat) && !isNaN(pointLng)) {
              markerFeatures.push({
                type: 'Feature',
                geometry: {
                  type: 'Point',
                  coordinates: [pointLng, pointLat]
                },
                properties: {
                  title,
                  markerIconUrl,
                  iconName: markerIconUrl ? getIconName(markerIconUrl) : 'marker-pin'
                }
              });
            }
          });
          return {
            markerFeatures,
            iconsToLoad
          };
        }
        function loadInvestmentPoints() {
          const pointsWrapper = wrapper.querySelector("points");
          if (!pointsWrapper) return {
            markerFeatures: [],
            iconsToLoad: new Set()
          };
          const pointElements = pointsWrapper.querySelectorAll("point");
          return createMarkerFeatures(pointElements);
        }
        function updateMapMarkers(markerFeatures) {
          const source = map.getSource('markers');
          if (source) {
            source.setData({
              type: 'FeatureCollection',
              features: markerFeatures
            });
          }
        }
        function loadIconsAndUpdateMarkers(iconsToLoad, markerFeatures, callback) {
          if (iconsToLoad.size === 0) {
            updateMapMarkers(markerFeatures);
            if (callback) callback();
            return;
          }
          let iconsLoadedCount = 0;
          const totalIconsCount = iconsToLoad.size;
          iconsToLoad.forEach(iconUrl => {
            loadMarkerIcon(iconUrl, () => {
              iconsLoadedCount++;
              if (iconsLoadedCount === totalIconsCount) {
                updateMapMarkers(markerFeatures);
                if (callback) callback();
              }
            });
          });
        }
        function fitMapToMarkers(markerFeatures) {
          if (markerFeatures.length === 0) return;
          const bounds = new mapboxgl.LngLatBounds();
          markerFeatures.forEach(feature => {
            bounds.extend(feature.geometry.coordinates);
          });
          currentBounds = bounds;
          map.fitBounds(bounds, {
            padding: getPadding(),
            maxZoom: CONFIG.map.overviewZoom,
            duration: CONFIG.animation.duration
          });
        }
        function handleMarkerClick(feature) {
          const coordinates = feature.geometry.coordinates.slice();
          const {
            title
          } = feature.properties;
          if (activePopup) {
            const popupCoords = activePopup.getLngLat();
            if (Math.abs(popupCoords.lng - coordinates[0]) < 0.0001 && Math.abs(popupCoords.lat - coordinates[1]) < 0.0001) {
              return;
            }
          }
          closeActivePopup(false);
          map.flyTo({
            center: coordinates,
            zoom: CONFIG.map.markerZoom,
            speed: CONFIG.animation.speed,
            easing: CONFIG.animation.easing,
            essential: true
          });
          map.once('moveend', () => {
            createPopup(coordinates, title);
          });
        }
        function handleClusterClick(feature) {
          const clusterId = feature.properties.cluster_id;
          const source = map.getSource('markers');
          if (source) {
            source.getClusterExpansionZoom(clusterId, (error, zoom) => {
              if (error) return;
              map.easeTo({
                center: feature.geometry.coordinates,
                zoom: zoom,
                easing: CONFIG.animation.easing
              });
            });
          }
        }
        function setupClickHandlers() {
          map.on('click', event => {
            const markerFeatures = map.queryRenderedFeatures(event.point, {
              layers: ['unclustered-point']
            });
            if (markerFeatures.length > 0) {
              handleMarkerClick(markerFeatures[0]);
              return;
            }
            const clusterFeatures = map.queryRenderedFeatures(event.point, {
              layers: ['clusters']
            });
            if (clusterFeatures.length > 0) {
              handleClusterClick(clusterFeatures[0]);
              return;
            }
            closeActivePopup(true);
          });
        }
        function setupHoverHandlers() {
          ['clusters', 'unclustered-point'].forEach(layerName => {
            map.on('mouseenter', layerName, () => {
              map.getCanvas().style.cursor = 'pointer';
            });
            map.on('mouseleave', layerName, () => {
              map.getCanvas().style.cursor = '';
            });
          });
        }
        map.on('load', () => {
          if (placeholder) placeholder.remove();
          const {
            markerFeatures,
            iconsToLoad
          } = loadInvestmentPoints();
          map.addSource('markers', {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            },
            cluster: true,
            clusterMaxZoom: CONFIG.cluster.maxZoom,
            clusterRadius: CONFIG.cluster.radius
          });
          map.addLayer({
            id: 'clusters',
            type: 'circle',
            source: 'markers',
            filter: ['has', 'point_count'],
            paint: {
              'circle-color': CONFIG.cluster.color,
              'circle-radius': CONFIG.cluster.circleRadius,
              'circle-stroke-width': 0
            }
          });
          map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'markers',
            filter: ['has', 'point_count'],
            layout: {
              'text-field': ['get', 'point_count_abbreviated'],
              'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
              'text-size': 14
            },
            paint: {
              'text-color': '#ffffff'
            }
          });
          map.addLayer({
            id: 'unclustered-point',
            type: 'symbol',
            source: 'markers',
            filter: ['!', ['has', 'point_count']],
            layout: {
              'icon-image': ['get', 'iconName'],
              'icon-size': CONFIG.marker.iconSize,
              'icon-allow-overlap': true,
              'icon-anchor': 'bottom'
            }
          });
          loadIconsAndUpdateMarkers(iconsToLoad, markerFeatures, () => {
            fitMapToMarkers(markerFeatures);
          });
          setupClickHandlers();
          setupHoverHandlers();
        });
      });
    });
  }

  // ========================================================================
  // INITIALIZATION
  // ========================================================================

  initMapboxInvestmentMap();
})();
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="packages"] [data-slider="slider"]');
  let swipers = [];
  function toggleNav(swiper, prevEl, nextEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
    }
  }
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this).closest('[data-slider="packages"]');
      const $slider = $(this);
      const prevEl = $section.find('[data-js="slider-prev"]')[0] || null;
      const nextEl = $section.find('[data-js="slider-next"]')[0] || null;
      const swiper = new Swiper($slider[0], {
        slidesPerView: 'auto',
        spaceBetween: 8,
        speed: 700,
        grabCursor: true,
        navigation: {
          prevEl,
          nextEl
        },
        breakpoints: {
          767: {
            spaceBetween: 32
          }
        },
        on: {
          init: function () {
            toggleNav(this, prevEl, nextEl);
          },
          resize: function () {
            toggleNav(this, prevEl, nextEl);
          },
          update: function () {
            toggleNav(this, prevEl, nextEl);
          }
        }
      });
      swipers.push(swiper);
    });
  }

  // Initialize
  if ($sliders.length > 0) {
    initSliders();
  }
});
jQuery(document).ready(function ($) {
  if ($('[data-js="properties-commercial"]').length > 0) {
    $('[data-js="properties-commercial"]').each(function () {
      const $section = $(this);

      // Slider
      const swiper = new Swiper($section.find('[data-js="slider"]')[0], {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 700,
        grabCursor: false,
        navigation: {
          prevEl: $section.find('[data-js="slider-prev"]').toArray(),
          nextEl: $section.find('[data-js="slider-next"]').toArray()
        },
        pagination: {
          el: $section.find('[data-js="slider-pagination"]')[0],
          clickable: true
        },
        breakpoints: {
          767: {
            spaceBetween: 24
          }
        }
      });

      // Set slider height to prevent jumping on filter change
      $section.find('[data-js="slider"]').css('min-height', $section.find('[data-js="slider"]').outerHeight());

      // Add initial animation to all slides
      $section.find('.swiper-slide').addClass('is-animated');

      // Filter
      $section.find('[data-js="filter"]').on('click', function () {
        if ($(this).hasClass('is-active')) return;
        const transactionType = $(this).data('transaction-type');

        // Remove active class from all filters
        $section.find('[data-js="filter"]').removeClass('is-active');
        $(this).addClass('is-active');

        // Remove animation class to reset animation
        $section.find('.swiper-slide').removeClass('is-animated');

        // Show/hide properties
        $section.find('[data-js="property-commercial"]').parent().hide();
        if (transactionType === 'all') {
          $section.find('[data-js="property-commercial"]').parent().show();
        } else {
          $section.find('[data-js="property-commercial"][data-transaction-type="' + transactionType + '"]').parent().show();
        }

        // Update swiper after filtering
        swiper.updateSlides();
        swiper.update();
        if (swiper.pagination) {
          swiper.pagination.render();
          swiper.pagination.update();
        }

        // Add animation class back to visible slides
        $section.find('[data-js="property-commercial"]:visible').parent().addClass('is-animated');
      });
    });
  }
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="properties-most-popular"]');
  let swipers = [];
  let currentBreakpoint = window.innerWidth >= 1200 ? 'desktop' : 'mobile';
  function toggleNav(swiper, prevEl, nextEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
    }
  }
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this);
      const $slider = $section.find('[data-slider="slider"]');
      let prevEl, nextEl, paginationEl;
      if (window.innerWidth >= 1200) {
        prevEl = $section.find('[data-js="slider-prev-desktop"]')[0];
        nextEl = $section.find('[data-js="slider-next-desktop"]')[0];
      } else {
        prevEl = $section.find('[data-js="slider-prev-mobile"]')[0];
        nextEl = $section.find('[data-js="slider-next-mobile"]')[0];
      }
      paginationEl = $section.find('.swiper-pagination')[0];

      // Clean pagination element from previous Swiper classes
      if (paginationEl) {
        $(paginationEl).removeClass('swiper-pagination-bullets-dynamic');
        $(paginationEl).empty();
      }
      const swiper = new Swiper($slider[0], {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 700,
        grabCursor: false,
        navigation: {
          prevEl,
          nextEl
        },
        pagination: {
          el: paginationEl,
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 5
        },
        breakpoints: {
          767: {
            slidesPerView: 'auto',
            spaceBetween: 24
          }
        },
        on: {
          init: function () {
            toggleNav(this, prevEl, nextEl);
          },
          resize: function () {
            toggleNav(this, prevEl, nextEl);
          },
          update: function () {
            toggleNav(this, prevEl, nextEl);
          }
        }
      });
      swipers.push(swiper);

      // Keep a reference on the section so the regionalization filter can update it.
      $section.data('mpSwiper', swiper);
    });
  }

  // Refresh navigation arrows for the active breakpoint of a given section.
  function refreshSectionNav($section, swiper) {
    let prevEl, nextEl;
    if (window.innerWidth >= 1200) {
      prevEl = $section.find('[data-js="slider-prev-desktop"]')[0];
      nextEl = $section.find('[data-js="slider-next-desktop"]')[0];
    } else {
      prevEl = $section.find('[data-js="slider-prev-mobile"]')[0];
      nextEl = $section.find('[data-js="slider-next-mobile"]')[0];
    }
    toggleNav(swiper, prevEl, nextEl);
  }

  // Switch the visible list for a given region (falls back to the default 'all' list).
  function applyRegion(region) {
    const requested = region || 'all';
    $sliders.each(function () {
      const $section = $(this);

      // Use the region list when it exists in this section, otherwise show the default list.
      let listKey = requested;
      if (requested !== 'all' && $section.find('.swiper-slide[data-location="' + requested + '"]').length === 0) {
        listKey = 'all';
      }
      $section.find('.swiper-slide').hide();
      $section.find('.swiper-slide[data-location="' + listKey + '"]').show();
      const swiper = $section.data('mpSwiper');
      if (swiper) {
        swiper.updateSlides();
        swiper.update();
        if (swiper.pagination) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
        swiper.slideTo(0, 0);
        refreshSectionNav($section, swiper);
      }
    });
  }

  // React to region changes triggered from any module (switcher, search form, tabs, etc.).
  $(document).on('novisa:region-changed', function (event, region) {
    if ($sliders.length > 0) {
      applyRegion(region);
    }
  });

  // Initialize
  if ($sliders.length > 0) {
    initSliders();
  }

  // Re-initialize
  $(window).on('resize', function () {
    const newBreakpoint = window.innerWidth >= 1200 ? 'desktop' : 'mobile';
    if (newBreakpoint !== currentBreakpoint) {
      if ($sliders.length > 0) {
        initSliders();
      }
      currentBreakpoint = newBreakpoint;
    }
  });
});
jQuery(document).ready(function ($) {
  if ($('[data-js="properties-ready-to-handover"]').length > 0) {
    $('[data-js="properties-ready-to-handover"]').each(function () {
      const $section = $(this);
      const $slider = $section.find('[data-js="slider"]');
      if (!$slider.length) {
        return;
      }
      const swiper = new Swiper($slider[0], {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 700,
        grabCursor: false,
        navigation: {
          prevEl: $section.find('[data-js="slider-prev"]').toArray(),
          nextEl: $section.find('[data-js="slider-next"]').toArray()
        },
        pagination: {
          el: $section.find('[data-js="slider-pagination"]')[0],
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 5
        },
        breakpoints: {
          767: {
            spaceBetween: 24
          }
        }
      });
      $slider.css('min-height', $slider.outerHeight());
      $section.find('.swiper-slide').addClass('is-animated');
      $section.find('[data-js="filter"]').on('click', function () {
        if ($(this).hasClass('is-active')) return;
        const location = $(this).data('location');
        $section.find('[data-js="filter"]').removeClass('is-active');
        $(this).addClass('is-active');
        $section.find('.swiper-slide').removeClass('is-animated');
        $section.find('.swiper-slide').hide();
        if (location === 'all') {
          $section.find('.swiper-slide').show();
        } else {
          $section.find('.swiper-slide[data-location="' + location + '"]').show();
        }
        swiper.updateSlides();
        swiper.update();
        if (swiper.pagination) {
          swiper.pagination.render();
          swiper.pagination.update();
        }
        $section.find('.swiper-slide:visible').addClass('is-animated');
      });
    });
  }
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="properties-related"]');
  let swipers = [];
  let currentBreakpoint = window.innerWidth >= 1200 ? 'desktop' : 'mobile';
  function toggleNav(swiper, prevEl, nextEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
    }
  }
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this);
      $section.find('[data-slider="slider"]').each(function () {
        const $slider = $(this);
        const $tabContent = $slider.closest('[data-js="tab-content"]');
        const tabName = $tabContent.data('tab');
        const paginationEl = $section.find('.swiper-pagination')[0];
        let prevEl, nextEl;
        if (window.innerWidth >= 1200) {
          prevEl = $section.find('.navigation-slider-desktop .navigation-slider [data-js="slider-prev-desktop"]')[0];
          nextEl = $section.find('.navigation-slider-desktop .navigation-slider [data-js="slider-next-desktop"]')[0];
        } else {
          prevEl = $section.find('.navigation-slider-mobile .navigation-slider [data-js="slider-prev-mobile"]')[0];
          nextEl = $section.find('.navigation-slider-mobile .navigation-slider [data-js="slider-next-mobile"]')[0];
        }
        const swiper = new Swiper($slider[0], {
          slidesPerView: 'auto',
          spaceBetween: 16,
          speed: 700,
          grabCursor: true,
          navigation: {
            prevEl,
            nextEl
          },
          pagination: {
            el: paginationEl,
            clickable: true
          },
          breakpoints: {
            767: {
              spaceBetween: 24
            }
          },
          on: {
            init: function () {
              toggleNav(this, prevEl, nextEl);
            },
            resize: function () {
              toggleNav(this, prevEl, nextEl);
            },
            update: function () {
              toggleNav(this, prevEl, nextEl);
            }
          }
        });
        swipers.push(swiper);
      });
    });
  }

  // Initialize
  if ($sliders.length > 0) {
    initSliders();
  }

  // Re-initialize
  $(window).on('resize', function () {
    const newBreakpoint = window.innerWidth >= 1200 ? 'desktop' : 'mobile';
    if (newBreakpoint !== currentBreakpoint) {
      if ($sliders.length > 0) {
        initSliders();
      }
      currentBreakpoint = newBreakpoint;
    }
  });
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="property-benefits"]');
  let swipers = [];
  let isSwiperInitialized = false;
  function toggleNav(swiper, prevEl, nextEl, paginationEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
      if (paginationEl) $(paginationEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
      if (paginationEl) $(paginationEl).show();
    }
  }
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this);
      const $slider = $section.find('[data-slider="slider"]');
      const prevEl = $section.find('[data-js="slider-prev"]')[0] || null;
      const nextEl = $section.find('[data-js="slider-next"]')[0] || null;
      const paginationEl = $section.find('.swiper-pagination')[0] || null;
      const swiper = new Swiper($slider[0], {
        slidesPerView: 'auto',
        spaceBetween: 16,
        speed: 700,
        grabCursor: true,
        a11y: false,
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl
        } : {},
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true
        } : {},
        on: {
          init: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          },
          resize: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          },
          update: function () {
            toggleNav(this, prevEl, nextEl, paginationEl);
          }
        }
      });
      swipers.push(swiper);
    });
    isSwiperInitialized = true;
  }
  function destroySliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    isSwiperInitialized = false;
  }
  function checkBreakpoint() {
    if (window.innerWidth < 1200) {
      if (!isSwiperInitialized) {
        initSliders();
      }
    } else {
      if (isSwiperInitialized) {
        destroySliders();
      }
    }
  }

  // Initialize
  checkBreakpoint();

  // Re-initialize
  $(window).on('resize', function () {
    checkBreakpoint();
  });
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="reels-gallery"]');
  let swipers = [];
  let isSwiperInitialized = false;
  function initSliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    $sliders.each(function () {
      const $section = $(this);
      const $slider = $section.find('[data-slider="slider"]');
      const swiper = new Swiper($slider[0], {
        slidesPerView: 'auto',
        spaceBetween: 8,
        speed: 700,
        grabCursor: true,
        freeMode: true,
        breakpoints: {
          767: {
            spaceBetween: 24
          }
        }
      });
      swipers.push(swiper);
    });
    isSwiperInitialized = true;
  }
  function destroySliders() {
    swipers.forEach(swiper => {
      if (swiper && swiper.destroy) swiper.destroy(true, true);
    });
    swipers = [];
    isSwiperInitialized = false;
  }
  function checkBreakpoint() {
    if (window.innerWidth < 1200) {
      if (!isSwiperInitialized) initSliders();
    } else {
      if (isSwiperInitialized) destroySliders();
    }
  }

  // Initialize
  checkBreakpoint();

  // Re-initialize on resize
  $(window).on('resize', checkBreakpoint);
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-js="slider-reviews"]');
  let currentBreakpoint = window.innerWidth >= 1200 ? 'desktop' : 'mobile';
  let swiperDesktop1 = null;
  let swiperDesktop2 = null;
  let swiperMobile = null;
  function cloneSlidesIfNeeded(sliderEl) {
    if (!sliderEl) return;
    const wrapper = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    const slides = wrapper.querySelectorAll('.swiper-slide');
    if (slides.length >= 6) return;
    let i = 0;
    while (wrapper.querySelectorAll('.swiper-slide').length < 6) {
      wrapper.appendChild(slides[i % slides.length].cloneNode(true));
      i++;
    }
  }
  function initSliders($sliders) {
    $sliders.each(function () {
      const $section = $(this);
      const sliderDesktop1 = $section.find('[data-js="slider-desktop-1"]')[0] || null;
      const sliderDesktop2 = $section.find('[data-js="slider-desktop-2"]')[0] || null;
      const sliderMobile = $section.find('[data-js="slider-mobile"]')[0] || null;
      if (swiperDesktop1) {
        swiperDesktop1.destroy(true, true);
        swiperDesktop1 = null;
      }
      if (swiperDesktop2) {
        swiperDesktop2.destroy(true, true);
        swiperDesktop2 = null;
      }
      if (swiperMobile) {
        swiperMobile.destroy(true, true);
        swiperMobile = null;
      }

      // Desktop
      if (window.innerWidth >= 1200) {
        if (sliderDesktop1) {
          cloneSlidesIfNeeded(sliderDesktop1);
          swiperDesktop1 = new Swiper(sliderDesktop1, {
            direction: 'vertical',
            slidesPerView: 3,
            spaceBetween: 16,
            speed: 15000,
            freeMode: true,
            grabCursor: false,
            loop: true,
            allowTouchMove: false,
            simulateTouch: false,
            autoplay: {
              delay: 0,
              disableOnInteraction: false
            }
          });
        }
        if (sliderDesktop2) {
          cloneSlidesIfNeeded(sliderDesktop2);
          swiperDesktop2 = new Swiper(sliderDesktop2, {
            direction: 'vertical',
            slidesPerView: 3,
            spaceBetween: 16,
            speed: 15000,
            freeMode: true,
            grabCursor: false,
            loop: true,
            allowTouchMove: false,
            simulateTouch: false,
            autoplay: {
              delay: 0,
              disableOnInteraction: false,
              reverseDirection: true
            }
          });
        }
      }

      // Mobile
      if (window.innerWidth < 1200 && sliderMobile) {
        const paginationEl = $(sliderMobile).find('.swiper-pagination')[0];
        swiperMobile = new Swiper(sliderMobile, {
          slidesPerView: 'auto',
          spaceBetween: 16,
          speed: 700,
          grabCursor: true,
          loop: true,
          pagination: {
            el: paginationEl,
            clickable: true,
            dynamicBullets: true,
            dynamicMainBullets: 5
          },
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          },
          breakpoints: {
            767: {
              spaceBetween: 24
            }
          }
        });
      }
    });
  }

  // Initialize
  if ($sliders.length > 0) {
    initSliders($sliders);
  }

  // Re-initialize on breakpoint change
  $(window).on('resize', function () {
    const newBreakpoint = window.innerWidth >= 1200 ? 'desktop' : 'mobile';
    if (newBreakpoint !== currentBreakpoint) {
      if ($sliders.length > 0) {
        initSliders($sliders);
      }
      currentBreakpoint = newBreakpoint;
    }
  });

  // Toggle quote expand/collapse in mobile slider
  $(document).on('click', '[data-js="review-toggle"]', function (e) {
    e.preventDefault();
    const $btn = $(this);
    const $quoteWrapper = $btn.closest('.quote-wrapper');
    const $quote = $quoteWrapper.find('[data-js="review-quote"]');
    const fullText = $quote.attr('data-full-text');
    const isExpanded = $btn.attr('aria-expanded') === 'true';
    const charLimit = parseInt($quote.attr('data-char-limit'));
    const openLabel = $btn.attr('data-open-label');
    const closeLabel = $btn.attr('data-close-label');
    if (isExpanded) {
      $quote.html(fullText.substring(0, charLimit) + '...');
      $btn.attr('aria-expanded', 'false');
      $btn.find('.btn-text').text(openLabel);
    } else {
      $quote.html(fullText);
      $btn.attr('aria-expanded', 'true');
      $btn.find('.btn-text').text(closeLabel);
    }
  });
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="testimonials"]');
  function toggleNav(swiper, prevEl, nextEl) {
    const hide = swiper.isLocked || swiper.slides.length <= 1;
    $(prevEl).toggle(!hide);
    $(nextEl).toggle(!hide);
  }
  if ($sliders.length > 0) {
    $sliders.each(function () {
      const $slider = $(this);
      const prevEl = $slider.find('[data-js="slider-prev"]')[0];
      const nextEl = $slider.find('[data-js="slider-next"]')[0];
      const paginationEl = $slider.find('.swiper-pagination')[0];
      const slidesCount = $slider.find('.swiper-slide').length;
      const swiper = new Swiper($slider.find('.swiper')[0], {
        slidesPerView: 'auto',
        spaceBetween: 0,
        speed: 700,
        centeredSlides: true,
        navigation: prevEl && nextEl ? {
          prevEl,
          nextEl
        } : {},
        pagination: paginationEl ? {
          el: paginationEl,
          clickable: true
        } : {},
        autoplay: slidesCount > 1 ? {
          delay: 7000,
          disableOnInteraction: false
        } : false,
        on: {
          init: function () {
            toggleNav(this, prevEl, nextEl);
          }
        }
      });
    });
  }
});
jQuery(document).ready(function ($) {
  const $sliders = $('[data-slider="video-slider"]');
  let swipers = [];
  function toggleNav(swiper, prevEl, nextEl) {
    if (swiper.isLocked) {
      if (prevEl) $(prevEl).hide();
      if (nextEl) $(nextEl).hide();
    } else {
      if (prevEl) $(prevEl).show();
      if (nextEl) $(nextEl).show();
    }
  }
  $sliders.each(function () {
    const $section = $(this);
    const $slider = $section.find('[data-js="slider"]');
    const paginationEl = $section.find('.swiper-pagination')[0];
    const $fractionEl = $section.find('.pagination-fraction');
    const prevEl = $section.find('[data-js="slider-prev"]')[0] || null;
    const nextEl = $section.find('[data-js="slider-next"]')[0] || null;
    const slidesCount = $slider.find('.swiper-slide').length;
    function updateFraction(swiperInstance) {
      if ($fractionEl.length) {
        $fractionEl.find('.current').text(swiperInstance.realIndex + 1);
      }
    }
    const swiper = new Swiper($slider[0], {
      slidesPerView: 1,
      effect: 'fade',
      speed: 700,
      a11y: false,
      navigation: prevEl && nextEl ? {
        prevEl,
        nextEl
      } : {},
      pagination: paginationEl ? {
        el: paginationEl,
        type: 'bullets',
        clickable: true
      } : {},
      on: {
        init: function () {
          updateFraction(this);
          toggleNav(this, prevEl, nextEl);
        },
        slideChange: function () {
          updateFraction(this);
        },
        update: function () {
          toggleNav(this, prevEl, nextEl);
        },
        resize: function () {
          toggleNav(this, prevEl, nextEl);
        }
      }
    });
    swipers.push(swiper);
  });
});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-js="video"]').forEach(function (section) {
    section.querySelectorAll('[data-js="video-wrapper"]').forEach(function (wrapper) {
      var poster = wrapper.querySelector('[data-js="video-poster"]');
      var video = wrapper.querySelector('video[data-src]');
      if (video) {
        let observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if (video.dataset.src && !video.src) {
                video.src = video.dataset.src;
              }
              if (poster) {
                poster.classList.add('is-inactive');
              }
              video.classList.add('is-active');
              video.play();
              observer.unobserve(wrapper);
            }
          });
        }, {
          threshold: 0.5
        });
        observer.observe(wrapper);
      }
    });
  });
});
//# sourceMappingURL=app.js.map
